export default {
    "bcase": {
        "header": {
            "tooltip": {
                "save": "Speichern",
                "edit_enable": "Bearbeiten aktivieren",
                "edit_disable": "Bearbeiten deaktivieren",
                "maximize": "Maximieren",
                "minimize": "Minimieren",
                "attachments": "Anhänge"
            }
        }
    },
    "oauth2_consent": {
        "title": "Darf {application} auf Liftbase zugreifen?",
        "intro": "Prüfen Sie vor dem Fortfahren, auf welche Daten diese Anwendung zugreifen darf.",
        "application": "Anwendung",
        "client_id": "Anwendungs-ID",
        "callback": "Rücksprungziel",
        "identity_notice": "Der Anwendungsname kommt von der App. Prüfen Sie vor der Freigabe das Rücksprungziel.",
        "permissions": "Berechtigung",
        "duration": "Zugriffsdauer",
        "token_lifetime": "Token-Gültigkeit",
        "token_lifetime_value": "{accessMinutes} Minuten",
        "renewal": "Erneuerung ohne Nachfrage",
        "renewal_value": "bis zu {authorizationDays} Tage",
        "readonly": "Nur Lesen",
        "notice": "Der Zugriff bleibt auf Ihre bestehenden Liftbase-Berechtigungen beschränkt und gilt nur für diese Anwendung.",
        "allow": "Zugriff erlauben",
        "deny": "Ablehnen",
        "submit_error": "Die Freigabe konnte nicht gestartet werden. Bitte erneut versuchen.",
        "submit_error_invalid_request": "Diese Freigabeanfrage ist abgelaufen oder ungültig. Starten Sie die Verbindung in der Anwendung erneut.",
        "submit_error_invalid_redirect": "Das Rücksprungziel der Anwendung ist ungültig. Starten Sie die Verbindung erneut.",
        "error_title": "Die Autorisierungsanfrage ist ungültig",
        "error_description": "Kehren Sie zur Anwendung zurück und starten Sie die Verbindung erneut.",
        "unverified_title": "Nicht verifizierte Anwendung",
        "unverified_warning": "Diese Anwendung wurde nicht von Liftbase als vertrauenswürdiger Drittanbieter verifiziert. Der angezeigte Name kann von einem anderen Anbieter stammen. Prüfen Sie das Rücksprungziel besonders sorgfältig, bevor Sie Zugriff erlauben.",
        "scope": {
            "mcp": {
                "title": "Erlaubte Liftbase-Daten lesen",
                "description": "Bestellungen, Rechnungen, Verträge, Workflows, Kontoauszüge und Liquiditätsplanung — nur Lesen, kein Schreibzugriff."
            }
        }
    },
    "administration": "Administration",
    "master_data": "Stammdaten",
    "admin_page": {
        "no_permission": "Sie haben keine Berechtigung für den Administrationsbereich.",
        "confirm_before_delete_msg": "Möchten Sie diesen Eintrag wirklich entfernen? (ID #{id})",
        "confirm_before_delete_from_db_msg": "Möchten Sie diesen Eintrag wirklich löschen? (ID #{id})",
        "confirm_before_delete_from_db_title": "Endgültig Löschen",
        "confirm_before_delete_from_db_btn": "Löschen",
        "block_user_msg": "Möchten Sie {name} wirklich sperren? Die Person kann sich dann nicht mehr anmelden.",
        "block_user_title": "Anmeldesperre",
        "block_user_btn": "Sperren",
        "unblock_user_msg": "Möchten Sie {name} wirklich entsperren? Die Person kann sich dann wieder anmelden.",
        "unblock_user_title": "Anmeldung entsperren",
        "unblock_user_btn": "Entsperren",
        "tour": {
            "menu_title": "Bereiche",
            "menu": "Hier sehen Sie die verschiedenen Bereiche der Administration, in denen Sie Stammdaten hinterlegen und bearbeiten sowie Konfigurationen vornehmen können.",
            "client_menu_title": "Unternehmen verwalten",
            "client_menu": "Hier können Sie Ihre Unternehmen hinzufügen, einsehen oder bearbeiten.",
            "client_list": "Hier sehen Sie die Liste aller Unternehmen.",
            "new_client": "Klicken Sie hier, um ein Unternehmen anzulegen.",
            "view_mode": "<p>Hier können Sie von der Listen- zur Tabellenansicht wechseln, um mehrere Stammdateneinträge auf einmal zu hinterlegen oder einen besseren Überblick zu haben.</p> Die Tabellenansicht ist z.B. auch für einen Datenex- oder -import nützlich. Vergessen Sie nicht, die Tabelle nach Bearbeitung abzuspeichern."
        }
    },
    "version": "Version",
    "yes": "Ja",
    "no": "Nein",
    "recommended": "Empfohlen",
    "never": "Nie",
    "add": "Hinzufügen",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "apply": "Übernehmen",
    "edit": "Bearbeiten",
    "delete": "Entfernen",
    "next": "Weiter",
    "back": "Zurück",
    "finish": "Beenden",
    "ok": "Ok",
    "open": "öffnen",
    "dashboard": "Dashboard",
    "dashboards": "Dashboards",
    "einvoice_dashboard": "E‑Rechnung Dashboard",
    "invoice_dashboard": "Eingangsrechnungsdashboard",
    "outgoing_invoice_dashboard": "Ausgangsrechnungsdashboard",
    "overview": "Übersicht",
    "operator": "Operator",
    "profile": "Profil",
    "help": "Hilfe",
    "logout": "Logout",
    "tenant_switcher": {
        "error": "Der Tenant konnte nicht gewechselt werden.",
        "error_passkey": "Der Tenant-Wechsel ist bei Passkey-Sitzungen nicht verfuegbar.",
        "error_saml": "Dieser Tenant kann aus der aktuellen SSO-Sitzung nicht geöffnet werden."
    },
    "list_view": "Listenansicht",
    "table_view": "Tabellenansicht",
    "archive": "Archiv",
    "active": "Aktiv",
    "email": "E-Mail",
    "name": "Name",
    "tax": "Steuer (%)",
    "value": "Betrag",
    "number": "Nummer",
    "currency": "Währung",
    "actions": "Aktionen",
    "system": "System",
    "from": "Von",
    "of": "Von",
    "until": "bis",
    "up_to": "bis",
    "show_more": "Weitere anzeigen",
    "refresh": "Aktualisieren",
    "calculate": "Berechnen",
    "calc_brutto_from_net": "Brutto aus Netto berechnen",
    "calc_net_from_brutto": "Netto aus Brutto berechnen",
    "cost_center_id": "Kostenstelle",
    "cost_centers": "Kostenstellen",
    "budget_id": "Budget",
    "budgets": "Budgets",
    "branch_id": "Niederlassung",
    "branches": "Niederlassungen",
    "employee_id": "Mitarbeitende",
    "employees": "Mitarbeitende",
    "vehicles": "Kraftfahrzeuge",
    "financial_dimension_id": "Finanzdimension",
    "financial_dimensions": "Finanzdimensionen",
    "tax_group_id": "Steuergruppe",
    "tax_groups": "Steuergruppen",
    "tax_item_group_id": "Steuer-Artikelgruppe",
    "tax_item_groups": "Steuer-Artikelgruppen",
    "profit_center_id": "Profitcenter",
    "profit_centers": "Profitcenter",
    "client_id": "Unternehmen",
    "clients": "Unternehmen",
    "ai_prompts": "Prompts",
    "ai_prompt": {
        "description": "Prompt",
        "title": "Titel",
        "slug": "Slug",
        "category": "Kategorie",
        "active": "Aktiv",
        "is_published": "Veröffentlicht",
        "changelog": "Changelog",
        "system_prompt": "System Prompt",
        "developer_prompt": "Developer Prompt",
        "user_prompt_tpl": "User Prompt Template",
        "output_format": "Ausgabeformat",
        "output_schema": "Ausgabeschema",
        "preview": "Vorschau",
        "context_json": "Kontext-JSON",
        "output_json": "Ausgabe (JSON)",
        "highlighted_preview": "Hervorgehobene Vorschau",
        "apply_placeholders": "Platzhalter anwenden",
        "available_objects": "Verfügbare Objekte",
        "search_objects": "Objekte und Felder suchen",
        "suggestions": "Vorschläge",
        "fields": "Felder",
        "relations": "Beziehungen",
        "execute": "Ausführen",
        "execute_prompt": "Prompt ausführen",
        "simulated_result_message": "Dies ist ein simuliertes Ergebnis der Prompt-Ausführung.",
        "test_data_selection": "Testdaten-Auswahl",
        "click_to_see_result": "Klicken Sie auf \"{action}\", um das Ergebnis zu sehen.",
        "tab_general": "Allgemein",
        "tab_content": "Inhalt",
        "tab_test": "Testen",
        "page": {
            "new": "Neuer Prompt",
            "validation": {
                "title_required": "Bitte geben Sie einen Titel ein.",
                "slug_required": "Bitte geben Sie einen Slug ein."
            }
        }
    },
    "department_id": "Abteilung",
    "departments": "Abteilungen",
    "d365_branch_id": "Niederlassung",
    "d365_employee_id": "Mitarbeitende",
    "d365_department_id": "D365 Abteilung",
    "d365_area_id": "D365 Bereich",
    "d365_labor_wert_id": "D365 Laborwert",
    "d365_project_id": "D365 Projekt",
    "d365_sales_channel_id": "D365 Vertriebskanal",
    "d365_vehicle_id": "Fahrzeug",
    "d365_branches": "Niederlassungen",
    "d365_employees": "Mitarbeitende",
    "d365_departments": "D365 Abteilungen",
    "location_id": "Standort",
    "consignee_id": "Wareneingang",
    "address_id": "Lieferanschrift",
    "cost_type_id": "Kostenart",
    "incoming_revenue_type": "Einnahmetyp",
    "incoming_revenue_type_id": "Einnahmetyp",
    "lb_user_id": "Person",
    "users": "Personen",
    "task_group_id": "Aufgabengruppe",
    "task_groups": "Aufgabengruppen",
    "user_task_group": "Person/Aufgabengruppe",
    "user_task_groups": "Personen/Aufgabengruppen",
    "products": "Produktkatalog",
    "product": "Produkt",
    "additional_information": "Weitere Informationen",
    "product_group_id": "Warengruppe",
    "product_groups": "Warengruppen",
    "supplier_id": "Lieferunternehmen",
    "business_partner_id": "Geschäftspartner",
    "suppliers": "Lieferunternehmen",
    "business_partners": "Geschäftspartner",
    "procurement_id": "Bestellanforderung",
    "procurements": "Bestellanforderungen",
    "contract_id": "Vertrag",
    "contracts": "Verträge",
    "user_select_product_id": "Person „Produktauswahl“",
    "user_send_order_id": "Person „Beauftragung“",
    "user_clearing_id": "Person „Klärung Einkauf“",
    "user_consignee_id": "Person „Wareneingang“",
    "user_invoice_manual_check_id": "Person „Manuelle Prüfung (Rechnung)“",
    "user_invoice_clearing_id": "Person „Klärung Buchhaltung“",
    "user_accounting_id": "Person „Buchhaltung“",
    "user_contract_clearing_id": "Person „Klärung Vertrag“",
    "ledger_account_id": "Sachkonto",
    "ledger_accounts": "Sachkonten",
    "posting_key_id": "Steuerschlüssel",
    "posting_keys": "Steuerschlüssel",
    "permission_id": "Berechtigungsgruppe",
    "permissions": "Berechtigungsgruppen",
    "invoices": "Rechnungen",
    "invoice_id": "Rechnung",
    "outgoing_invoice_id": "Ausgangsrechnung",
    "outgoing_invoices": "Ausgangsrechnungen",
    "marketplace_id": "Marktplatz",
    "provider_id": "Marktplatz Anbieter",
    "configurations": "Konfigurationen",
    "notes": "Notiz",
    "search": "Suchen",
    "no_data": "Keine Einträge gefunden",
    "months": "Monate",
    "select_valid_option": "Wählen Sie einen gültigen Eintrag aus.",
    "price_restricted": "Informationen zu Preisen sind derzeit deaktiviert.",
    "procurement_line": {
        "description": "Produkt",
        "item_number": "Artikelnummer",
        "is_cost_center_fixed": "Kostenstelle für diesen Artikel sperren",
        "image_url": "Bild-URL",
        "webshop_url": "Shop-URL",
        "offer_number": "Angebotsnummer",
        "offer_date": "Angebotsdatum",
        "include_tax": "inkl. {tax} USt",
        "offer_msg": "Nach dem Angebot {offer_number}",
        "offer_date_msg": "vom {offer_date}",
        "delivery_completed": "Position abgeschlossen",
        "total_price_brutto": "Gesamt-Brutto",
        "total_price_netto": "Gesamt-Netto",
        "type_total_price_brutto": "currency",
        "type_price_brutto": "currency",
        "type_total_price_netto": "currency",
        "type_price_netto": "currency"
    },
    "product_catalog": {
        "description": "Artikel",
        "alias": "Beschreibung für Suche",
        "add_product_btn": "Produkt hinzufügen",
        "item_number": "Artikelnummer",
        "is_cost_center_fixed": "Kostenstelle für diesen Artikel sperren",
        "image_url": "Bild-URL",
        "webshop_url": "Shop-URL",
        "offer_number": "Angebotsnummer",
        "offer_date": "Angebotsdatum",
        "type_price_netto": "currency",
        "type_price_brutto": "currency",
        "form_sequence": "name,item_number,product_group_id,supplier_id,location_id,cost_center_id,is_cost_center_fixed,tax,price_netto,price_brutto,unit,image_url,webshop_url,offer_number,offer_date",
        "page": {
            "new": "Neues Produkt",
            "supplier_tooltip": "Wählen Sie ein Lieferunternehmen aus Ihren Stammdaten aus oder fügen Sie ein neues hinzu, indem Sie einen neuen Namen eintippen.",
            "supplier_new_tooltip": "Dieses Lieferunternehmen wird beim Hinzufügen des Produktes in Ihren Stammdaten gespeichert.",
            "should_save": "Im Produktkatalog speichern",
            "error_adding_product": "Beim Hinzufügen des Produktes ist ein Fehler aufgetreten.",
            "sections": {
                "basic": "Grunddaten",
                "supplier": "Klassifizierung und Lieferant",
                "pricing": "Preise und Steuer",
                "accounting": "Kontierung",
                "media_offer": "Medien und Angebot",
                "permissions": "Berechtigungen"
            },
            "validation": {
                "name_required": "Bitte geben Sie einen Namen ein.",
                "supplier_required": "Bitte wählen Sie ein Lieferunternehmen aus oder geben Sie ein neues an.",
                "image_url_invalid": "Bitte geben Sie einen gültigen URL ein.",
                "webshop_url_invalid": "Bitte geben Sie einen gültigen URL ein.",
                "tax_invalid": "Bitte geben Sie eine gültige Steuer aus."
            },
            "tour": {
                "name": "Geben Sie einen aussagekräftigen Namen für das Produkt an.",
                "number": "Hier können Sie die Artikelnummer des Produkts erfassen.",
                "product_group": "Wählen Sie aus, zu welcher Warengruppe das Produkt gehört.",
                "supplier": "Wählen Sie aus, von welchem Lieferunternehmen das Produkt angeboten wird, bzw. bei welchem es bestellt werden soll.",
                "price": "Geben Sie einen Steuersatz sowie einen Netto- oder Brutto-Preis an. Der andere Preis wird dann mit dem Steuersatz berechnet.",
                "unit": "Geben Sie an, in welcher Einheit das Produkt bemessen wird, z.B. \"Stück\", \"kg\" oder \"Liter\".",
                "url": "Hier können Sie dem Produkt eine Bild-URL hinzufügen. Außerdem können Sie, falls vorhanden, einen Link zu der Artikelseite des Shops hinzufügen.",
                "offer": "Liegt zu dem Produkt ein Angebot vor, können hier Nummer und Datum des Angebots erfasst werden, damit diese auf der Bestell-PDF abgebildet werden.",
                "btn_save": "Speichern Sie das Produkt im Produktkatalog, wenn Sie alle Informationen hinzugefügt haben."
            }
        }
    },
    "product_group": {
        "form_sequence": "name,description,user_select_product_id",
        "page": {
            "new": "Neue Warengruppe",
            "no_product_group": "Ohne Warengruppe",
            "validation": {
                "name_required": "Bitte geben Sie einen Namen ein."
            },
            "tour": {
                "name": "Geben Sie einen aussagekräftigen Namen für die Warengruppe an.",
                "btn_save": "Haben Sie alle Informationen angegeben, fügen Sie die Warengruppe hinzu."
            }
        }
    },
    "procurement": {
        "description": "Bestellanforderung",
        "order_description": "Bestellung",
        "name": "Bezeichnung",
        "number": "Bestellnummer",
        "order_number_formatted": "Bestellnummer",
        "contract_number": "Vertragsnummer",
        "creator_id": "Erstellt von",
        "created_at": "Erstelldatum",
        "delivery_date": "Lieferdatum",
        "delivery_address_id": "Lieferanschrift",
        "billing_address_text": "Rechnungsanschrift",
        "status": "Status",
        "show_notes_pdf": "In Bestell-PDF anzeigen",
        "open_value": "Offener Bestellwert",
        "open_value_recurring": "∞ dKueZ",
        "open_value_exceeds_with_invoice": "Mit dieser Rechnung wird der Bestellwert überschritten.",
        "total_brutto": "Gesamt-Brutto",
        "total_netto": "Gesamt-Netto",
        "total_netto_abbr": "-Netto",
        "payment_in_advance": "Vorkasse",
        "has_invoices": "Rechnung erfasst",
        "invoice_count": "Rechnungen (Menge)",
        "completely_invoiced": "Vollständig abgerechnet",
        "is_fully_allocated": "Vollständig abgerechnet",
        "payment_timing": "Zahlungstyp",
        "usage_type": "Rhythmus",
        "type": "Bestelltyp",
        "type_options": {
            "single_invoice": "eKuez mit Einzelrechnung",
            "recurring_invoice": "dKuez mit Einzelrechnung",
            "recurring_contract": "dKuez mit Dauerrechnung"
        },
        "statuses": {
            "open": "Produktauswahl",
            "approved": "Beauftragung",
            "ordered": "Warten auf Lieferung",
            "declined": "Abgewiesen",
            "completed": "Abgeschlossen",
            "approval": "Freigabe",
            "clearing": "Klärung Einkauf",
            "draft": "Entwurf"
        },
        "page": {
            "ai_fill_menu": "Bestellung mit KI ausfüllen",
            "completely_invoiced_auto_tooltip": "Automatisch vom System markiert, da der mit Rechnungen zugeordnete Betrag gleich oder höher als der Bestellwert ist.",
            "completely_invoiced_final_invoice_tooltip": "Als vollständig abgerechnet markiert durch {invoices}.",
            "completely_invoiced_final_invoice_tooltip_prefix": "Als vollständig abgerechnet markiert durch ",
            "completely_invoiced_final_invoice_tooltip_separator": ", ",
            "completely_invoiced_final_invoice_tooltip_suffix": ".",
            "ai": {
                "title": "Einkaufsassistent",
                "months": "Zeitraum (Monate)",
                "products_limit": "Produkte (Anzahl)",
                "suppliers_limit": "Lieferunternehmen (Anzahl)",
                "contracts_limit": "Verträge (Anzahl)",
                "order_without_template_btn": "Ohne Vorlage bestellen",
                "or_create_based_on_existing_msg": "oder erstellen Sie eine neue Bestellung basierend auf den folgenden bestehenden Bestellungen oder Verträgen:",
                "recent_products": "Ihre zuletzt bestellten Produkte",
                "top_products": "Top-Produkte",
                "top_suppliers": "Top-Lieferunternehmen",
                "orders_count": "{n} Bestellungen",
                "active_contracts": "Aktive Verträge",
                "contract_end_date": "Enddatum",
                "procurements_count": "{n} Bestellungen",
                "loading_text": "KI-Vorschlag wird verarbeitet…",
                "processing_title": "Bestellung wird mit KI erstellt",
                "processing_subtitle": "Das kann 15–20 Sekunden dauern. Bitte diese Seite geöffnet lassen. Es können Kosten gemäß den KI-Einstellungen Ihres Tenants anfallen.",
                "invoices_count": "{n} Rechnungen",
                "msg_success": "Bestelldaten wurden automatisch vorbelegt",
                "msg_not_found": "Keine passende Bestellung gefunden",
                "msg_failed": "KI-Vorschlag fehlgeschlagen",
                "msg_not_possible": "KI-Vorbelegung nicht möglich",
                "magic_order": {
                    "label": "Bestellung anhand der letzten Kaufgewohnheiten erstellen",
                    "tooltip": "Dies kann Kosten für Ihr Unternehmen verursachen."
                }
            },
            "new_from_contract": "Bestellung aus Vertrag",
            "no_delivery_address": "Keine Lieferanschrift",
            "no_budget": "Kein Budget",
            "new": "Neue Bestellanforderung",
            "create_btn": "Bestellanforderung starten",
            "copy_btn_tooltip": "Bestellanforderung kopieren",
            "magic_suggestions_btn_tooltip": "Intelligente Vorschläge anhand dynamischer Kriterien (letzte Einkäufe, Lieferanten, Verträge).",
            "magic_suggestions_no_data": "Für die ausgewählten Kriterien wurden keine KI-Vorschläge gefunden.",
            "magic_suggestions_applied": "KI-Vorschläge übernommen.",
            "magic_suggestions_dialog": {
                "title": "Vorschläge für diese Bestellanforderung",
                "message": "Wählen Sie die Felder aus, die Sie anhand der KI-Vorschläge übernehmen möchten.",
                "info_based_on_last_order": "Dieser Vorschlag wurde von der KI auf Basis Ihrer letzten Bestellung erstellt.",
                "no_data": "Keine Vorschläge für diese Bestellanforderung gefunden."
            },
            "offer_document": {
                "add_from_document": "Aus Angebot PDF hinzufügen",
                "dialog_title": "Positionen aus Angebot übernehmen",
                "loading_text": "Angebot wird erkannt...",
                "upload_info1": "Angebots-PDF hierher ziehen <br>oder <br> <em>Datei auswählen</em>.",
                "upload_info2": "PDF-Dateien bis 30 MB.",
                "preview_message": "Wählen Sie die Positionen aus, die als Artikel übernommen werden sollen.",
                "no_lines": "Keine Angebotspositionen gefunden.",
                "new_upload": "Verwerfen & Neu hochladen",
                "retry": "Erneut versuchen",
                "retry_wait": "oder noch ein paar Sekunden warten",
                "file_invalid": "Bitte nur PDF-Dateien hochladen.",
                "file_too_large": "Bitte nur Dateien bis 30 MB hochladen.",
                "extract_failed": "Das Angebot konnte nicht erkannt werden.",
                "file_save_failed": "Das Angebots-PDF konnte nicht gespeichert werden.",
                "lines_applied": "Angebotspositionen übernommen.",
                "supplier_required": "Bitte wählen Sie ein Lieferunternehmen aus, bevor Sie die Positionen übernehmen.",
                "supplier_recognized": "Erkannt wurde: {supplier_name}.",
                "supplier_missing": "Bitte ein Lieferunternehmen auswählen oder neu anlegen.",
                "create_supplier": "„{supplier_name}“ neu anlegen",
                "create_supplier_confirm_title": "Lieferunternehmen anlegen",
                "create_supplier_confirm_message": "Möchten Sie „{supplier_name}“ als neues Lieferunternehmen anlegen?",
                "create_supplier_confirm_btn": "Anlegen",
                "create_supplier_success": "Lieferunternehmen angelegt.",
                "create_supplier_failed": "Das Lieferunternehmen konnte nicht angelegt werden.",
                "supplier_note_website": "Website",
                "supplier_note_contact": "Kontakt",
                "supplier_note_extra_ibans": "Weitere IBANs"
            },
            "delivery_date_tooltip": "Das Lieferdatum wird auf die Bestell-PDF gedruckt und kann dann an das Lieferunternehmen übermittelt werden.",
            "order_sender": "Beauftragung",
            "product_selector": "Produktauswahl",
            "product_search": "Produkte suchen",
            "before_leave_msg": "Ihre Bestellanforderung wurde nicht gespeichert. Sind Sie sicher, dass Sie die Seite verlassen wollen?",
            "confirm_without_approval_limit_msg": "Keine, der gewählten Personen besitzt die notwendige Freigabegrenze für den Wert dieser Bestellung. Entsprechende Freigaben können später noch hinzugefügt werden. Sind Sie sicher, dass Sie fortfahren wollen?",
            "confirm_without_approval_limit_title": "Freigabegrenze",
            "confirm_product_selection_without_product_msg": "Sie haben kein Produkt ausgewählt. Sind Sie sicher, dass Sie fortfahren wollen?",
            "confirm_product_selection_without_product_title": "Kein Produkt ausgewählt",
            "no_approval_limit_msg": "Ihre Freigabegrenze reicht für diese Bestellung nicht aus. Bitte fügen Sie eine weitere Person zur Freigabe hinzu, welche eine ausreichende Freigabegrenze besitzt.",
            "no_approval_limit_title": "Freigabegrenze",
            "product_group_missing_msg": "Alle Produkte müssen einer Warengruppe zugeordnet sein. Gehen Sie oberhalb der Produktliste auf den Reiter \"Warengruppen\" und ordnen Sie jedem Produkt eine Warengruppe zu.",
            "product_group_missing_title": "Warengruppe zuordnen",
            "product_group_missing_btn": "Verstanden",
            "min_approval_one_person": "1 Person",
            "min_approval_qty": "{qty} verschiedenen Personen",
            "min_approval_error_msg": "Die Freigabe reicht für diese Bestellanforderung nicht aus. Bitte fügen Sie eine weitere Person zur Freigabe hinzu. Diese Bestellanforderung muss von <b>mindestens {min_approval_msg}</b> freigegeben werden.",
            "min_approval_error_title": "Freigabe nicht ausreichend",
            "order_not_completed_msg": "Sie haben nicht alle Bestellungen beauftragt oder bestätigt. Vergewissern Sie sich in der Produktliste, dass Sie alle Produkte bestellt haben und bestätigen Sie diese ggf. um fortzufahren.",
            "order_not_completed_title": "Bestellungen erst beauftragen",
            "order_not_completed_btn": "Verstanden",
            "confirm_delivery_not_completed_msg": "Sie haben nicht alle Wareneingänge bestätigt. Sind Sie sicher, dass Sie die Bestellanforderung abschließen wollen? <br> <i>Diese Aktion kann nicht rückgängig gemacht werden</i>.",
            "confirm_delivery_not_completed_title": "Ausstehende Wareneingänge",
            "confirm_delivery_not_completed_btn": "Abschließen",
            "default_confirm_btn": "Fortfahren",
            "budget_exceeded_msg": "Budget überschritten",
            "approval_limit_exceeded_msg": "Freigabegrenze überschritten",
            "external_order_number_msg": "Geben Sie die externe Bestellnummer ein.",
            "external_order_number_title": "Externe Bestellnummer erfassen",
            "no_edit_permission": "Ihnen fehlt die Berechtigung zu Bearbeitung der Daten. Bitte senden Sie die Bestellanforderung über die Aktionen zur Klärung, um Änderungen an den Daten vorzunehmen.",
            "add_invoice_after_order_message": "Sie können eine Rechnung nach dem Starten der Bestellanforderung erstellen.",
            "no_invoice": "Für diese Bestellanforderung wurden noch keine Rechnungen erfasst.",
            "tabs": {
                "lines": "Artikel",
                "invoices": "Rechnungen"
            },
            "delivery_dialog": {
                "title": "Wareneingang bestätigen",
                "confirm_btn": "Bestätigen",
                "message": "Geben Sie die zuletzt eingegangene Menge an.<br> Es fehlen <b>{missing_qty} von {quantity}</b> {unit}.",
                "qty_exceeded_msg": "Die fehlende Warenmenge darf nicht überschritten werden.",
                "qty_must_be_greater_msg": "Die Warenmenge muss größer als 0 sein.",
                "invalid_format": "Verwenden Sie ein gültiges Zahlenformat."
            },
            "order_sender_dialog": {
                "title": "Vorbelegung von Beauftragung",
                "info": "Die Person im Schritt „Beauftragung“ ergibt sich aus verschiedenen Vorbelegungen von zuständigen Personen je Abteilung, Unternehmen, einer globalen Rollenvorbelegung und der Person, welche die Bestellung erstellt hat. Die Person, die in der Liste zuoberst steht, wird für die Aufgabe vorbelegt."
            },
            "consignee_dialog": {
                "title": "Vorbelegung vom Wareneingang",
                "info": "Die Person im Schritt „Wareneingang“ ergibt sich aus verschiedenen Vorbelegungen von zuständigen Personen je Abteilung, Unternehmen, einer globalen Rollenvorbelegung und der Person, welche die Bestellung erstellt hat. Die Person, die in der Liste zuoberst steht, wird für die Aufgabe vorbelegt."
            },
            "select_product_dialog": {
                "title": "Vorbelegung von Produktauswahl",
                "info": "Die Person im Schritt „Produktauswahl“ ergibt sich aus verschiedenen Vorbelegungen von zuständigen Personen je Abteilung, Unternehmen, einer globalen Rollenvorbelegung und der Person, welche die Bestellung erstellt hat. Die Person, die in der Liste zuoberst steht, wird für die Aufgabe vorbelegt."
            },
            "marketplace_change_dialog": {
                "title": "Bestellung wird storniert",
                "info": "Es wurde ein Wechsel des Unternehmens festgestellt. <br>Es gibt jedoch eine Bestellung im Marketplace {marketplace_name}, die nicht mit dem neuen Unternehmen {client_name} verknüpft ist. <br>Wenn Sie fortfahren, wird diese Bestellung storniert.",
                "btn_confirm": "Bestellung stornieren"
            },
            "dialog_assignment": {
                "department_form": "Abteilung im Formular",
                "department_creator": "Abteilung der bestellenden Person",
                "client_form": "Unternehmen im Formular",
                "client_creator": "Unternehmen der bestellenden Person",
                "no_selection": "noch nicht ausgewählt",
                "no_action": "nicht anwendbar",
                "configuration": "Globale Vorbelegung"
            },
            "draft": {
                "title": "Entwurf",
                "save": "Entwurf speichern",
                "delete": "Entwurf löschen",
                "confirm_before_delete_msg": "Sind Sie sicher, dass Sie diesen Entwurf endgültig löschen wollen?",
                "confirm_before_delete_title": "Entwurf löschen",
                "confirm_before_delete_btn": "Löschen"
            },
            "punchout": {
                "pending_msg": "Ausstehende Punch-out-Produkte ansehen.",
                "error_title": "Fehler beim Punch-out",
                "error_msg": "Es ist ein Fehler aufgetreten. Bitte prüfen Sie die Punch-out-Konfigurationen oder wenden sich an eine Person mit Administratorenrechten.",
                "error_start_url_msg": "Es wurde keine Start-URL bereitgestellt, daher kann Punch-out nicht gestartet werden.",
                "error_invalid_credentials_msg": "Die Zugangsdaten sind ungültig. Bitte überprüfen Sie die Punch-out-Konfiguration oder wenden Sie sich an Ihre Administratorin/Ihren Administrator.",
                "error_invalid_domain_msg": "{provider} hat die Anmeldung für die E-Mail \"{email}\" abgelehnt, weil die Domain \"{domain}\" im {provider}-Konto nicht freigeschaltet ist. Der Punch-out kann daher nicht gestartet werden.",
                "no_config": "Hinterlegen Sie zunächst die Konfiguration, um Punch-out nutzen zu können.",
                "no_config_by_client": "Dieses Lieferunternehmen ist für das aktuell ausgewählte Unternehmen nicht zulässig. <br>Bitte wählen Sie ein kompatibles Unternehmen oder passen Sie die Einstellungen an.",
                "pending_dialog": {
                    "title": "Ausstehende Punch-out-Produkte",
                    "add_products": "Zur Bestellung hinzufügen",
                    "add_all_products": "Alles zur Bestellung hinzufügen",
                    "delete_products": "Produkte entfernen"
                },
                "delete_dialog": {
                    "title": "Produkte von {supplier} #{index} entfernen",
                    "info1": "Möchten sie wirklich alle folgenden Produkte von {supplier} #{index} entfernen?",
                    "info2": "Diese Aktion kann nicht rückgängig gemacht werden.",
                    "delete_btn": "Entfernen"
                },
                "log_dialog": {
                    "title": "{supplier_name} Anfrage",
                    "request": "Anfrage",
                    "response": "Antwort",
                    "no_log": "Es existieren keine Logeinträge für die Anfrage an das Lieferunternehmen.",
                    "url": "Url",
                    "header": "Header",
                    "method": "Method",
                    "body": "Body"
                },
                "loading": "Bitte schließen Sie Ihre Produktauswahl in dem geöffneten Pop-up ab. Sollte sich kein Pop-up öffnen, müssen Sie dieses zunächst erlauben.",
                "can_not_edit": "Punch-out Produkte können nicht geändert werden. Bitte führen Sie Punch-out erneut durch. oder löschen Sie den kompletten Warenkorb.",
                "no_provider_found": "Der gewählte Punch-out Anbieter wird derzeit leider noch nicht unterstützt."
            },
            "download_pdf": {
                "title": "Download PDF",
                "confirm_btn": "Bestätigen",
                "title_confirm_save_changes": "Ungesicherte Daten speichern",
                "text_confirm_save_changes": "Wollen Sie die ungesicherten Daten speichern und für das Bestelldokument übernehmen?",
                "invalid_form": "Bitte füllen Sie alle Pflichtfelder im Formular aus, bevor Sie mit der Aktion fortfahren."
            },
            "lines": {
                "no_line": "Keine Produkte ausgewählt, bitte fügen Sie Produkte hinzu.",
                "add_lines_from_contract": "Alle Artikel aus dem Vertrag hinzufügen",
                "show_all_info": "Erweiterte Ansicht",
                "invoice": {
                    "title": "Rechnung",
                    "created_at": "Erfasst",
                    "date": "Rechnungsdatum",
                    "created_by": "Erstellt von"
                },
                "automatic_order": "Elektronisch absenden",
                "automatic_ordered": "Elektronisch abgesendet",
                "supplier_connect_order": "Per SupplierConnect senden",
                "manual_order_confirmation": "Beauftragung manuell bestätigen",
                "confirm_order": "Beauftragung bestätigen",
                "finish_order": "Beauftragung abschließen",
                "order_finished": "Beauftragung abgeschlossen",
                "confirm_order_tooltip": "Bitte beachten Sie, dass Sie die Bestellung bei dem Lieferunternehmen <b>per E-Mail beauftragen</b> müssen,<br> die Bestellung wird <b>nicht elektronisch übermittelt.</b>",
                "ordered_at": "Übermittelt",
                "ordered_by": "Von",
                "confirm_receipt": "Wareneingang bestätigen",
                "no_cost_center": "Keine Kostenstelle",
                "include_taxes": "inkl. USt",
                "budget": "Budget",
                "no_budget": "Kein Budget",
                "no_product_group": "Keine Warengruppe",
                "no_ledger_account": "Kein Sachkonto",
                "select_product": "Produktauswahl",
                "quantity_to_show": "eingegangen: <b>{quantity_received}/{quantity}</b>",
                "delivery_completed": "Position abgeschlossen",
                "from": "von",
                "item_number": "Art-Nr. #",
                "delete_msg": "Möchten Sie diesen Artikel wirklich entfernen?",
                "delete_title": "Artikel entfernen",
                "delete_btn": "Entfernen",
                "automatic_order_dialog": {
                    "confirm_order": "Bestellung absenden",
                    "confirm_order_btn": "Absenden",
                    "finish_order": "Bestellung abschließen",
                    "finish_order_btn": "Abschließen",
                    "info1": "Möchten Sie diese Bestellung <span style=\"font-weight: bold\">jetzt verbindlich elektronisch </span>an das Lieferunternehmen <span style=\"font-weight: bold\">senden?</span>",
                    "info2": "Diese Aktion kann nicht rückgängig gemacht werden."
                },
                "order_dialog": {
                    "confirm_order": "Beauftragung bestätigen",
                    "confirm_order_btn": "Bestätigen",
                    "finish_order": "Beauftragung abschließen",
                    "finish_order_btn": "Abschließen",
                    "info1": "Haben Sie den Auftrag an das Lieferunternehmen übermittelt? (z. B. per E-Mail oder Fax)",
                    "info2": "Diese Aktion kann nicht rückgängig gemacht werden."
                },
                "more_actions": {
                    "delete_products": "Produkte entfernen",
                    "add_external_id": "Externe Bestellnummer erfassen",
                    "download_pdf": "Bestellung (PDF)",
                    "download_pdf_with_attachments": "Bestellung inkl. PDF-Anhang",
                    "write_email": "Anschreiben",
                    "email_with_pdf": "E-Mail inkl. PDF",
                    "show_cxml": "Punchout CXML anzeigen",
                },
                "file": {
                    "open_btn": "PDF öffnen",
                    "add_btn": "PDF hinzufügen",
                    "upload_info1": "Per Drag-and-drop ablegen <br>oder <br> <em>Datei auswählen</em>.",
                    "upload_info2": "PDF-Dateien bis zu 30MB.",
                    "delete_msg": "Möchten Sie dieses Dokument wirklich entfernen?",
                    "delete_title": "Dokument entfernen",
                    "delete_btn": "Entfernen",
                    "delete_error_msg": "Das Dokument konnte nicht entfernt werden."
                }
            },
            "validation": {
                "delivery_date_format": "Bitte geben Sie ein Lieferdatum ein.",
                "client_id_required": "Bitte wählen Sie ein Unternehmen aus.",
                "department_id_required": "Bitte wählen Sie eine Abteilung aus.",
                "department_id_required_client_missing": "Erst Unternehmen auswählen.",
                "cost_center_id_required": "Bitte wählen Sie eine Kostenstelle aus.",
                "cost_center_id_required_filters_missing": "Erst Unternehmen und Abteilung auswählen.",
                "cost_center_id_required_department_missing": "Erst Abteilung auswählen.",
                "cost_center_id_required_client_missing": "Erst Unternehmen auswählen.",
                "ledger_account_id_required": "Bitte wählen Sie eine Sachkonto aus.",
                "consignee_id_required": "Bitte wählen Sie eine zuständige Person aus.",
                "delivery_address_id_required": "Bitte wählen Sie eine Lieferanschrift aus.",
                "billing_address_text_required": "Die Rechnungsanschrift fehlt in der Konfiguration des Unternehmens.",
                "usage_type_required": "Bitte wählen Sie einen Rhythmus aus.",
                "payment_timing_required": "Bitte wählen Sie einen Zahlungstyp aus."
            },
            "tour": {
                "main": {
                    "description": "In den ersten Feldern geben Sie eine Bezeichnung für die Bestellanforderung an sowie Ihr Unternehmen und die Abteilung für welche die Bestellung getätigt werden soll. Die Abteilung wird nach dem Unternehmen und die Kostenstelle nach der Abteilung gefiltert.",
                    "organization": "Hier geben Sie das Unternehmen, die Abteilung und die Kostenstelle an, für welche die Bestellanforderung aufgegeben werden soll. Die Abteilung wird nach dem Unternehmen und die Kostenstelle nach der Abteilung gefiltert.",
                    "address": "Die Lieferanschrift, welche dem Lieferunternehmen mitgeteilt werden soll. Sie können aus den Anschriften des Unternehmens, der Person im Wareneingang und Ihren Anschriften wählen.",
                    "total": "Hier sehen Sie den Gesamtwert Ihrer Bestellanforderung, welcher sich aus der Summe der ausgewählten Produkte ergibt.",
                    "delivery_date": "Das Lieferdatum kann nach dem Wareneingang zur Dokumentation erfasst werden. Es wird nicht an das Lieferunternehmen gesendet.",
                    "product_selector": "Hier sehen Sie, welche Person im nächsten Schritt für die Produktauswahl zuständig ist. Sie hängt von verschiedenen Vorbelegungen ab, welche Sie detaillierter sehen, wenn Sie auf das Info-Icon klicken.",
                    "order_sender": "Hier sehen Sie, welche Person im vorletzten Schritt für die Beauftragung der Bestellung zuständig ist. Sie hängt von verschiedenen Vorbelegungen ab, welche Sie detaillierter sehen, wenn Sie auf das Info-Icon klicken.",
                    "consignee": "Wählen Sie hier die Person aus, welche die Ware in Empfang nehmen soll. Die gewählte Person bestätigt dann im letzten Schritt der Bestellanforderung den Eingang der bestellten Ware und schließt die Bestellanforderung ab.",
                    "approvers": "Hier sehen Sie, ob für die gewählte Kostenstelle eine Freigabe konfiguriert wurde. Außerdem können Sie weitere Personen zur Freigabe hinzufügen.",
                    "product_search": "Hier können Sie ein Produkt aus dem internen Produktkatalog suchen und der Bestellanforderung hinzufügen.",
                    "punchout": "Hier können Sie Produkte bei integrierten Marktplätzen wie Amazon oder Mercateo auswählen. Die so getätigte Produktauswahl kann nach der Freigabe der Bestellanforderung einfach elektronisch an den Marktplatz übermittelt und somit bestellt werden.",
                    "new_product": "Ist Ihr gewünschtes Produkt noch nicht im Produktkatalog, können Sie es hier der Bestellanforderung hinzufügen.",
                    "save_btn": "Wenn Sie alle Informationen erfasst haben, können Sie die Bestellanforderung starten und zum nächsten Schritt weiterleiten."
                },
                "product": {
                    "pdf": "Wenn Sie hier klicken, können Sie dem Produkt Dokumente hinzufügen.",
                    "remove": "Sie können Produkte auch wieder aus der Auswahl entfernen, indem Sie hier klicken.",
                    "more_actions": "Sie können hier nach Erhalt die externe Bestellnummer erfassen.",
                    "tabs": "Hier können Sie die Ansicht Ihrer Produkte nach Lieferunternehmen, Kostenstellen, Warengruppen oder Sachkonten gruppieren.",
                    "expand_view": "Hier können Sie erweiterte Einstellungen zu den Produkten ein- bzw. ausblenden, um diesen eine Kostenstelle, Lieferanschrift, Warengruppen oder Sachkonten zuzuordnen."
                },
                "new_product": {
                    "name": "Geben Sie einen aussagekräftigen Namen für das Produkt an.",
                    "number": "Sie können außerdem noch eine Artikelnummer für das Produkt erfassen.",
                    "supplier": "Wählen Sie aus, von welchem Lieferunternehmen das Produkt angeboten wird, bzw. bei welchem es bestellt werden soll.",
                    "price": "Geben Sie einen Steuersatz sowie einen Netto- oder Brutto-Preis an. Der andere Preis wird dann mit dem Steuersatz berechnet.",
                    "unit": "Geben Sie an, in welcher Einheit das Produkt bemessen wird, z. B. \"Stück\", \"kg\" oder \"Liter\".",
                    "url": "Hier können Sie dem Produkt eine Bild-URL hinzufügen. Außerdem können Sie, falls vorhanden, einen Link zu der Artikelseite des Shops hinzufügen.",
                    "offer": "Liegt zu dem Produkt ein Angebot vor, können hier Nummer und Datum des Angebots erfasst werden, damit diese auf der Bestell-PDF abgebildet werden.",
                    "should_save": "Hier können Sie wählen, ob das neue Produkt im Produktkatalog gespeichert werden soll. Dadurch kann das spezifische Produkt auch zu weiteren Bestellungen hinzugefügt werden.",
                    "save_btn": "Fügen Sie das Produkt der Bestellanforderung hinzu, wenn Sie alle Informationen erfasst haben."
                },
                "cost_center_view": "Kostenstellen können auch einzelnen Produkten einer Bestellanforderung zugewiesen werden. Die in der Kostenstelle hinterlegten Lieferadressen können dann für das Produkt ausgewählt werden.",
                "product_group_view": "Jedem Produkt kann eine Warengruppe zugewiesen werden. Die für die Warengruppe zuständige Person erhält in der Timeline dann eine Aufgabe, um die Produktauswahl zu bearbeiten oder zu bestätigen.",
                "send_order": {
                    "send_btn": "Im Schritt der Beauftragung können Sie hier die Bestellung elektronisch absenden bzw. die bei dem Lieferunternehmen per Mail getätigte Bestellung bestätigen.",
                    "more_actions": "In den Optionen zu den ausgewählten Lieferunternehmen können Sie eine Bestell-PDF oder eine E-Mail mit oder ohne Bestell-PDF an das Lieferunternehmen generieren. Auf diese Weise können Sie die Bestellung bei dem Unternehmen beauftragen oder z. B. eine Rückfrage per Mail klären."
                },
                "delivery_btn": "Wenn Sie eine Teillieferung oder die gesamte Ware erhalten haben, können Sie dies hier vermerken. Artikel können hier auch als abgeschlossen markiert werden. Der bestätigte Wareneingang wird dann auch in der Timeline vermerkt."
            }
        }
    },
    "quantity": "Menge",
    "price_netto": "Netto-Preis",
    "price_brutto": "Brutto-Preis",
    "unit": "Einheit",
    "default_unit": "Stück",
    "tenant": {
        "tab_general": "Allgemein",
        "description": "Tenant",
        "main_language": "Hauptsprache",
        "show_invoices": "Rechnungen im Menü anzeigen",
        "monthly_document_limit": "Belege pro Monat",
        "base_price": "Grundpreis",
        "price_extra_document": "Preis jeder weiteren Belege",
        "monthly_procurement_limit": "BANF pro Monat im Grundpreis",
        "monthly_invoice_limit": "Rechnung pro Monat im Grundpreis",
        "base_price_procurement": "BANF Grundpreis",
        "base_price_invoice": "Rechnung Grundpreis",
        "price_extra_procurement": "Preis jeder weiteren Bestellung",
        "price_extra_invoice": "Preis jeder weiteren Rechnung",
        "invoice_recognition_unit_price": "Rechnungserkennung Preis jeder Beleg",
        "invoice_recognition_custom_field_unit_price": "Preis je Beleg mit Custom Fields",
        "ai_validation_unit_price": "KI-Validierung inkl. Scoring Preis je Beleg",
        "easybill_id": "Easybill ID",
        "bank_account": "Kontonummer",
        "bank_account_owner": "Kontoinhabende Person",
        "bank_bic": "BIC",
        "bank_country": "Bank Land",
        "bank_code": "Bankleitzahl",
        "bank_iban": "IBAN",
        "bank_name": "Name der Bank",
        "address": "Rechnungsanschrift",
        "sepa_agreement": "SEPA Lastschriftverfahren",
        "sepa_agreement_date": "SEPA - Eingangsdatum des Mandates",
        "sepa_mandate_reference": "Mandatsreferenz",
        "automatic_billing": "Abrechnung automatisch erstellen",
        "automatic_billing_mail": "Abrechnung automatisch per E-Mail senden",
        "bank": "Bankverbindung",
        "datev": "DATEV",
        "billing_address_name": "Firma",
        "billing_address_consignee_name": "Name empfangender Person",
        "billing_address_street": "Straße und Nr.",
        "billing_address_zipcode": "PLZ",
        "billing_address_city": "Stadt",
        "billing_address_state": "Bundesland",
        "billing_address_country": "Land",
        "billing_address_phone": "Telefonnummer",
        "contact_email": "Kontakt-E-Mail",
        "billing_email": "Rechnungs-E-Mail",
        "contact": "Kontaktdaten",
        "sepa": "SEPA Lastschrift",
        "add_sepa": "SEPA Lastschrift hinterlegen",
        "remove_sepa": "SEPA Lastschrift widerrufen",
        "import_invoice_email": "Automatische Rechnungserstellung per E-Mail",
        "send_email_notifications": "E-Mail-Benachrichtigungen versenden",
        "storage_usage": "Speicherplatznutzung",
        "storage_current": "Aktuelle Nutzung",
        "storage_included_gb": "Inklusive Speicherplatz (GB)",
        "storage_price_per_gb": "Preis pro zusätzlichem GB",
        "storage_free_included": "Inklusive Freivolumen",
        "storage_billable": "Abrechenbare GB",
        "storage_billable_price": "Monatliche Zusatzkosten",
        "storage_billing_hint": "Die ersten {included} GB sind kostenfrei. Jeder weitere angefangene GB wird mit {price} berechnet.",
        "tab_mailbox": "Postfächer",
        "debit_credit_reverse": "Konto/Gegenkonto tauschen",
        "default_decimal_places": "Standard Nachkommastellen",
        "tab_sso": "Single Sign-On (SAML)",
        "sso_saml_enabled": "SAML-Login aktivieren",
        "sso_saml_provider_label": "Beschriftung Login-Button",
        "sso_saml_entity_id": "Entity ID des Identity Providers",
        "sso_saml_sso_url": "SSO-URL des Identity Providers",
        "sso_saml_x509_cert": "X509-Zertifikat des Identity Providers (PEM)",
        "sso_saml_sp_entity_id": "Entity ID des Service Providers (optional)",
        "sso_saml_attr_email": "Attributname für E-Mail (optional)",
        "sso_saml_help": "Aktivieren Sie dies erst, wenn die Werte vom Identity Provider vorliegen.",
        "sso_saml_validation_required": "Bitte füllen Sie alle erforderlichen SAML-Felder aus."
    },
    "datev_access": {
        "description": "DATEV Integration",
        "label_log": "DATEV Unternehmen (datev_client_id)",
        "label_log_fields": "datev_client_id",
        "connected_info": "Verbindung mit DATEV wurde hergestellt.",
        "disconnected_info": "Verbindung mit DATEV wurde entfernt.",
        "connected_client_info": "Verbindung mit DATEV-Unternehmen {datev_client_id} wurde hergestellt.",
        "disconnected_client_info": "Verbindung mit DATEV-Unternehmen {datev_client_id} wurde deaktiviert."
    },
    "ms365_access": {
        "description": "D365 Integration",
        "connected_info": "Verbindung mit D365 wurde hergestellt.",
        "disconnected_info": "Verbindung mit D365 wurde entfernt.",
        "data_loaded_info": "Die Daten aus D365 wurden manuell geladen.",
        "journal_created_info": "Der D365 Journal wurde hinzugefügt.<br><b>Journal Name:</b> {journal_name} <br><b>Org URL:</b> {org_url}.",
        "journal_edited_info": "Der D365 Journal Name wurde aktualisiert: {journal_name}.",
    },
    "client": {
        "description": "Unternehmen",
        "alias": "Unternehmensalias",
        "tab_invoice_recognition_prompt": "Custom Prompt",
        "min_approval": "Mindestanzahl Freigebende",
        "branch_required": "Die Niederlassung ist für das Rechnungsformular erforderlich.",
        "department_required": "Die Abteilung ist für das Rechnungsformular erforderlich.",
        "cost_center_required": "Die Kostenstelle ist für das Bestellformular pflicht.",
        "client_number": "Mandantennummer",
        "consultant_number": "Beraternummer",
        "ledger_account_length": "Sachkontenlänge",
        "vat_number": "USt-IdNr.",
        "address_name": "Name",
        "consignee": "Name empfangender Person - Rechnungsanschrift",
        "dropoff_location": "Name des Abgabeorts - Rechnungsanschrift",
        "address": "Straße und Nr. - Rechnungsanschrift",
        "address_complement": "Straße 2 - Rechnungsanschrift",
        "country": "Land - Rechnungsanschrift",
        "zipcode": "PLZ - Rechnungsanschrift",
        "city": "Stadt - Rechnungsanschrift",
        "phone_country_code": "Telefonland - Rechnungsanschrift",
        "phone_number": "Telefonnummer - Rechnungsanschrift",
        "can_delete_document_directly": "Dokumente können ohne Klärung löscht werden.",
        "default_product_tax": "Standard-Steuersatz (%)",
        "default_product_currency": "Standardwährung",
        "default_product_unit": "Standardeinheit",
        "invoice_recognition_prompt": "Custom Prompt für Belegerkennung",
        "form_sequence": "name,email,client_number,currency,min_approval,user_select_product_id,user_send_order_id,user_clearing_id,user_consignee_id,user_invoice_manual_check_id,user_invoice_clearing_id",
        "page": {
            "tab_general": "Allgemein",
            "tab_bank_data": "Bankdaten",
            "tab_billing_address": "Rechnungsanschrift",
            "tab_shipping_address": "Lieferanschriften",
            "tab_default_roles": "Allgemeine Rollenvorbelegungen",
            "tab_communication_signature": "Kommunikationssignatur",
            "tab_permissions": "Berechtigungsgruppen",
            "tab_departments": "Abteilungen",
            "tab_cost_centers": "Kostenstellen",
            "tab_ledger_accounts": "Sachkonten",
            "tab_required_fields": "Pflichtfelder",
            "tab_datev_csv": "DATEV CSV Export",
            "new": "Neues Unternehmen",
            "invoice_recognition_prompt_placeholder": "z. B. diese Anweisungen bei der Belegerkennung für dieses Unternehmen anwenden.",
            "select_logo": "Logo auswählen",
            "select_logo_tooltip_content": "Fügen Sie eine Logo hinzu, welche auf das Beauftragungsdokument Ihrer freigegebenen Bestellungen gedruckt wird. <br/> Nehmen Sie am besten eine Bilddatei mit Hintergrund-Transparenz.",
            "communication_signature_html": "Supplier-Communication-Signatur",
            "communication_signature_html_hint": "Diese HTML-Signatur wird in der externen Lieferantenkommunikation eines Dokuments automatisch vorausgefüllt. HTML-Formatierung wird unterstützt.",
            "communication_signature_editor_visual": "Visuell",
            "communication_signature_editor_html": "HTML",
            "communication_signature_editor_visual_disabled_hint": "Der visuelle Editor ist für diesen HTML-Quellcode deaktiviert, damit seine Formatierung erhalten bleibt.",
            "communication_signature_placeholders": "Platzhalter",
            "communication_signature_placeholders_hint": "Klicken Sie auf einen Platzhalter, um ihn an der aktuellen Cursorposition im HTML-Editor einzufügen.",
            "communication_signature_placeholder_first_name": "Mitarbeiter Vorname",
            "communication_signature_placeholder_last_name": "Mitarbeiter Nachname",
            "communication_signature_placeholder_name": "Mitarbeiter Name",
            "communication_signature_placeholder_email": "Mitarbeiter E-Mail",
            "communication_signature_placeholder_company_name": "Unternehmen Name",
            "communication_signature_placeholder_company_email": "Unternehmen E-Mail",
            "communication_signature_preview": "Signaturvorschau",
            "communication_signature_preview_hint": "Verwendet Beispieldaten für Mitarbeiter und aktuelle Unternehmensdaten, falls gepflegt.",
            "communication_signature_preview_empty": "Fügen Sie oben eine Signatur hinzu, um hier die Vorschau zu sehen.",
            "select_letterhead": "Briefpapier auswählen",
            "select_letterhead_tooltip_content": "Fügen Sie ein Briefpapier hinzu, welche auf das Beauftragungsdokument Ihrer freigegebenen Bestellungen gedruckt wird.",
            "billing_address": "Rechnungsanschrift",
            "state_placeholder": "Bundesland/Region auswählen",
            "state_tooltip_content": "Für die Berechnung von Feiertagen.",
            "roles": "Allgemeine Rollenvorbelegungen",
            "user_clearing_id_tooltip_content": "Für die Klärung in Bestellabläufen.",
            "user_invoice_clearing_id_tooltip_content": "Für die Klärung während der Rechnungsablage.",
            "bank_accounts_title": "Bankkonten",
            "bank_accounts_hint": "Hier können Sie mehrere Unternehmenskonten pflegen. IBAN und BIC werden bei Eingabe validiert.",
            "bank_accounts_empty": "Es wurden noch keine zusätzlichen Bankkonten hinzugefügt.",
            "add_bank_account": "Bankkonto hinzufügen",
            "bank_account_label": "Bezeichnung",
            "bank_account_holder": "Kontoinhaber",
            "bank_account_bank_name": "Name der Bank",
            "bank_account_iban": "IBAN",
            "bank_account_bic": "BIC",
            "no_selection": "Keinem bestimmten Unternehmen zugeordnet, daher zu allen Unternehmen zugehörig.",
            "validation": {
                "name_required": "Bitte geben Sie einen Namen ein.",
                "name_max_length": "Darf höchstens 50 Zeichen enthalten.",
                "email_invalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
                "iban_invalid": "Bitte geben Sie eine gültige IBAN-Nummer ein.",
                "bic_invalid": "Bitte geben Sie einen gültigen BIC ein.",
                "bank_account_iban_required": "Bitte geben Sie eine IBAN für dieses Bankkonto ein.",
                "bank_account_iban_duplicate": "Diese IBAN wurde bereits hinzugefügt.",
                "bank_accounts_invalid": "Bitte prüfen Sie den Bereich Bankkonten.",
                "client_number_invalid": "Bitte geben Sie eine gültige Nummer an.",
                "min_approval_invalid": "Bitte geben Sie eine gültige Nummer an.",
                "address_incomplete": "Bitte vervollständigen Sie die Pflichtdaten  der Anschrift.",
                "delivery_address_missing": "Fügen Sie zumindest eine Lieferanschrift hinzu.",
                "error_address_incomplete": "Bitte vervollständigen Sie die Pflichtdaten aller Lieferanschriften."
            },
            "tour": {
                "name": "Geben Sie zunächst den Namen Ihres Unternehmens an.",
                "email": "Geben Sie die E-Mail Ihres Unternehmens an, an die z.B. die Rechnungszustellung gesendet werden soll.",
                "timeline_assignment": "Sie können für das Unternehmen optional zuständige Personen für die verschiedenen Schritte der Bestellanforderungen vorbelegen. Zum Beispiel, wenn es immer eine Person gibt, welche die Bestellung beauftragen soll.",
                "billing_address": "Die Rechnungsanschrift wird für die Bestellung benötigt und ggf. mit der Bestellung an das Lieferunternehmen gesendet.",
                "shipping_address": "Hier können Sie eine oder mehrere Lieferanschriften erfassen, aus denen in einer Bestellanforderung gewählt werden kann.",
                "btn_save": "Nach dem Sie alle benötigten Informationen erfasst haben, fügen Sie das Unternehmen hinzu."
            }
        }
    },
    "client_form_config": {
        "field": "Feld",
        "form": "Formular",
        "required": "Pflicht",
        "not_available_for_d365": "Die Konfiguration der Pflichtfelder für Rechnungen ist nicht verfügbar, da bei der Integration mit D365 die Validierungsregeln von D365 verwendet werden."
    },
    "department": {
        "description": "Abteilung",
        "code": "Nummer",
        "form_sequence": "name,code,client_id,user_select_product_id,user_send_order_id,user_clearing_id,user_consignee_id",
        "page": {
            "new": "Neue Abteilung",
            "tab_general": "Allgemein",
            "tab_clients": "Unternehmen",
            "tab_cost_centers": "Kostenstellen",
            "tab_approvers": "Freigabe",
            "tab_permissions": "Berechtigungsgruppen",
            "tab_employees": "Personen",
            "tab_assignment": "Rollenvorbelegungen",
            "validation": {
                "name_required": "Bitte geben Sie einen Namen ein.",
                "email_required": "Bitte geben Sie eine gültige E-Mail-Adresse ein."
            },
            "tour": {
                "name": "Geben Sie zunächst den Namen der Abteilung an.",
                "client": "Wenn Sie die Abteilung einem Unternehmen zuordnen, kann die Abteilung beim Anlegen einer Bestellanforderung nur in diesem Unternehmen ausgewählt werden.",
                "timeline_assignment": "Sie können in der Abteilung für die verschiedenen Schritte der Bestellanforderungen zuständige Personen bestimmen. Zum Beispiel, wenn es immer eine Person je Abteilung im Wareneingang gibt.",
                "cost_centers": "Hier können Sie die bereits angelegten Kostenstellen der Abteilung zuordnen. Wenn Sie keine Kostenstellen zuordnen, können bei Bestellanforderungen der Abteilung nur Kostenstellen gewählt werden, die gar keiner Abteilung zugeordnet sind.",
                "employees": "Hier können Sie verschiedene Personen hinzufügen, die dieser Abteilung zuzuordnen sind. Legen die Personen dieser Abteilung eine Bestellanforderungen an, wird die Abteilung vorausgefüllt.",
                "btn_save": "Haben Sie alle Informationen angegeben, fügen Sie die Abteilung hinzu."
            }
        }
    },
    "permission": {
        "description": "Berechtigungsgruppe",
        "name": "Bezeichnung",
        "page": {
            "new": "Neue Berechtigungsgruppe",
            "validation": {
                "name_required": "Bitte geben Sie eine Bezeichnung ein."
            },
            "tour": {
                "name": "Hier können Sie eine Berechtigungsgruppe anlegen. Diese Gruppe können Sie dann verschiedenen Entitäten (Abteilungen, Produkten aus dem Warenkatalog, Warengruppen etc.) zuordnen. Den Personen können Sie ebenfalls eine oder mehrere Berechtigungsgruppen zuweisen. Soll eine Entität keine Berechtigungsbeschränkungen haben, ordnen Sie keine Gruppe zu."
            },
            "no_selection": "Keine Berechtigungsgruppenbeschränkung, daher für alle sichtbar."
        }
    },
    "task_group": {
        "description": "Aufgabengruppe",
        "name": "Bezeichnung",
        "priority_approval_limit": "Freigabe-Priorität",
        "page": {
            "new": "Neue Aufgabengruppe",
            "validation": {
                "name_required": "Bitte geben Sie eine Bezeichnung ein."
            },
            "tour": {
                "name": "Hier können Sie eine Aufgabengruppe erstellen. Sie können dann Aufgaben dieser Gruppe zuweisen."
            },
            "no_selection": "Keine Aufgabengruppe"
        }
    },
    "budget": {
        "name": "Name",
        "description": "Budgets",
        "label_log": "value€ (start - end)",
        "label_log_fields": "value,start,end",
        "value": "Betrag",
        "type_value": "currency",
        "start": "Gültig ab",
        "end": "Gültig bis",
        "add_foreach_ledger_account": "Alle Sachkonten einfügen",
        "component": {
            "validation": {
                "end_date_before_start_date": "Das Enddatum darf nicht vor dem Startdatum liegen.",
                "end_date_required": "Das Enddatum darf hier nicht leer sein.",
                "time_overlap": "Die Budgets dürfen sich zeitlich nicht überschneiden.",
                "field_missing": "Bitte geben Sie alle Informationen ein."
            }
        }
    },
    "address": {
        "description": "Lieferanschrift",
        "description_plural": "Lieferanschriften",
        "address_name": "Name",
        "consignee": "Name empfangender Person",
        "dropoff_location": "Name des Abgabeorts",
        "address": "Straße und Nr.",
        "address_complement": "Straße 2",
        "complement": "Straße 2",
        "country": "Land",
        "zipcode": "PLZ",
        "city": "Stadt",
        "phone_country_code": "Telefonland",
        "phone_number": "Telefonnummer",
        "component": {
            "new": "Neue Lieferanschrift",
            "copy_btn": "Rechnungsanschrift kopieren",
            "required_field": "Bitte vervollständigen Sie die Pflichtdaten der Anschrift.",
            "phone_required": "Bitte geben Sie beide Informationen ein.",
            "no_address": "Keine Lieferanschrift"
        }
    },
    "cost_center": {
        "name": "Bezeichnung",
        "number": "Nummer",
        "free_budget": "Frei",
        "description": "Kostenstelle",
        "label_log": "cost_center_name",
        "budgets": "Budgets",
        "form_sequence": "name,number",
        "page": {
            "new": "Neue Kostenstelle",
            "department_tooltip_content": "Welche Abteilungen dürfen diese Kostenstelle verwenden.",
            "tab_general": "Allgemein",
            "tab_budgets": "Budgets",
            "tab_shipping_address": "Lieferanschriften",
            "tab_approvers": "Freigabe",
            "tab_permissions": "Berechtigungsgruppen",
            "tab_departments": "Abteilungen",
            "tab_clients": "Unternehmen",
            "validation": {
                "name_required": "Bitte geben Sie einen Namen ein.",
                "number_required": "Bitte geben Sie eine Nummer ein.",
                "number_length": "Darf höchstens 36 Zahlen und Buchstaben enthalten und Leerzeichen dürfen nur in der Mitte vorkommen.",
                "number_exists": "Die Nummer existiert bereits."
            },
            "tour": {
                "name_number": "Geben Sie einen Namen und eine eindeutige Nummer für die Kostenstelle an.",
                "budget": "Sie können zu Ihrer Kostenstelle verschiedene Budgets angeben und die Budgets jeweils auch einem Sachkonto zuordnen.",
                "approver": "Definieren Sie hier optional, welche Personen Bestellanforderungen mit dieser Kostenstelle freigeben sollen. Weitere Freigaben können beim Anlegen von Bestellanforderungen hinzugefügt werden.",
                "department": "Hier können Sie definieren, in welchen Abteilungen die Kostenstelle verwendet werden kann. Wenn Sie hier keine Abteilungen hinzufügen, kann die Kostenstelle in allen Abteilungen ausgewählt werden.",
                "btn_save": "Nachdem Sie alle nötigen Informationen angegeben haben, fügen Sie die Kostenstelle der Datenbank hinzu."
            }
        }
    },
    "bank_statement": {
        "abbr": "KS",
        "description": "Kontoauszug hochladen",
        "transactions_menu": "Kontoauszugs-Transaktionen",
        "page": {
            "upload": {
                "title": "Kontoauszug hochladen",
                "info": "Laden Sie einen strukturierten Kontoauszug hoch.",
                "client_hint": "Das ausgewählte Unternehmen wird dem hochgeladenen Kontoauszug und seinen Transaktionen zugewiesen.",
                "client_required": "Bitte wählen Sie vor dem Upload ein Unternehmen aus.",
                "supported_hint": "Unterstützt camt.052/.053/.054 als XML und MT940-Textdateien.",
                "error_invalid": "Unterstützte Formate sind camt.052, camt.053, camt.054 als XML sowie MT940-Textdateien.",
                "abort_upload": "Upload abbrechen",
                "processing_in_background_notice": "Der Kontoauszug wurde gespeichert. {count} Buchungen werden jetzt im Hintergrund verarbeitet.",
                "large_statement_notice": "Der Kontoauszug mit {count} Buchungen wurde hochgeladen. Die automatische Zuordnung wurde bei diesem großen Upload übersprungen, damit der Upload nicht blockiert.",
                "account_identifier_match_notice": "Der hochgeladene Auszug enthält nur die Kontokennung {identifier}, keine gültige IBAN. Es wurde kein neues Unternehmenskonto angelegt. Die Kennung gehört zum bereits hinterlegten IBAN-Konto {iban}.",
                "account_identifier_only_notice": "Der hochgeladene Auszug enthält nur die Kontokennung {identifier}, keine gültige IBAN. Für diesen Upload wurde kein neues Unternehmenskonto angelegt.",
                "update_client_iban": "IBAN als neues Konto anlegen",
                "continue_without_update": "Ohne neues Konto fortfahren",
                "continue_upload": "Upload fortsetzen",
                "statement_account_title": "Konto im hochgeladenen Auszug",
                "statement_account_hint": "Diese IBAN wurde im hochgeladenen Kontoauszug erkannt.",
                "client_accounts_title": "Aktive Unternehmenskonten",
                "client_accounts_count": "{count} aktiv",
                "client_accounts_table_label": "Bezeichnung",
                "client_accounts_table_bank": "Bank",
                "client_accounts_table_account_holder": "Kontoinhaber",
                "client_accounts_table_bic": "BIC",
                "client_accounts_table_iban": "IBAN",
                "client_iban_missing_title": "Unternehmensbankkonto fehlt",
                "client_iban_missing_intro": "Für {clientName} ist noch kein passendes aktives Unternehmenskonto im Stammdatensatz hinterlegt.",
                "client_iban_mismatch_title": "Unternehmensbankkonto abweichend",
                "client_iban_mismatch_intro": "Die IBAN im Kontoauszug weicht von den aktiven Unternehmenskonten im Unternehmensstamm für {clientName} ab.",
                "client_iban_document": "IBAN im Kontoauszug: {iban}",
                "client_iban_masterdata": "Bereits hinterlegtes Unternehmenskonto: {iban}",
                "client_iban_masterdata_empty": "Im Unternehmensstamm ist noch kein aktives Unternehmenskonto hinterlegt.",
                "client_iban_update_question": "Möchten Sie diese IBAN vor dem Upload als neues Unternehmenskonto anlegen?",
                "client_iban_readonly_hint": "Sie können den Upload fortsetzen, aber es wird kein neues Unternehmenskonto angelegt."
            },
            "form": {
                "title": "Kontoauszug",
                "back_to_upload": "Neuen Upload",
                "delete": "Kontoauszug löschen",
                "delete_confirm_title": "Kontoauszug löschen",
                "delete_confirm_message": "Möchten Sie diesen Kontoauszug wirklich löschen? Vorhandene Zuordnungen werden gelöst und bankauszugsbasierte Zahlungsmarkierungen werden zurückgesetzt, sofern sie nur aus diesem Kontoauszug stammen.",
                "delete_success": "Der Kontoauszug wurde gelöscht.",
                "delete_error": "Der Kontoauszug konnte nicht gelöscht werden.",
                "download": "Datei herunterladen",
                "format": "Format",
                "status": "Status",
                "account_iban": "Konto",
                "account_owner": "Kontoinhaber",
                "period": "Zeitraum",
                "matched_entries": "Automatisch zugeordnet",
                "processing_title": "Kontoauszug wird verarbeitet",
                "processing_notice": "Der Upload wurde bereits gespeichert. {inserted} von {count} Buchungen wurden bereits importiert; der Rest wird noch im Hintergrund importiert und abgeglichen. Prüfen Sie den Status mit dem Aktualisieren-Button, sobald Sie nachsehen möchten.",
                "processing_matching_title": "Buchungen importiert, Abgleich laeuft noch",
                "processing_matching_notice": "Alle {count} Buchungen wurden bereits importiert und werden jetzt im Hintergrund abgeglichen. Bisher wurden {matched} Buchungen automatisch zugeordnet. Aktualisieren Sie den Status, wenn Sie den aktuellen Stand sehen moechten.",
                "processing_refresh": "Status aktualisieren",
                "processing_finished_notice": "Die Verarbeitung des Kontoauszugs wurde abgeschlossen.",
                "entries": "Buchungen",
                "entry_index": "Pos.",
                "booking_date": "Buchung",
                "value_date": "Wertstellung",
                "amount": "Betrag",
                "counterparty": "Gegenpartei",
                "reference": "Verwendungszweck",
                "match_status": "Abgleich",
                "matched_invoice": "Zugeordnete Rechnung",
                "status_labels": {
                    "processing": "In Verarbeitung",
                    "processed": "Verarbeitet",
                    "partial": "Teilweise verarbeitet",
                    "failed": "Fehlgeschlagen"
                },
                "match_status_labels": {
                    "unmatched": "Nicht zugeordnet",
                    "matched": "Zugeordnet",
                    "ambiguous": "Mehrdeutig",
                    "ignored": "Ignoriert"
                }
            },
            "list": {
                "identifier": "Kennung",
                "uploaded_at": "Hochgeladen am",
                "empty": "Noch keine hochgeladenen Kontoauszüge."
            },
            "transactions": {
                "title": "Kontoauszugs-Transaktionen",
                "subtitle": "Zentrale Übersicht aller Kontoauszugsbuchungen. Wählen Sie zuerst ein Unternehmen aus.",
                "clear_filters": "Filter zurücksetzen",
                "client_required_notice": "Bitte wählen Sie zuerst ein Unternehmen aus, um Transaktionen anzuzeigen.",
                "empty": "Keine Transaktionen gefunden.",
                "no_permission": "Sie haben keine Berechtigung, diese Ansicht zu öffnen.",
                "active_filters": "Aktive Filter",
                "transaction_date": "Transaktionsdatum",
                "transaction_date_short": "BDat",
                "value_date_short": "Valuta",
                "direction": "Art",
                "incoming": "Einzahlung",
                "outgoing": "Auszahlung",
                "client": "Unternehmen",
                "supplier": "Lieferunternehmen",
                "account_filter": "Konto",
                "statement": "Kontoauszug öffnen",
                "amount_filter": "Betragstyp",
                "transaction_type": "Transaktionstyp",
                "text_search": "Textfilter",
                "text_search_placeholder": "In ausgewählten Spalten suchen",
                "text_search_columns": "Suchspalten",
                "text_search_columns_placeholder": "Spalten auswählen",
                "export": "XLSX exportieren",
                "export_success": "Der XLSX-Export wurde erstellt.",
                "export_error": "Der XLSX-Export konnte nicht erstellt werden.",
                "export_empty": "Für die aktuellen Filter stehen keine Transaktionen zum Export bereit.",
                "export_end_balance": "Endsaldo",
                "export_adjustment_type": "Ausgleichsbuchung",
                "export_adjustment_description": "Ausgleichsbuchung für fehlende Auszugsabdeckung ({from} - {to})",
                "export_gap_description": "Fehlende Auszugsabdeckung ({from} - {to})",
                "transaction_type_labels": {
                    "transfer": "Überweisung",
                    "direct_debit": "SEPA-Lastschrift",
                    "card": "Kartenzahlung",
                    "standing_order": "Dauerauftrag",
                    "fee": "Gebühr",
                    "cash": "Bargeld",
                    "refund": "Rückerstattung"
                },
                "description": "Bezeichnung",
                "coverage_gap_alert_title": "Lücken in der Kontoauszugs-Abdeckung erkannt",
                "coverage_gap_alert_summary": "{days} Tag(e) im gewählten Zeitraum sind durch keinen hochgeladenen Kontoauszug abgedeckt.",
                "coverage_gap_row_label": "Fehlende Abdeckung: {from} - {to} ({days} Tag(e))",
                "coverage_gap_row_context_between": "Lücke zwischen {previous} und {next}.",
                "coverage_gap_row_context_before_first": "Kein früherer Auszug im gewählten Zeitraum. Nächster verfügbarer Auszug: {next}.",
                "coverage_gap_row_context_after_last": "Kein späterer Auszug im gewählten Zeitraum. Letzter verfügbarer Auszug: {previous}.",
                "coverage_gap_row_context_unknown": "Für diese Lücke wurden keine benachbarten Kontoauszüge gefunden.",
                "coverage_gap_closing_balance_difference": "Endsaldo-Differenz A/B: {previous} -> {next} ({difference}).",
                "coverage_gap_closing_balance_difference_unavailable": "Endsaldo-Differenz A/B für einen oder beide Auszüge nicht verfügbar.",
                "manual_match": {
                    "action": "Aktionen",
                    "assignment": "Zuordnung",
                    "details": "Details",
                    "open": "Zuordnen",
                    "edit": "Bearbeiten",
                    "dialog_title": "Zahlung manuell zuordnen",
                    "dialog_title_single": "Transaktion zuordnen",
                    "dialog_title_split": "Zahlung aufteilen",
                    "eyebrow": "Manueller Zahlungsabgleich",
                    "single_option": "Einzeln zuordnen..",
                    "split_option": "Aufteilen",
                    "bulk_actions_select": "Massenaktionen ({count})",
                    "bulk_action": "Kostenart zuordnen ({count})",
                    "bulk_dialog_title": "Kostenart gesammelt zuordnen",
                    "bulk_dialog_text": "Ordnen Sie {count} ausgewählten Transaktionen direkt diese Kostenart zu. Bestehende manuelle Zuordnungen werden dabei ersetzt.",
                    "bulk_save": "Kostenart zuordnen",
                    "incoming_revenue_bulk_action": "Einnahmetyp zuordnen",
                    "revenue_bulk_dialog_title": "Einnahmetyp gesammelt zuordnen",
                    "revenue_bulk_dialog_text": "Ordnen Sie {count} ausgewählten Zahlungseingängen direkt diesen Einnahmetyp zu. Bestehende manuelle Zuordnungen werden dabei ersetzt.",
                    "revenue_bulk_save": "Einnahmetyp zuordnen",
                    "filtered_batch_action": "Gefilterte gesammelt zuordnen ({count})",
                    "filtered_batch_incoming_action": "Gefilterte Einzahlungen zuordnen ({count})",
                    "filtered_batch_outgoing_action": "Gefilterte Auszahlungen zuordnen ({count})",
                    "filtered_batch_empty": "Für die aktuelle Filterung stehen keine Transaktionen zur Sammelzuordnung bereit.",
                    "filtered_batch_direction_warning": "Die gefilterten Ergebnisse enthalten Ein- und Auszahlungen. Bitte grenzen Sie die Filter vor der Sammelzuordnung weiter ein.",
                    "filtered_batch_load_error": "Die gefilterten Transaktionen konnten nicht für die Sammelzuordnung vorbereitet werden.",
                    "permission_required_title": "Fehlende Berechtigung",
                    "permission_required": "Für Änderungen an Kontoauszugs-Transaktionen benötigen Sie die Berechtigungen „Kontoauszugs-Transaktionen sehen“ und „Rechnung nachträglich bearbeiten“.",
                    "permission_tooltip": "Deaktiviert: Die Berechtigung „Rechnung nachträglich bearbeiten“ fehlt.",
                    "transaction_total": "Transaktionsbetrag",
                    "allocated_total": "Zugeordnete Summe",
                    "remaining_difference": "Offene Differenz",
                    "ready_to_save": "Summe stimmt.",
                    "remaining_message": "Noch offen: {amount}",
                    "allocations_title": "Rechnungen und Beträge aufteilen",
                    "allocations_subtitle": "Wählen Sie eine oder mehrere Rechnungen und tragen Sie pro Zeile den Betrag ein, der durch diese Transaktion abgedeckt wird.",
                    "add_invoice": "Rechnung hinzufügen",
                    "outgoing_invoice": "Ausgangsrechnung (Kundenzahlung)",
                    "cost_type": "Kostenart",
                    "cost_type_bulk_action": "Kostenart zuordnen",
                    "invoice_gross": "Rechnungsbrutto",
                    "match_amount": "Zuordnungsbetrag",
                    "use_transaction_total": "Transaktionsbetrag verwenden",
                    "use_invoice_gross": "Brutto übernehmen",
                    "use_remaining": "Rest übernehmen",
                    "clear_matches": "Zuordnung entfernen",
                    "save": "Zuordnung speichern",
                    "alerts": {
                        "invoice_conflict_title": "Rechnung bereits mit anderer Transaktion verknüpft",
                        "invoice_conflict_message": "Mindestens eine ausgewählte Rechnung ist bereits einer anderen Banktransaktion zugeordnet.",
                        "invoice_conflict_hint": "Öffnen Sie zuerst die bestehende Zuordnung und passen Sie dort die Aufteilung an oder entfernen Sie sie, bevor Sie diese Transaktion speichern."
                    }
                }
            }
        }
    },
    "supplier": {
        "address": "Straße + Nr.",
        "alias": "Lieferantenalias",
        "external_id": "DATEV ID",
        "supplier_number": "Nummer",
        "client_number": "Kundennummer",
        "delivery_in_days": "Lieferzeit in Werktagen",
        "delivery_terms": "Lieferbedingungen",
        "payment_terms": "Zahlungsbedingungen",
        "vat_number": "USt-IdNr.",
        "city": "Stadt",
        "iban": "IBAN",
        "bic": "BIC",
        "bank_country": "Bank Land",
        "bank_account": "Kontonummer",
        "bank_code": "Bankleitzahl",
        "bank": "Bank",
        "discount_percentage": "Skonto 1 - Prozent",
        "discount_days": "Skonto 1 - Tage",
        "discount_percentage2": "Skonto 2 - Prozent",
        "discount_days2": "Skonto 2 - Tage",
        "invoice_recognition_prompt": "Custom Prompt für Belegerkennung",
        "form_sequence": "name,email,city,address,external_id,delivery_terms,payment_terms,iban,bic,vat_number",
        "payment_method": "Zahlungsart",
        "payment_method_info": "Rechnungen von Lieferunternehmen mit der Zahlungsart SEPA-Lastschrift oder Kreditkarte werden direkt als bezahlt markiert",
        "page": {
            "new": "Neues Lieferunternehmen",
            "department_tooltip_content": "Welche Abteilungen dürfen dieses Lieferunternehmen verwenden.",
            "delivery_in_days_tooltip_content": "Die Lieferzeit wird für die Aufgaben-E-Mail des Wareneingangs verwendet.",
            "notes_tooltip_content": "Dieser Hinweis wird nur intern auf liftbase angezeigt und nicht auf dem Bestell-PDF ausgedruckt.",
            "external_id_tooltip_content": "Die ID des Lieferunternehmens aus einem von Ihnen angebundenen Drittsystem.",
            "client_number_tooltip_content": "Nummer, die dieses Lieferunternehmen Ihnen zugewiesen hat (optional).",
            "supplier_number_tooltip_content": "Nummer, die Sie diesem Lieferunternehmen zugewiesen haben.",
            "delivery_terms_tooltip_content": "Die mit dem Lieferunternehmen vereinbarten Zahlungs- und Lieferbedingungen werden bei einer Bestellung auf der Bestell-PDF abgebildet.",
            "payment_terms_tooltip_content": "Die mit dem Lieferunternehmen vereinbarten Zahlungs- und Lieferbedingungen werden bei einer Bestellung auf der Bestell-PDF abgebildet.",
            "vat_number_tooltip_content": "Die Umsatzsteuer-ID ist relevant für die Zuordnung einer importierten Rechnung zu dem Lieferunternehmen.",
            "name_tooltip_content": "Für die Zuordnung einer importierten Rechnung, den Namen des Lieferunternehmens genau so angeben, wie auf der Rechnung.",
            "tab_general": "Allgemein",
            "tab_delivery_info": "Lieferungsdaten",
            "tab_payment_info": "Zahlungsdaten",
            "tab_permissions": "Berechtigungsgruppen",
            "tab_departments": "Abteilungen",
            "tab_approvers": "Freigabe",
            "tab_clients": "Unternehmensspezifische IDs",
            "tab_invoice_recognition": "Vorbelegung für Belegerkennung",
            "tab_invoice_recognition_prompt": "Custom Prompt",
            "invoice_recognition_prompt_placeholder": "z.B. als Rechnungsnummer bitte den \"Ticketcode\" verwenden.",
            "default_clients_ids": "Falls ein Unternehmen in dieser Tabelle nicht mit spezifischen IDs aufgeführt ist, <br>werden die folgenden Standard-IDs verwendet: <br>DATEV ID: {external_id} <br>Kundennummer: {client_number}.",
            "no_default_id": "Keine Standard-ID vorhanden.",
            "validation": {
                "name_required": "Bitte geben Sie einen Namen ein.",
                "name_length": "Darf höchstens 50 Zeichen enthalten.",
                "email_invalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
                "supplier_number_invalid": "Bitte geben Sie eine gültige Nummer an.",
                "vat_number_invalid": "Darf Zahlen, Groß- und Kleinbuchstaben, Punkte, Leerzeichen und Unterstriche enthalten. Darf höchstens 15 Zeichen enthalten.",
                "iban_invalid": "Darf mindestens 15, höchstens 34 Zeichen und keine Leerzeichen enthalten. Beginnt mit zwei Großbuchstaben, gefolgt von 2 Zahlen und 11 bis 30 Zahlen/Buchstaben.",
                "bic_invalid": "Darf mindestens 8, höchstens 11 Zeichen und nur Großbuchstaben und Zahlen enthalten. Die ersten sechs Zeichen müssen Buchstaben sein.",
                "external_id_length": "Die DATEV ID darf nur ganze Zahlen enthalten und nicht kleiner als 10000 sein."
            },
            "tour": {
                "name": "Geben Sie den Namen des Lieferunternehmens an.",
                "email": "Die E-mail-Adresse des Lieferunternehmens wird z.B. für die Vorbereitung von E-Mail-Nachrichten zur Beauftragung einer Bestellung verwendet.",
                "address": "Hier können Sie die Anschrift des Lieferunternehmens hinterlegen.",
                "external_id": "Die externe ID ist die Nummer des Unternehmens, wie sie z.B. in externer Software hinterlegt ist. Diese Nummer wird in der API verwendet.",
                "terms": "Erfassen Sie hier die mit dem Lieferunternehmen vereinbarten Zahlungs- und Lieferbedingungen. Diese Informationen werden dann bei einer Bestellung auf der Bestell-PDF abgebildet.",
                "btn_save": "Wenn Sie alle Informationen hinterlegt haben, speichern Sie das Lieferunternehmen hier."
            }
        }
    },
    "business_partner": {
        "address": "Straße + Nr.",
        "business_partner_number": "Nummer",
        "delivery_in_days": "Lieferzeit in Werktagen",
        "delivery_terms": "Lieferbedingungen",
        "payment_terms": "Zahlungsbedingungen",
        "vat_number": "USt-IdNr.",
        "city": "Stadt",
        "iban": "IBAN",
        "bic": "BIC",
        "bank_country": "Bank Land",
        "bank_account": "Kontonummer",
        "bank_code": "Bankleitzahl",
        "bank": "Bank",
        "discount_percentage": "Skonto 1 - Prozent",
        "discount_days": "Skonto 1 - Tage",
        "discount_percentage2": "Skonto 2 - Prozent",
        "discount_days2": "Skonto 2 - Tage",
        "payment_method": "Zahlungsart",
        "payment_method_info": "Belege mit der Zahlungsart SEPA-Lastschrift oder Kreditkarte können direkt als bezahlt markiert werden.",
        "page": {
            "new": "Geschäftspartner hinzufügen",
            "delivery_in_days_tooltip_content": "Die Lieferzeit wird als Stammdateninformation für diesen Geschäftspartner gespeichert.",
            "notes_tooltip_content": "Dieser Hinweis wird nur intern auf liftbase angezeigt.",
            "business_partner_number_tooltip_content": "Nummer, die Sie diesem Geschäftspartner zugewiesen haben.",
            "delivery_terms_tooltip_content": "Hier können Sie die mit dem Geschäftspartner vereinbarten Lieferbedingungen hinterlegen.",
            "payment_terms_tooltip_content": "Hier können Sie die mit dem Geschäftspartner vereinbarten Zahlungsbedingungen hinterlegen.",
            "vat_number_tooltip_content": "Die USt-IdNr. hilft bei der Zuordnung von Belegen zu diesem Geschäftspartner.",
            "name_tooltip_content": "Geben Sie den Namen des Geschäftspartners so an, wie er auf Belegen erscheinen soll.",
            "tab_general": "Allgemein",
            "tab_delivery_info": "Lieferungsdaten",
            "tab_payment_info": "Zahlungsdaten",
            "tab_permissions": "Berechtigungsgruppen",
            "tab_clients": "Unternehmen",
            "import_legacy_suppliers_button": "Lieferanten als Partner importieren",
            "import_legacy_suppliers_title": "Lieferanten als Geschäftspartner importieren?",
            "import_legacy_suppliers_confirm": "Legt für jeden Lieferanten Ihres Mandanten, der noch nicht mit einem Geschäftspartner verknüpft ist, einen Partner an (mit Referenz zum bisherigen Lieferanten), übernimmt Bankverbindungen, Unternehmens- und Berechtigungsverknüpfungen und aktualisiert ausgehende Rechnungen. Bereits importierte Lieferanten werden übersprungen. Sie können diesen Vorgang gefahrlos erneut ausführen.",
            "import_legacy_suppliers_run": "Import starten",
            "import_legacy_suppliers_loading": "Lieferanten werden importiert…",
            "import_legacy_suppliers_success": "Import abgeschlossen. Neue Partner: {inserted}. Übersprungen (bereits verknüpft): {skipped}. Bankverbindungen ergänzt: {bankAccounts}. Ausgehende Rechnungen aktualisiert (Haupt / erkannt): {invoicesBp} / {invoicesRec}. Unternehmensverknüpfungen: {clients}. Berechtigungen: {permissions}.",
            "tab_invoice_recognition": "Vorbelegung für Belegerkennung",
            "validation": {
                "name_required": "Bitte geben Sie einen Namen ein.",
                "name_length": "Darf höchstens 50 Zeichen enthalten.",
                "email_invalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
                "vat_number_invalid": "Darf Zahlen, Groß- und Kleinbuchstaben, Punkte, Leerzeichen und Unterstriche enthalten. Darf höchstens 15 Zeichen enthalten.",
                "iban_invalid": "Darf mindestens 15, höchstens 34 Zeichen und keine Leerzeichen enthalten. Beginnt mit zwei Großbuchstaben, gefolgt von 2 Zahlen und 11 bis 30 Zahlen/Buchstaben.",
                "bic_invalid": "Darf mindestens 8, höchstens 11 Zeichen und nur Großbuchstaben und Zahlen enthalten. Die ersten sechs Zeichen müssen Buchstaben sein."
            },
            "tour": {
                "name": "Geben Sie den Namen des Geschäftspartners an.",
                "email": "Die E-Mail-Adresse des Geschäftspartners kann für Kommunikation und Belegprozesse verwendet werden.",
                "address": "Hier können Sie die Anschrift des Geschäftspartners hinterlegen.",
                "terms": "Erfassen Sie hier die mit dem Geschäftspartner vereinbarten Zahlungs- und Lieferbedingungen.",
                "btn_save": "Wenn Sie alle Informationen hinterlegt haben, speichern Sie den Geschäftspartner hier."
            }
        }
    },
    "user": {
        "name": "Name",
        "client_id": "Hauptunternehmen",
        "approval_limit": "Freigabegrenze",
        "priority_approval_limit": "Freigabe-Priorität",
        "show_tour": "Alle Touren von Liftbase anzeigen",
        "tooltip_edit_master_data_permission": "Mit dieser Berechtigung können durch folgende Features Stammdaten auch außerhalb es Administrations-Bereich verändert werden:<br>" +
            "- Lieferunternehmen direkt beim Anlegen eines Produkts hinzufügen<br>" +
            "- Bankverbindung, Zahlungsart und UStID im Rahmen der Rechnungserfassung ändern/ergänzen",
        "roles": {
            "user-admin": "Administrator",
            "user-price": "Preise sehen",
            "user-dashboard": "Alle Dashboards sehen",
            "user-procurement-dashboard": "Beschaffungs-Dashboard sehen",
            "user-invoice-dashboard": "Eingangsrechnungsdashboard sehen",
            "user-outgoing-invoice-dashboard": "Ausgangsrechnungsdashboard sehen",
            "user-einvoice-dashboard": "E-Rechnungsdashboard sehen",
            "user-change-order": "Bestellung nachträglich bearbeiten",
            "user-see-orders": "Bestellungen sehen:",
            "user-see-all-orders": "Alle Unternehmen",
            "user-see-all-orders-belonging-to-accessible-companies": "Alle Unternehmen mit Zugriff",
            "user-see-all-orders-belonging-to-own-company": "Eigenes  Unternehmen",
            "user-see-all-orders-belonging-to-own-department": "Eigene Abteilung",
            "user-see-orders-from-involved-invoices": "Bestellungen zu beteiligten Rechnungen sehen",
            "user-see-own-orders-and-involved": "Eigene und mit Beteiligung",
            "user-insert-contract": "Vertrag anlegen",
            "user-change-contract": "Vertrag nachträglich bearbeiten",
            "user-see-contracts": "Verträge sehen:",
            "user-see-all-contracts": "Alle Unternehmen",
            "user-see-all-contracts-belonging-to-accessible-companies": "Alle Unternehmen mit Zugriff",
            "user-see-all-contracts-belonging-to-own-company": "Eigenes  Unternehmen",
            "user-see-all-contracts-belonging-to-own-department": "Eigene Abteilung",
            "user-see-own-contracts-and-involved": "Eigene und mit Beteiligung",
            "user-see-all-invoices": "Alle Unternehmen",
            "user-see-all-invoices-belonging-to-accessible-companies": "Alle Unternehmen mit Zugriff",
            "user-see-invoices": "Rechnungen sehen:",
            "user-see-all-invoices-belonging-to-own-company": "Eigenes  Unternehmen",
            "user-see-invoices-from-own-orders": "Rechnungen aus eigenen Bestellungen sehen",
            "user-see-own-invoices-and-involved": "Eigene und mit Beteiligung",
            "user-can-change-invoices": "Rechnung nachträglich bearbeiten",
            "user-see-outgoing-invoices": "Ausgangsrechnungen sehen:",
            "user-see-all-outgoing-invoices": "Alle Unternehmen",
            "user-see-all-outgoing-invoices-belonging-to-accessible-companies": "Alle Unternehmen mit Zugriff",
            "user-see-all-outgoing-invoices-belonging-to-own-company": "Eigenes  Unternehmen",
            "user-see-own-outgoing-invoices-and-involved": "Eigene und mit Beteiligung",
            "user-can-change-outgoing-invoices": "Ausgangsrechnung nachträglich bearbeiten",
            "user-bank-statement-transactions": "Kontoauszugs-Transaktionen sehen",
            "user-liquidity-planning": "Liquiditätsplanung öffnen",
            "user-supplier-dashboard": "Lieferanten-Dashboard sehen",
            "user-ai-dashboard": "AI-Stats (nur für Operatoren)",
            "user-see-client-addresses": "Alle Unternehmensanschriften sehen",
            "user-export-invoice": "Rechnungen an {export_name} übermitteln",
            "user-can-delete-document-directly": "Dokumente ohne Klärung stornieren/aussteuern",
            "user-can-insert-product": "Im Produktkatalog speichern",
            "user-can-insert-supplier": "Stammdaten indirekt verändern",
            "masterdata-edit-clients": "Unternehmen bearbeiten",
            "masterdata-edit-cost-centers": "Kostenstellen bearbeiten",
            "masterdata-edit-posting-keys": "Steuerschlüssel bearbeiten",
            "masterdata-edit-departments": "Abteilungen bearbeiten",
            "masterdata-edit-suppliers": "Lieferunternehmen bearbeiten",
            "masterdata-edit-business-partners": "Geschäftspartner bearbeiten",
            "masterdata-edit-products": "Produktkatalog bearbeiten",
            "masterdata-edit-product-groups": "Warengruppen bearbeiten"
        },
        "blocked": "Anmeldesperre",
        "token_issued_at": "API-Token erzeugt am",
        "form_sequence": "name,email,client_id,department_id,cost_center_id,location_id,approval_limit,roles,blocked",
        "page": {
            "tab_general": "Allgemein",
            "tab_roles": "Berechtigungen",
            "tab_roles_general": "Allgemeine Berechtigungen",
            "tab_roles_dashboards": "Dashboards",
            "tab_roles_procurement": "Bestellanforderungen",
            "tab_roles_invoice": "Rechnungen",
            "tab_roles_outgoing_invoice": "Ausgangsrechnungen",
            "tab_roles_bank_statements": "Kontoauszüge",
            "bank_statement_permission_dependency_warning": "Für Änderungen an Kontoauszugs-Transaktionen muss zusätzlich „Rechnung nachträglich bearbeiten“ aktiviert sein. Diese Auswahl kann trotzdem gespeichert werden.",
            "tab_roles_masterdata": "Stammdaten",
            "tab_roles_block": "Sperren",
            "tab_permissions": "Berechtigungsgruppen",
            "tab_addresses": "Lieferanschriften",
            "tab_task_groups": "Aufgabengruppen",
            "tab_communication_contacts": "Kontakte",
            "tab_passkeys": "Passkeys",
            "tab_oauth_permissions": "App-Zugriffe",
            "oauth_permissions": "Gewährte Anwendungszugriffe",
            "oauth_permissions_description": "Die hier aufgeführten Anwendungen wurden ausdrücklich autorisiert, im Namen dieser Person auf Liftbase zuzugreifen.",
            "oauth_permissions_empty": "Es wurde noch kein Anwendungszugriff gewährt.",
            "oauth_application": "Anwendung",
            "oauth_redirect_uri": "Rücksprungziel",
            "oauth_unverified": "Nicht verifiziert",
            "oauth_permission": "Berechtigung",
            "oauth_scope_mcp": "Erlaubte Liftbase-Daten lesen",
            "oauth_granted_at": "Gewährt",
            "oauth_expires_at": "Läuft ab",
            "oauth_status": "Status",
            "oauth_status_active": "Aktiv",
            "oauth_status_expired": "Abgelaufen",
            "oauth_revoke": "Widerrufen",
            "oauth_revoke_title": "Anwendungszugriff widerrufen",
            "oauth_revoke_confirm": "Möchten Sie den Zugriff für {application} widerrufen? Die Erneuerung des Zugriffs wird sofort beendet; ein bereits ausgestellter Zugriffs-Token kann noch bis zu 15 Minuten gültig bleiben.",
            "oauth_revoked": "Anwendungszugriff wurde widerrufen.",
            "communication_contacts_description": "Verwalten Sie hier die E-Mail-Kontakte, die nur Ihnen in der Lieferantenkommunikation vorgeschlagen werden. Sie können gespeicherte Kontakte umbenennen oder entfernen, damit sie nicht mehr vorgeschlagen werden.",
            "communication_contacts_empty": "Noch keine gespeicherten Kontakte vorhanden.",
            "communication_contact_name": "Name",
            "communication_contact_name_placeholder": "Optionaler Anzeigename",
            "communication_contact_email": "E-Mail",
            "communication_contact_last_used": "Zuletzt verwendet",
            "communication_contact_saved": "Kontakt aktualisiert.",
            "communication_contact_deleted": "Kontakt entfernt.",
            "communication_contact_delete_confirm": "Möchten Sie den gespeicherten Kontakt \"{email}\" wirklich entfernen?",
            "accessible_companies_title": "Unternehmen mit Zugriff für diese Person",
            "accessible_companies_empty": "Keine Unternehmen aus den aktuellen Berechtigungen ermittelt.",
            "new": "Neue Person",
            "block_btn": "Person sperren",
            "unblock_btn": "Person entsperren",
            "login_as_btn": "Einloggen als",
            "roles": "Berechtigungen",
            "no_permission": "Keine Berechtigungsgruppen ausgewählt.",
            "task_group_permissions": "Berechtigungen aus Aufgabengruppen",
            "approval_limit_tooltip_content": "Definieren Sie hier, welche Beträge durch diese Person final freigegeben werden können. <br> Höhere Beträge können freigegeben werden, müssen aber zusätzlich durch eine weitere Person mit höherer Freigabegrenze final freigegeben werden.",
            "approval_limit_placeholder": "Unbegrenzt",
            "priority_approval_limit_tooltip_content": "Bestimmt die Reihenfolge, wenn mehrere Benutzer oder Gruppen dieselbe Freigabegrenze haben. <br>Höhere Werte bedeuten höhere Priorität (z.B. 1 = niedrigste, 1000 = höchste Priorität).",
            "upload_signature_label": "Unterschrift (Bild)",
            "upload_signature_btn": "Unterschrift auswählen",
            "upload_signature_tooltip_content": "Fügen Sie eine Unterschrift hinzu, welche auf das Beauftragungsdokument Ihrer freigegebenen Bestellungen gedruckt wird. <br/> Nehmen Sie am besten eine Bilddatei mit Hintergrund-Transparenz.",
            "email_signature_html": "E-Mail-Signatur",
            "email_signature_html_hint": "Diese Signatur wird bei der ersten Lieferantenkommunikation eines Dokuments automatisch im Nachrichtentext vorausgefüllt.",
            "api_token_btn": "API-Token erzeugen",
            "api_token_dialog_title": "API-Token erzeugen",
            "api_token_dialog_content": "API-Token werden für die Integration von Drittanwendungen benötigt und ermöglichen, im Namen der jeweiligen Person auf Daten zuzugreifen.",
            "api_token_dialog_date_placeholder": "Token-Ablaufdatum",
            "api_token_dialog_generate_btn": "Erzeugen",
            "api_token_dialog_copy_btn": "Kopieren",
            "api_token_dialog_copy_info": "Bitte kopieren und fügen Sie den folgenden API-Token in die Drittanwendung ein:",
            "api_token_dialog_copied": "Kopiert!",
            "language": "Sprache",
            "role_dashboard_tooltip": "Erlaubt den Zugriff auf alle Dashboards.",
            "role_ai_dashboard_tooltip": "AI-Stats ist nur für Operatoren verfügbar.",
            "role_supplier_dashboard_tooltip": "Erlaubt ausschließlich den Zugriff auf das Lieferanten-Dashboard. Diese Berechtigung ist unabhängig von „Dashboard sehen“.",
            "passkey": "Passkey",
            "passkeys": "Passkeys",
            "passkey_name": "Name",
            "passkey_last_login": "Letzter Login",
            "passkey_dialog": {
                "title": "Passkey hinzufügen",
                "info1": "<b>Was sind Passkeys?</b><ul><li>Login ohne auf E-Mail zu warten</li><li>Mit Fingerabdruck, Ihrem Gesicht oder PIN</li><li>Sicher und komfortabel</li></ul>",
                "info2": "<b>Jetzt in 3 Schritten einrichten:</b><ol><li>Name eingeben z.B. \"Homeoffice PC\" oder \"Notebook\"</li><li>Auf \"Weiter\" klicken</li><li>Den Anweisungen Ihres Browsers / Betriebsystems folgen</li></ol>",
                "info3": "Eine Schritt-für-Schritt Anleitung <a href=\"https://liftbase.de/handbuch/anmeldung/passkeys/\" target=\"_blank\">finden Sie im Handbuch</a>",
                "name_input_label": "Passkey-Name",
                "name_input_placeholder": "z.B. 'Homeoffice PC' oder 'Notebook'",
                "added_msg": "Passkey wurde hinzugefügt.",
                "deleted_msg": "Passkey wurde gelöscht.",
                "exist_msg": "Sie haben bereits einen Passkey auf diesem Gerät, versuchen Sie es mit einem anderen Gerät."
            },
            "validation": {
                "name_required": "Bitte geben Sie einen Namen ein.",
                "name_exists": "Der Name existiert bereits.",
                "email_required": "Bitte geben Sie eine E-Mail-Adresse ein.",
                "email_invalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
                "email_exists": "Die E-Mail-Adresse existiert bereits.",
                "approval_limit_length": "Die Freigabegrenze muss entweder größer als 0 oder leer sein."
            },
            "tour": {
                "name": "Geben Sie den Namen der Person an, am besten Vor- und Nachname.",
                "email": "Geben Sie die E-Mail-Adresse an, über die sich die Person einloggen kann.",
                "organization": "Ordnen Sie die Person einem Unternehmen, einer Abteilung und einer Kostenstelle zu. Diese Informationen werden dann beim Anlegen einer Bestellanforderung im Formular vorbelegt.",
                "approval_limit": "Hier können Sie der Person eine Freigabegrenze definieren. Wenn eine Bestellanforderung einen höheren Gesamtbetrag hat, muss diese zusätzlich von einer Person mit höherer Freigabegrenze freigegeben werden. Ist keine Grenze definiert, kann die Person alle Beträge final freigeben.",
                "signature": "Hier kann die Unterschrift der Person hinzugefügt werden. Gibt die Person eine Bestellanforderung frei, wird die Unterschrift zu der Bestell-PDF hinzugefügt.",
                "roles": "Hier können Berechtigungen der Person eingestellt werden, beispielsweise, ob und welche Vorgänge bzw. Informationen gesehen bzw. bearbeitet werden dürfen. Es gibt außerdem die Möglichkeit, die Person zu sperren, wenn diese bspw. das Unternehmen verlassen hat.",
                "roles_price": "Stellen Sie hier ein, ob die Person Produktpreise sehen darf.",
                "role_change_order": "Sie können einer vertrauenswürdigen Person die Berechtigung geben, Bestellanforderungen nach der Freigabe noch zu bearbeiten, ohne diese in die Klärung schicken zu müssen und somit eine erneute Freigabe zu vermeiden. Das kann beispielsweise nützlich sein, um Lieferanschriften oder Produktpreise nachträglich anzupassen.",
                "admin": "Wählen Sie aus, ob die Person Zugriff zum Administrationsbereich haben soll, um z.B. weitere Personen, Stammdaten oder Konfigurationen zu hinterlegen.",
                "block": "Wählen Sie diese Option, wenn eine Person daran gehindert werden soll, sich in liftbase einzuloggen, z.B. wenn sie das Unternehmen vorübergehend verlassen hat.",
                "api_token": "API-Token werden für die Integration von Drittanwendungen benötigt und ermöglichen, im Namen der jeweiligen Person auf Daten zuzugreifen.",
                "addresses": "Sie können für die Person eigene Lieferanschriften hinterlegen, z.B. wenn die Person von zuhause arbeitet und Produkte dorthin geliefert werden sollen.",
                "btn_save": "Speichern Sie die Person und die zugehörigen Informationen ab.",
                "profile_signature": "Hier können Sie Ihre Unterschrift hochladen. Wenn Sie dann Bestellanforderungen freigeben, wird Ihre Unterschrift auf die Bestell-PDF gedruckt.",
                "profile_addresses": "Sie können eigene Lieferanschriften hinterlegen, z.B. wenn Sie von zuhause arbeiten und Produkte dorthin geliefert werden sollen.",
                "profile_btn_save": "Speichern Sie die zugehörigen Informationen ab."
            }
        }
    },
    "lb_user": {
        "description": "Person"
    },
    "posting_key": {
        "name": "Bezeichnung",
        "tax": "Steuersatz in %",
        "number": "Schlüssel",
        "form_sequence": "name,number,tax",
        "page": {
            "new": "Neuer Steuerschlüssel",
            "validation": {
                "name_required": "Bitte geben Sie eine Bezeichnung ein.",
                "number_required": "Bitte geben Sie eine gültige Nummer an.",
                "number_length": "Darf bis zu 9-stellige Zahlen ab 1 enthalten."
            },
            "tour": {
                "name": "Geben Sie den Schlüssel sowie den zugehörigen Steuersatz an."
            }
        }
    },
    "ledger_account": {
        "name": "Bezeichnung",
        "description": "Beschreibung",
        "form_sequence": "name,number,description",
        "page": {
            "new": "Neue Sachkonto",
            "validation": {
                "name_required": "Bitte geben Sie einen Namen ein.",
                "number_required": "Bitte geben Sie eine gültige Nummer an.",
                "number_length": "Darf nur Zahlen enthalten und bei mehreren Ziffern nicht mit 0 beginnen.",
                "tax_required": "Bitte geben Sie einen gültigen Steuersatz aus.",
                "tax_length": "Prozentwert darf nur zweistellige Zahlen mit Komma und höchstens zwei Nachkommastellen enthalten."
            },
            "tour": {
                "name": "Geben Sie die Nummer sowie die Bezeichnung des Sachkontos an."
            }
        }
    },
    "profit_center": {
        "name": "Bezeichnung",
        "form_sequence": "name,number",
        "page": {
            "new": "Neues Profitcenter",
            "validation": {
                "name_required": "Bitte geben Sie einen Namen ein.",
                "number_required": "Bitte geben Sie eine gültige Nummer an.",
                "number_length": "Darf nur Zahlen enthalten und bei mehreren Ziffern nicht mit 0 beginnen.",
            },
            "tour": {
                "name": "Geben Sie die Nummer sowie die Bezeichnung des Profitcenters an."
            }
        }
    },
    "tax_group": {
        "code": "ID",
        "name": "Bezeichnung",
        "form_sequence": "name,code,client_id",
        "page": {
            "new": "Neue Steuergruppe",
            "validation": {
                "name_required": "Bitte geben Sie einen Namen ein.",
                "code_required": "Bitte geben Sie eine ID ein.",
                "client_required": "Bitte wählen Sie ein Unternehmen aus.",
            },
            "tour": {
                "name": "Geben Sie die ID sowie die Bezeichnung der Steuergruppe an."
            }
        }
    },
    "financial_dimension": {
        "code": "ID",
        "name": "Name",
        "form_sequence": "name,code",
        "page": {
            "new": "Neue Mitarbeitende",
            "validation": {
                "name_required": "Bitte geben Sie einen Namen ein.",
                "code_required": "Bitte geben Sie eine ID ein.",
                "client_required": "Bitte wählen Sie ein Unternehmen aus.",
            },
            "tour": {
                "name": "Geben Sie die ID sowie den Namen der Mitarbeidenden an."
            }
        }
    },
    "tax_item_group": {
        "code": "ID",
        "tax_code": "Steuer-ID",
        "name": "Bezeichnung",
        "form_sequence": "name,code,tax_code,client_id",
        "page": {
            "new": "Neue Steuer-Artikelgruppe",
            "validation": {
                "name_required": "Bitte geben Sie einen Namen ein.",
                "code_required": "Bitte geben Sie eine ID ein.",
                "tax_code_required": "Bitte geben Sie eine Steuer-ID ein.",
                "client_required": "Bitte wählen Sie ein Unternehmen aus.",
            },
            "tour": {
                "name": "Geben Sie die ID sowie die Bezeichnung der Steuer-Artikelgruppe an."
            }
        }
    },
    "approver": {
        "description": "Freigabe",
        "label_log": "lb_user_name",
        "table_log": "lb_user",
        "approver_required": "Bitte wählen Sie eine Freigabe aus.",
        "is_required": "Pflicht",
        "is_required_info": "Muss auch freigeben, wenn vorherige Freigebende bereits über die notwendige Freigabegrenze verfügen.",
        "conversion_info": "Der Freigabebetrag wurde zum aktuellen Wechselkurs der EZB in die Währung des Dokuments umgerechnet.",
        "max_approvers": "Max. Anzahl Freigebende",
        "max_approvers_placeholder": "optional",
        "max_approvers_info": "Optional. Wenn gesetzt, müssen nur die höchsten N Freigebenden (nach Freigabegrenze) freigeben. Pflicht-Freigebende zählen dazu und können die Maximalanzahl überschreiten. Ein vorangestellter Ersteller oder Fallback zählt nicht zur Maximalanzahl. Leer = bisherige Regel (alle passenden Freigebenden).",
        "add_creator_or_fallback": "Ersteller gibt zuerst frei",
        "add_creator_or_fallback_info": "Bestellanforderung: Der Ersteller wird an erster Stelle eingefügt. Reicht sein Freigabelimit nicht aus oder ist er nicht verfügbar, wird der Fallback verwendet. Rechnung mit verknüpfter Bestellung: Der Ersteller der Bestellung wird an erster Stelle eingefügt. Der Fallback wird nur verwendet, wenn dieser Ersteller nicht verfügbar ist. Rechnung ohne verknüpfte Bestellung: Der Fallback wird an erster Stelle eingefügt.",
        "procurement": "Bestellanforderung",
        "invoice": "Rechnung/Bestellanforderung",
        "or": "oder",
        "creator_placeholder": "Ersteller (automatisch)",
        "fallback_label": "Fallback bei fehlendem Ersteller",
        "fallback_info": "Wird bei Bestellanforderungen verwendet, wenn der Ersteller nicht verfügbar ist oder sein Freigabelimit nicht ausreicht. Bei Rechnungen wird er verwendet, wenn keine Bestellung verknüpft ist oder deren Ersteller nicht verfügbar ist.",
        "fallback_placeholder": "Fallback-Benutzer",
        "creator_or_fallback_preview": "Ersteller oder Fallback",
        "creator_or_fallback_preview_info": "Die erste Position ist reserviert. Ob dort der Ersteller oder der Fallback erscheint, wird beim jeweiligen Beleg bestimmt.",
        "test_order_value": "Test-Bestellwert",
        "test_order_value_placeholder": "z. B. 5000",
        "test_order_value_info": "Geben Sie einen fiktiven Bestellwert ein, um zu sehen, welche Freigebenden bei den aktuellen Einstellungen erforderlich wären.",
        "test_preview_section_title": "Freigabe testen",
        "test_preview_title": "Erforderliche Freigebende",
        "test_preview_empty": "Keine Freigebenden für diesen Wert.",
        "test_preview_required_overflow_short": "{requiredCount} Pflicht > Max. {max}"
    },
    "invoice": {
        "grouped_sum_tax": "Summe {tax}% Steuer",
        "description": "Rechnung",
        "name": "Bezeichnung",
        "creator_id": "Hochgeladen von",
        "created_at": "Hochgeladen am",
        "number": "Rechnungsnummer",
        "invoice_prefix": "Rechnungspräfix",
        "is_final_invoice": "Verknüpfte Bestellung als abgeschlossen markieren",
        "is_final_invoice_short": "BE abschließen",
        "is_final_invoice_info": "Wenn diese Option aktiviert wird, wird die verknüpfte Bestellung automatisch als abgeschlossen markiert. Danach können keine weiteren Rechnungen mehr mit dieser Bestellung verknüpft werden.",
        "invoice_prefix_options": {
            "RE": "normale Rechnung",
            "AZ": "Anzahlungsanforderung/ProForma Rechnung",
            "VK": "Vorkasse-Rechnung",
            "SR": "Schlussrechnung",
            "GS": "Gutschrift",
        },
        "invoice_number_formatted": "Interne RE-Nummer",
        "due_date": "Fälligkeit",
        "delivery_date": "Leistungsdatum",
        "invoice_date": "Belegdatum",
        "vat_due_date": "Datum des Umsatzsteuerregisters",
        "tax": "Steuersatz %",
        "total_brutto": "Gesamt-Brutto",
        "type_total_brutto": "currency",
        "total_netto": "Gesamt-Netto",
        "type_total_netto": "currency",
        "total_netto_abbr": "-Netto",
        "document_discount_amount": "Dokumentrabatt Betrag",
        "document_discount_base_amount": "Dokumentrabatt Basisbetrag",
        "document_discount_percentage": "Dokumentrabatt %",
        "document_discount_tax_percentage": "MwSt.-Satz des Dokumentrabatts %",
        "document_discount_percentage_tooltip": "Prozentsatz des Dokumentrabatts, bezogen auf den Basisbetrag (EN 16931 BT-94).",
        "document_discount_amount_tooltip": "Betrag des Dokumentrabatts (EN 16931 BT-92).",
        "document_discount_base_amount_tooltip": "Netto-Betrag, auf den der Dokumentrabatt angewendet wird (EN 16931 BT-93).",
        "document_discount_tax_percentage_tooltip": "Steuersatz, der für die steuerliche Zuordnung des Dokumentrabatts verwendet wird.",
        "supplier_vat_number": "USt-IdNr.",
        "supplier_payment_method": "Zahlungsart",
        "supplier_iban": "IBAN",
        "supplier_bic": "BIC",
        "supplier_bank_country": "Bank Land",
        "supplier_bank_account": "Kontonummer",
        "supplier_bank_code": "Bankleitzahl",
        "payment_reference": "Zahlungsreferenz",
        "fix_recognition": "Nicht zufrieden mit der Erkennung",
        "fix_recognition_checkbox": "Ich bin mit der Rechnungserkennung nicht zufrieden.",
        "paid": "Rechnung ist bereits bezahlt.",
        "paid_auto_by_bank_statement_hint": "Automatisch durch Kontoauszugsanalyse am {date} als bezahlt markiert.",
        "paid_manual_by_bank_statement_hint": "Durch manuellen Kontoauszugsabgleich am {date} als bezahlt markiert.",
        "review_status": "Prüfungsergebnis",
        "selected_review_status": "Gewählter Grund",
        "review_status_options": {
            "content_rejection": "Rechnung sachlich/fachlich abgelehnt",
            "insolvency_rejection": "Rechnung insolvenzrechtlich abgelehnt",
            "further_review_required": "Rechnung der erweiterten Prüfung zuzuführen",
            "other_reason_rejection": "Aus Sonstigen Grund storniert",
            "approved": "Rechnung freigegeben",
        },
        "currency": "Währung",
        "notes": "Notizen",
        "order_notes": "Bestellnotizen",
        "discount_percentage": "Skonto 1 - Prozent",
        "discount_amount": "Skonto 1 - Betrag",
        "discount_days": "Skonto 1 - Tage",
        "discount_payment_date": "Skonto 1 - Datum",
        "discount_percentage2": "Skonto 2 - Prozent",
        "discount_amount2": "Skonto 2 - Betrag",
        "discount_days2": "Skonto 2 - Tage",
        "discount_payment_date2": "Skonto 2 - Datum",
        "type_discount_amount": "currency",
        "type_discount_amount2": "currency",
        "payment_in_advance": "Vorkasse",
        "einvoice_status": {
            "is_einvoice": "E-Rechnung",
            "not_einvoice": "Keine E-Rechnung",
            "not_relevant_hint": "Keine E-Rechnung, nicht für den Vorsteuerabzug relevant",
            "tax_not_refundable_hint": "Vorsteuer in Höhe von {amount} kann ab 01.01.2027 nicht erstattet werden.",
            "zugferd10_hint": "ZUGFeRD 1.0 ist im Sinne der E-Rechnungspflicht (EN 16931) keine gültige E-Rechnung."
        },
        "electronic_validation": {
            "blocked_title": "Die Rechnung erfüllt nicht die gesetzlichen Anforderungen",
            "blocked_message": "Da die Rechnung die gesetzlichen Anforderungen nicht erfüllt, wird ihre Weiterverarbeitung nicht empfohlen. Eine manuelle Weiterverarbeitung ist dennoch möglich.",
            "blocked_status": "Prüfung erforderlich",
            "manual_export_warning_title": "Technische E-Rechnungsfehler",
            "manual_export_warning_message": "Die technische Prüfung dieser E-Rechnung enthält Fehler. Eine manuelle Weiterverarbeitung kann dennoch fortgesetzt werden, wird aber nicht empfohlen. Möchten Sie den Export bewusst fortsetzen?",
            "manual_export_bulk_warning_message": "Mindestens eine der ausgewählten E-Rechnungen enthält technische Fehler. Die manuelle Weiterverarbeitung kann dennoch fortgesetzt werden, wird aber nicht empfohlen. Möchten Sie den Export bewusst fortsetzen?",
            "manual_export_warning_confirm": "Export fortsetzen",
            "manual_export_warning_cancel": "Abbrechen",
            "show_details": "Details anzeigen",
            "hide_details": "Details ausblenden",
            "rule_set": "Regelpaket",
            "external_reference_uris": "Externe Referenzen",
            "notify_supplier": "Lieferanten benachrichtigen",
            "admin_report_hint": "Der vollständige technische Prüfbericht kann nur von Administratoren heruntergeladen werden.",
            "issue": {
                "malformed_xml": "Die XML-Datei ist nicht wohlgeformt oder enthält nicht erlaubte XML-Konstrukte.",
                "external_reference_not_resolved": "Die E-Rechnung verweist auf eine externe Ressource. Liftbase ruft externe Ressourcen aus Sicherheits- und Datenschutzgründen nicht automatisch ab und löst sie nicht auf.",
                "unknown_format": "Das XML-Rechnungsformat wird nicht unterstützt.",
                "unsupported_version": "Für die erkannte Versionsfamilie ist kein aktives Regelpaket verfügbar.",
                "outdated_version": "Die Rechnung verwendet die ältere XRechnung-Version {version}. Dies ist ein Hinweis und verhindert eine gesetzlich zulässige Verarbeitung nicht automatisch.",
                "unsupported_profile": "Das erkannte Format und Profil erfüllen nicht die gesetzlichen Anforderungen der EN 16931 und können daher nicht als gesetzeskonforme E-Rechnung akzeptiert werden. Bitte verwenden Sie ein EN-16931-konformes Rechnungsformat bzw. Profil, z. B. ZUGFeRD mit dem Profil EN 16931 oder XRechnung in einer gesetzlich gültigen Version.",
                "zugferd_10_unsupported": "Es wurde das veraltete Format ZUGFeRD 1.0 erkannt (Profil: {profile}). Diese Version wird nicht unterstützt. Der Lieferant muss die Rechnung als aktuelle Factur-X-/ZUGFeRD- oder XRechnung neu erzeugen.",
                "electronic_invoice_extraction_failed": "Die Daten konnten nicht aus der technisch gültigen E-Rechnung übernommen werden.",
                "kosit_execution_failed": "Die technische E-Rechnungsprüfung konnte nicht ausgeführt werden.",
                "kosit_processing_failed": "Bei der technischen E-Rechnungsprüfung ist ein Verarbeitungsfehler aufgetreten.",
                "processing_error": "Die technische E-Rechnungsprüfung konnte nicht abgeschlossen werden.",
                "multiple_bodies": "Es wurden mehrere Rechnungskörper gefunden. Unter den lokalen FatturaPA-Regeln sind nur Dokumente mit einem Body verarbeitbar.",
                "format_mismatch": "Das FatturaPA-Übertragungsformat (versione / FormatoTrasmissione) entspricht nicht den lokalen FatturaPA-Regeln.",
                "fatturapa_total_mismatch": "Die Belegsummen stimmen unter den lokalen FatturaPA-Regeln nicht überein.",
                "unsupported_document_type": "Dieser FatturaPA-Dokumenttyp wird unter den lokalen FatturaPA-Regeln nicht unterstützt.",
                "fatturapa_schema_violation": "Das Dokument hat die lokale FatturaPA-XSD-Prüfung nicht bestanden.",
                "fatturapa_line_total_mismatch": "Eine Positions-Summe stimmt nicht mit Menge × Einzelpreis nach Rabatten überein (lokale FatturaPA-Regeln).",
                "fatturapa_riepilogo_mismatch": "Die Positionssummen stimmen nicht mit der Steuerzusammenfassung überein (lokale FatturaPA-Regeln).",
                "fatturapa_destinatario_missing": "Der Empfängercode (CodiceDestinatario / PEC) fehlt oder ist unvollständig (lokale FatturaPA-Regeln).",
                "fatturapa_tax_mismatch": "Die MwSt.-Beträge stimmen nicht mit Bemessungsgrundlage × Satz überein (lokale FatturaPA-Regeln).",
                "fatturapa_business_rule_failed": "Die lokalen FatturaPA-Geschäftsregeln konnten nicht ausgewertet werden.",
                "fatturapa_iban_format": "Eine IBAN auf der Rechnung ist nach lokalen FatturaPA-Regeln formal ungültig.",
                "fatturapa_vat_id_sanity": "Eine USt-Id (IdFiscaleIVA) hat die grundlegenden Längen-/Zeichensatzprüfungen nach lokalen FatturaPA-Regeln nicht bestanden.",
                "fatturapa_destinatario_length": "Die Länge von CodiceDestinatario entspricht nicht dem erwarteten Übertragungsformat (lokale FatturaPA-Regeln)."
            },
            "local_scope_hint": "Nur lokale FatturaPA-Prüfung — kein SDI-Annahmeergebnis und keine rechtliche Sicherheit für den Vorsteuerabzug.",
            "local_accepted_title": "Gültig nach lokalen FatturaPA-Regeln",
            "warning_title": "Hinweise zur technischen Validierung",
            "status": {
                "acceptable": "Bestanden",
                "rejected": "Abgelehnt",
                "undefined": "Nicht eindeutig",
                "technical_error": "Technischer Fehler"
            },
            "supplier_template": {
                "subject": "Ihre Rechnung {number} vom {invoiceDate}",
                "unknown_value": "nicht angegeben",
                "rule_set_unavailable": "kein passendes Regelpaket",
                "no_specific_reason": "Der Validator hat keinen einzelnen Fehlertext zurückgegeben. Bitte prüfen Sie den vollständigen technischen Prüfbericht.",
                "reasons_heading": "Was muss korrigiert werden?",
                "body": "<p>Guten Tag,</p><p>die Rechnung kann in der vorliegenden Form nicht als gesetzeskonforme E-Rechnung akzeptiert werden, da das erkannte Format bzw. Profil die gesetzlichen Anforderungen nicht erfüllt.</p><p style=\"margin-bottom:-4px\"><strong>Betroffene Rechnung:</strong></p><ul style=\"margin-bottom:12px\"><li><strong>Rechnungsnummer:</strong> {number}</li><li><strong>Rechnungsdatum:</strong> {invoiceDate}</li><li><strong>Erkanntes Format:</strong> {standard}</li><li><strong>Erkannte Version:</strong> {version}</li><li><strong>Erkanntes Profil:</strong> {profile}</li></ul>{reasonsSection}<br><p>Bitte verwenden Sie ein Rechnungsformat oder -profil gemäß EN 16931, z. B. ZUGFeRD im Profil EN 16931 oder XRechnung in einer unterstützten Version.</p><p>Bitte stellen Sie eine korrigierte E-Rechnung aus und senden Sie sie uns anschließend erneut.</p><p>Vielen Dank für Ihre Unterstützung.</p>",
                "body_fatturapa": "<p>Guten Tag,</p><p>die Rechnung kann in der vorliegenden Form nicht als gesetzeskonforme E-Rechnung akzeptiert werden, da das erkannte Format bzw. Profil die gesetzlichen Anforderungen nicht erfüllt.</p><p style=\"margin-bottom:-4px\"><strong>Betroffene Rechnung:</strong></p><ul style=\"margin-bottom:12px\"><li><strong>Rechnungsnummer:</strong> {number}</li><li><strong>Rechnungsdatum:</strong> {invoiceDate}</li><li><strong>Erkanntes Format:</strong> {standard}</li><li><strong>Erkannte Version:</strong> {version}</li><li><strong>Erkanntes Profil:</strong> {profile}</li></ul>{reasonsSection}<br><p>Bitte verwenden Sie ein Rechnungsformat oder -profil gemäß EN 16931, z. B. ZUGFeRD im Profil EN 16931 oder XRechnung in einer unterstützten Version.</p><p>Bitte stellen Sie eine korrigierte E-Rechnung aus und senden Sie sie uns anschließend erneut.</p><p>Vielen Dank für Ihre Unterstützung.</p>"
            }
        },
        "export_individual_items": "Rechnungspositionen übermitteln",
        "export_individual_items_tooltip": "Wenn dieser Haken gesetzt ist, werden die Positionen anstelle der Kopfdaten übermittelt.",
        "status": "Status",
        "statuses": {
            "open": "Rechnungserkennung",
            "export": "Bereit zum Export",
            "declined": "Storniert",
            "declined-exported": "Storniert-Exportiert",
            "completed": "Exportiert",
            "approval": "Manuelle Prüfung",
            "financial-approval": "Freigabe",
            "clearing": "Klärung Buchhaltung",
            "accounting": "Buchhaltung"
        },
        "page": {
            "ai_validation_result": {
                "title": "KI-Validierungsergebnis",
                "result": "Ergebnis",
                "green_flags": "Positive Signale (Green Flags)",
                "red_flags": "Risikosignale (Red Flags)",
                "score": "Score",
                "check_method": "Prüfmethode",
                "signals_considered": "Berücksichtigte Signale",
                "signals_missing": "Fehlende Signale",
                "system_prompt": "System-Prompt",
                "user_prompt": "User-Prompt",
                "context": "Kontext",
                "no_data": "Keine KI-Validierungsdaten für diese Rechnung vorhanden.",
                "response": "Antwort (JSON)",
                "trust_level": "Vertrauenswürdig",
                "not_trust_level": "Nicht vertrauenswürdig",
                "btn_tooltip": "KI-Validierungsdetails anzeigen",
                "decision_summary": "Begründung",
                "what_decided": "Was hat entschieden?",
                "positive_contributions": "Positive Beiträge",
                "risk_contributions": "Risiko-Beiträge",
                "scoring_method": "Methode",
                "scoring_method_linear": "Linear",
                "scoring_method_multiplicative": "Multiplikativ",
                "scoring_method_confidence": "Konfidenz",
                "score_kind_risk": "Risikoscore",
                "score_kind_confidence": "Konfidenzscore",
                "score_kind_green_sum": "Summe positiver Signale",
                "score_explanation_title": "Wie die KI zur Entscheidung kommt",
                "score_scale_hint_risk": "Orientierung: 0 = kein erkennbares Restrisiko, 1 = maximales Risiko. Je niedriger der Wert, desto eher kann die Rechnung automatisch freigegeben werden.",
                "score_scale_hint_confidence": "Orientierung: 0 = sehr unsicher, 1 = sehr sicher. Je höher der Wert, desto eher kann die Rechnung automatisch freigegeben werden.",
                "score_scale_hint_green_sum": "Orientierung: 0 = keine belastbaren positiven Signale, 1 = sehr starke positive Signale. Je höher der Wert, desto eher kann die Rechnung automatisch freigegeben werden.",
                "decision_reasons_trusted": "Entscheidend waren außerdem: {ai_validation_reason_value}.",
                "decision_reasons_not_trusted": "Entscheidend waren: {ai_validation_reason_value}.",
                "decision_reasons_insufficient_positive": "Die positiven Signale reichten nicht aus: {ai_validation_reason_value}.",
                "show_calculation": "Berechnung anzeigen",
                "formula_linear": "Risiko = RedSum − GreenSum = {red_sum} − {green_sum} = {final_score}",
                "formula_multiplicative_risk": "Risiko = (RedSum × Boost) × (1 − GreenSum) = ({red_sum} × {boost}) × (1 − {green_sum}) = {final_score}",
                "formula_multiplicative_green": "GreenSum = {green_sum}",
                "formula_confidence": "Konfidenz = GreenSum − RedPenalty = {green_sum} − {red_sum} = {final_score}",
                "decision_passed": "{score_label} {final_score} {comparison} {threshold} → vertrauenswürdig",
                "decision_failed": "{score_label} {final_score} {comparison} {threshold} → nicht vertrauenswürdig",
                "finding": "Ergebnis",
                "detected": "Gefunden / Ja",
                "not_detected": "Nicht gefunden / Nein",
                "certainty_label": "Sicherheit",
                "tokens_used": "KI-Tokens verwendet (In: {tokens_in}, Out: {tokens_out})",
                "tokens_not_used": "Keine KI-Tokens verwendet",
                "ai_checked_flags": "Von KI geprüft",
                "local_checked_flags": "Lokal vorgeprüft",
                "parse_error": "KI-Antwort konnte nicht als JSON verarbeitet werden.",
                "flag_descriptions": {
                    "GREEN_01": "Alle Pflichtfelder sind vollständig (Rechnungsnummer, Datum, Lieferunternehmen, Beträge, Steuerangaben).",
                    "GREEN_02": "Historische Plausibilität beim Lieferunternehmen (ähnliche Beträge, Struktur, Beschreibungen, Intervalle).",
                    "GREEN_03": "Absender-E-Mail-Adresse ist bekannt (passt zu Stammdaten oder historischen E-Mails des Lieferunternehmens).",
                    "GREEN_04": "Beträge wirken zur Leistung plausibel (abgeleitetes Preisniveau passt zum Rechnungsbetrag).",
                    "GREEN_05": "Rechnung bezieht sich auf einen klaren Zeitraum (Leistungszeitraum ist angegeben und überschneidet sich nicht).",
                    "GREEN_06": "Bankverbindung entspricht den Stammdaten (IBAN/Empfänger stimmt exakt mit den Stammdaten überein).",
                    "RED_01": "Absender-E-Mail-Adresse weicht ab (neue oder leicht veränderte Domain).",
                    "RED_02": "Zeitraum überschneidet sich mit bestehenden Rechnungen (Leistungszeitraum ist bereits abgedeckt).",
                    "RED_03": "Hoher Betrag oder hohes inhärentes Risiko (Betrag über Schwellwert oder risikoreiche Kategorie).",
                    "RED_04": "Plötzlicher Betragsanstieg beim gleichen Lieferunternehmen (deutlicher Anstieg ohne erkennbare Begründung).",
                    "RED_05": "Bestellung/Vertrag fehlt oder weicht ab (historisch erwartet, aber fehlend, oder deutliche Abweichung zur verknüpften Bestellung).",
                    "RED_06": "Abweichende Bankverbindung zum Stammdatensatz (neue/geänderte IBAN gegenüber den Stammdaten)."
                }
            },
            "upload": {
                "title": "Neue Rechnungen hochladen",
                "info": "Drag-and-drop oder hier klicken zum Hochladen einer oder mehrerer Rechnungen (*.pdf bis zu 30MB).",
                "info_attachments": "Drag-and-drop oder hier klicken zum Hochladen einer oder mehrerer Anhänge (bis zu 30MB pro Datei).",
                "create_btn": "Rechnungserkennung starten",
                "file_invalid": "Bitte nur PDF oder XML-Dateien bis zu 30MB hochladen.",
                "no_preview_available": "Für diesen Dateityp steht keine Vorschau zur Verfügung. <br>Bitte laden Sie die Datei herunter und öffnen Sie auf Ihrem Computer.",
                "settings": "Einstellungen",
                "group_by_tax": "Beim Erkennen nach Steuersatz gruppieren",
                "group_by_tax_hint": "Wenn aktiviert, werden erkannte Positionen beim Upload nach Steuersatz zusammengefasst (z. B.: Summe 19% Steuer).",
                "ai_validation": "KI-Validierung aktivieren",
                "ai_validation_hint": "Wenn aktiviert, wird die Rechnung nach der KI-Erkennung direkt in den Status \"Bereit zum Export\" verschoben, sofern keine Genehmigungsschritte erforderlich sind.",
                "ai_validation_mode": "KI-Validierung",
                "ai_validation_mode_none": "Keine KI-Validierung",
                "ai_validation_auto_forward": "Aktivieren und zu \"Bereit zum Export\" schieben",
                "ai_validation_auto_forward_hint": "Wenn aktiviert, wird die Rechnung nach der KI-Erkennung direkt in den Status \"Bereit zum Export\" verschoben, sofern keine Genehmigungsschritte erforderlich sind.",
                "ai_validation_advisory": "Aktivieren, Status unverändert lassen",
                "ai_validation_advisory_forced": "Bereits aktiv, Status bleibt unverändert",
                "ai_validation_advisory_hint": "Wenn aktiviert, prüft die KI die Rechnung, schreibt das Ergebnis in die Timeline und zeigt die Score-Details an, ohne den normalen Workflow zu überspringen.",
                "tour": {
                    "before_attach": "Hier können Sie eine oder mehrere Rechnungen per Drag-and-drop oder Klicken in dem Bereich hochladen.",
                    "after_attach_title": "Rechnungserkennung starten",
                    "after_attach": "Hier können Sie die automatische Erkennung für alle hochgeladenen Rechnungen starten. Sie werden dann zur Übersicht der ersten Rechnung weitergeleitet. Die anderen Rechnungen finden Sie dann in der Aufgabeliste."
                }
            },
            "tabs": {
                "lines": "Positionen",
                "discount": "Rabatt",
                "payment": "Zahlungsdaten",
                "transactions": "Transaktionen",
                "notes": "Notizen",
                "recognition": "Belegerkennung Rohdaten",
            },
            "linked_transactions": {
                "title": "Verknüpfte Transaktionen",
                "empty": "Es wurden keine verknüpften Transaktionen gefunden.",
                "load_error": "Die verknüpften Transaktionen konnten nicht geladen werden.",
                "statement": "Kontoauszug",
                "match_type": "Verknüpfung",
                "allocated_amount": "Zugeordneter Betrag",
                "match_type_direct": "Direkt",
                "match_type_manual": "Split"
            },
            "new": "Neue Rechnung",
            "payment_conditions": "Zahlungsbedingungen",
            "select_contract_or_procurement": "Vertrag / Bestellanforderung",
            "discount1": "Skonto 1",
            "discount2": "Skonto 2",
            "discount_percentage": "Prozent",
            "discount_amount": "Betrag",
            "discount_days": "Tage",
            "discount_payment_date": "Datum",
            "invoice_discount_data": "Skonto auf dem Belege",
            "supplier_discount_data": "Skonto in den Stammdaten",
            "business_partner_discount_data": "Skonto in den Stammdaten des Geschäftspartners",
            "copy_discount_data_to_supplier": "Vom Beleg in die Stammdaten übernehmen",
            "copy_discount_data_to_supplier_tooltip": "Beim Klicken werden die im Formular angegebenen Skontodaten in die Stammdaten des Lieferunternehmens übernommen.",
            "copy_discount_data_to_business_partner_tooltip": "Beim Klicken werden die im Formular angegebenen Skontodaten in die Stammdaten des Geschäftspartners übernommen.",
            "download_pdf": "PDF herunterladen",
            "download_pdf_info": "Falls kein PDF dargestellt wird, prüfen Sie bitte in Ihren Webbrowser Einstellungen, <br>dass die Option \"PDF-Dateien immer herunterladen\" deaktiviert ist.",
            "download_xml": "XML herunterladen",
            "download_xml_info": "Lädt die originale FatturaPA-XML-Datei herunter.",
            "visualization_generated_hint": "Dieses PDF wurde aus dem XML der E-Rechnung erzeugt. Rechtlich maßgeblich bleibt das XML.",
            "visualization_compare_hint": "Das XML-PDF zeigt den Inhalt des XML; das Original-PDF kann davon abweichen. Rechtlich maßgeblich bleibt das XML.",
            "visualization_version_hint": "Visualisierungs-Version: {version}.",
            "visualization_history": "PDF-Versionen",
            "visualization_history_title": "PDF-Versionen",
            "visualization_version_label": "PDF-Version {version}",
            "visualization_current_version": "Aktuell",
            "visualization_version_created_at": "Erstellt am: {date}",
            "visualization_version_renderer": "Rendering-Version: {renderer}",
            "visualization_version_view": "Anzeigen",
            "visualization_version_download": "Herunterladen",
            "visualization_version_loading": "PDF wird geladen ...",
            "visualization_version_load_error": "Die PDF-Version konnte nicht geladen werden.",
            "regenerate_visualization": "PDF neu erzeugen",
            "regenerate_visualization_title": "PDF neu erzeugen",
            "regenerate_visualization_confirm": "Das PDF wird mit der aktuellen Rendering-Version neu erzeugt. Die bisherige Version bleibt erhalten. Möchten Sie fortfahren?",
            "regenerate_visualization_confirm_button": "Neu erzeugen",
            "regenerate_visualization_success": "PDF-Version {version} wurde erfolgreich erzeugt.",
            "regenerate_visualization_error": "Das PDF konnte nicht neu erzeugt werden.",
            "document_tabs": {
                "xml": "XML",
                "preview": "Vorschau",
                "pdf": "PDF",
                "original_pdf": "Original-PDF",
                "visualization": "KoSIT-PDF",
                "fatturapa": "FatturaPA",
                "fatturapa_pdf": "FatturaPA-PDF"
            },
            "fatturapa_preview": {
                "eyebrow": "FatturaPA",
                "invoice": "Rechnung",
                "credit_note": "Gutschrift",
                "debit_note": "Belastungsanzeige",
                "number": "Nummer",
                "date": "Datum",
                "profile": "Format",
                "order_data": "Bestelldaten",
                "order_number": "Nummer",
                "purchase_order_number": "Bestellnummer",
                "line_reference": "Zeilenreferenz",
                "order_reference": "Bestellreferenz",
                "item_number": "Artikelnummer",
                "convention_code": "Konventionscode",
                "cup": "CUP",
                "cig": "CIG",
                "supplier": "Verkäufer",
                "customer": "Käufer",
                "vat_id": "USt-IdNr.",
                "fiscal_code": "Steuercode",
                "lines": "Positionen",
                "description": "Beschreibung",
                "qty": "Menge",
                "unit_price": "Einzelpreis",
                "discount": "Rabatt",
                "document_discount": "Dokumentrabatt",
                "line_total": "Positionssumme",
                "vat": "MwSt.",
                "taxable": "Bemessungsgrundlage",
                "tax": "Steuer",
                "total": "Gesamtbetrag",
                "payment": "Zahlung",
                "payment_method": "Zahlungsart",
                "show_xml": "XML anzeigen",
                "hide_xml": "XML ausblenden",
                "footnote": "Lokale FatturaPA-Vorschau — rechtlich maßgeblich bleibt das XML. Kein SDI-Annahmeergebnis."
            },
            "notes_datev_hint": "Diese Notiz wird über DATEV Unternehmen Online an den Steuerberater übermittelt.",
            "recognition_data_title": "Belegerkennung Rohdaten",
            "no_recognition_data": "Keine Daten erkannt.",
            "repeat_recognition_btn": "Belegerkennung wiederholen",
            "repeat_recognition_confirm_btn": "Bestätigen",
            "repeat_recognition_confirm_msg": "Die bestehenden Daten im Formular werden überschrieben. Sind Sie sicher, dass Sie fortfahren wollen?",
            "repeat_recognition_confirm_title": "Belegerkennung wiederholen",
            "repeat_recognition_feedback_msg": "Die Belegerkennung erfolgt im Hintergrund und kann einige Sekunden in Anspruch nehmen.",
            "recognized_client_id": "Anhand der <b>Umsatzsteuer-ID</b> und des <b>Namens</b> konnte das Unternehmen erfolgreich zugeordnet werden.<br>  <b>Unternehmen:</b> {client_name}",
            "user_client_id": "Das Unternehmen wurde anhand des <b>Benutzerprofils</b> des Uploaders übernommen.<br> <b>Unternehmen:</b> {client_name}",
            "field_origin": {
                "title": "Herkunft der Vorauswahl",
                "source_label": "Quelle",
                "history_title": "Historie der Belegerkennung",
                "run_title": "{date} · {count} Feld(er){status}{model}",
                "unknown_run": "Unbekannte Belegerkennung",
                "field_column": "Feld",
                "before_column": "Vorher",
                "after_column": "Nachher",
                "reason_column": "Grund",
                "empty_value": "Leer",
                "ai_history_title": "KI-Verarbeitungsverlauf",
                "ai_request_label": "Anfrage-Prompt",
                "ai_response_label": "KI-Antwort",
                "ai_system_prompt_label": "System-Prompt",
                "ai_user_prompt_label": "Benutzer-Prompt",
                "ai_sources_label": "Quellen der benutzerdefinierten Prompts",
                "ai_tenant_prompt_label": "Mandanten-Prompt",
                "ai_client_prompt_label": "Kunden-Prompt",
                "ai_supplier_prompt_label": "Lieferanten-Prompt",
                "ai_recognition": "Belegerkennung",
                "ai_custom_prompt": "Nachbearbeitung mit benutzerdefiniertem Prompt",
                "ai_supplier_identification": "Lieferantenerkennung",
                "ai_validation": "Rechnungsprüfung",
                "ai_succeeded": "Erfolgreich",
                "ai_failed": "Fehlgeschlagen",
                "source_types": {
                    "recognition": "Belegerkennung",
                    "procurement": "Bestellanforderung",
                    "supplier_master_data": "Lieferantenstammdaten",
                    "business_partner_master_data": "Geschäftspartner-Stammdaten",
                    "creator_default": "Profil des Uploaders"
                },
                "reasons": {
                    "invoice_number_extracted_from_document": "Direkt aus dem erkannten Rechnungsdokument ausgelesen.",
                    "total_netto_extracted_from_document": "Direkt aus dem erkannten Rechnungsdokument ausgelesen.",
                    "total_brutto_extracted_from_document": "Direkt aus dem erkannten Rechnungsdokument ausgelesen.",
                    "invoice_date_extracted_from_document": "Direkt aus dem erkannten Rechnungsdokument ausgelesen.",
                    "due_date_extracted_from_document": "Direkt aus dem erkannten Rechnungsdokument ausgelesen.",
                    "delivery_date_extracted_from_document": "Direkt aus dem erkannten Rechnungsdokument ausgelesen.",
                    "document_discount_amount_extracted_from_document": "Direkt aus dem erkannten Rechnungsdokument ausgelesen.",
                    "document_discount_base_amount_extracted_from_document": "Direkt aus dem erkannten Rechnungsdokument ausgelesen.",
                    "document_discount_percentage_extracted_from_document": "Direkt aus dem erkannten Rechnungsdokument ausgelesen.",
                    "document_discount_tax_percentage_extracted_from_document": "Direkt aus dem erkannten Rechnungsdokument ausgelesen.",
                    "client_matched_by_receiver_name_or_vat": "Ausgewählt, weil der erkannte Rechnungsempfänger anhand von Name oder Umsatzsteuer-ID einem Unternehmen zugeordnet wurde.",
                    "client_matched_by_supplier_name_or_vat": "Ausgewählt, weil der erkannte Rechnungssteller anhand von Name oder Umsatzsteuer-ID einem Unternehmen zugeordnet wurde.",
                    "client_from_creator_profile": "Aus dem Unternehmen übernommen, das dem Uploader zugeordnet ist.",
                    "client_from_procurement": "Aus der zugeordneten Bestellanforderung übernommen.",
                    "supplier_matched_by_name_vat_or_iban": "Ausgewählt, weil erkannte Lieferantendaten anhand von Name, Umsatzsteuer-ID oder IBAN einem Lieferunternehmen zugeordnet wurden.",
                    "business_partner_matched_by_name_vat_or_iban": "Ausgewählt, weil erkannte Gegenparteidaten anhand von Name, Umsatzsteuer-ID oder IBAN einem Geschäftspartner zugeordnet wurden.",
                    "business_partner_matched_by_receiver_name_or_vat": "Ausgewählt, weil der erkannte Rechnungsempfänger anhand von Name oder Umsatzsteuer-ID einem Geschäftspartner zugeordnet wurde.",
                    "supplier_from_single_procurement_supplier": "Ausgewählt, weil die zugeordnete Bestellanforderung genau ein Lieferunternehmen hat.",
                    "procurement_matched_by_recognized_reference": "Ausgewählt, weil eine erkannte Bestellreferenz zu dieser Bestellanforderung passt.",
                    "procurement_matched_by_invoice_similarity": "Ausgewählt, weil Betrag, Datum und Positionen zur Rechnung passen.",
                    "procurement_matched_by_invoice_similarity_without_supplier": "Ausgewählt, weil Betrag, Datum und Positionen schon vor der Lieferantenauswahl zur Rechnung passen.",
                    "ledger_account_from_procurement": "Aus der zugeordneten Bestellanforderung übernommen.",
                    "cost_center_from_procurement": "Aus der zugeordneten Bestellanforderung übernommen.",
                    "cost_type_from_procurement": "Aus der zugeordneten Bestellanforderung übernommen.",
                    "profit_center_from_supplier_master_data": "Aus den Lieferantenstammdaten übernommen.",
                    "profit_center_from_business_partner_master_data": "Aus den Geschäftspartner-Stammdaten übernommen.",
                    "department_from_procurement": "Aus der zugeordneten Bestellanforderung übernommen.",
                    "branch_from_procurement": "Aus der zugeordneten Bestellanforderung übernommen.",
                    "employee_from_procurement": "Aus der zugeordneten Bestellanforderung übernommen.",
                    "financial_dimension_from_procurement": "Aus der zugeordneten Bestellanforderung übernommen.",
                    "ledger_account_from_supplier_master_data": "Aus den Lieferantenstammdaten übernommen.",
                    "cost_center_from_supplier_master_data": "Aus den Lieferantenstammdaten übernommen.",
                    "ledger_account_from_business_partner_master_data": "Aus den Geschäftspartner-Stammdaten übernommen.",
                    "cost_center_from_business_partner_master_data": "Aus den Geschäftspartner-Stammdaten übernommen.",
                    "posting_key_from_recognized_tax": "Aus dem erkannten Steuersatz abgeleitet.",
                    "supplier_iban_extracted_from_document": "Direkt aus dem erkannten Rechnungsdokument ausgelesen.",
                    "supplier_bic_extracted_from_document": "Direkt aus dem erkannten Rechnungsdokument ausgelesen.",
                    "payment_bank_data_extracted_from_document": "Die Quelle der Bankdaten wurde anhand erkannter Belegdaten gesetzt."
                }
            },
            "client_address_check": {
                "match": "Es wurde eine Prüfung gemäß § 14 Abs. 4 UStG durchgeführt, bei der keine Abweichungen festgestellt wurden.",
                "unrecognized": "Es konnte keine Prüfung gemäß § 14 Abs. 4 UStG durchgeführt werden, da die Anschrift auf der Rechnung nicht erkannt wurde.",
                "mismatch_intro": "Es wurde eine Prüfung gemäß § 14 Abs. 4 UStG durchgeführt, bei der eine Abweichung festgestellt wurde:",
                "invoice_label": "Daten auf der Rechnung",
                "master_data_label": "Daten in den Stammdaten",
                "supplier_message_button": "Korrektur anfordern",
                "supplier_message_greeting": "Sehr geehrte Damen und Herren,",
                "supplier_message_intro": "vielen Dank für die Übersendung der Rechnung.",
                "supplier_message_invoice_number_label": "Rechnungsnummer",
                "supplier_message_body": "Leider ist die auf der Rechnung angegebene Anschrift/Name unseres Unternehmens nicht korrekt. Gemäß § 14 Abs. 4 UStG muss eine Rechnung die zutreffende Anschrift und Namen des Leistungsempfängers enthalten, um den gesetzlichen Anforderungen zu entsprechen.",
                "supplier_message_outro": "Wir können die Rechnung daher in der vorliegenden Form nicht akzeptieren und bitten Sie, uns eine entsprechend korrigierte Rechnung mit der richtigen Anschrift zukommen zu lassen.",
                "supplier_message_questions": "Für Rückfragen stehen wir gerne zur Verfügung.",
                "address_normalization": {
                    "street_aliases": ["straße", "strasse", "str", "str."],
                    "number_aliases": ["nr", "nr.", "no", "no.", "nummer", "hausnummer", "hnr", "hnr."]
                }
            },
            "no_client_recognized": "Es konnte anhand der <b>Umsatzsteuer-ID</b> oder des <b>Namens</b> kein Unternehmen zugeordnet werden.<br> Bitte überprüfen Sie, ob die Daten des Unternehmens in liftbase den Daten auf der Rechnung entsprechen.",
            "recognized_supplier_id": "Anhand der <b>IBAN</b>, <b>Umsatzsteuer-ID</b> und des <b>Namens</b> konnte das Lieferunternehmen erfolgreich zugeordnet werden.<br> <b>Lieferunternehmen:</b> {supplier_name} <br> <b>USt-IdNr.:</b> {supplier_vat_number} <br> <b>IBAN:</b> {supplier_iban} <br> <b>BIC:</b> {supplier_bic}",
            "supplier_custom_prompt_title": "Lieferantenspezifischer Custom Prompt",
            "supplier_custom_prompt_applied": "Für die Belegerkennung wurde ein lieferantenspezifischer Custom Prompt angewendet.",
            "supplier_custom_prompt_supplier_label": "Lieferunternehmen",
            "supplier_custom_prompt_source_label": "Quelle",
            "supplier_custom_prompt_confidence_label": "Konfidenz",
            "supplier_custom_prompt_text_label": "Prompt",
            "supplier_custom_prompt_text_empty": "Für dieses Lieferunternehmen ist aktuell kein Custom Prompt hinterlegt.",
            "supplier_custom_prompt_source": {
                "sender_domain": "Absenderdomain",
                "recognized_supplier_vat_iban": "USt-IdNr./IBAN",
                "recognized_supplier_name": "Lieferantenname",
                "first_page_ai": "KI (1. PDF-Seite, Text)",
                "first_page_ai_file": "KI (1. PDF-Seite, Scan)"
            },
            "recognized_business_partner_id": "Anhand der <b>IBAN</b>, <b>Umsatzsteuer-ID</b> und des <b>Namens</b> konnte der Geschäftspartner erfolgreich zugeordnet werden.<br> <b>Geschäftspartner:</b> {supplier_name} <br> <b>USt-IdNr.:</b> {supplier_vat_number} <br> <b>IBAN:</b> {supplier_iban} <br> <b>BIC:</b> {supplier_bic}",
            "no_supplier_recognized": "Es konnte anhand der <b>Umsatzsteuer-ID</b> oder des <b>Namens</b> kein Lieferunternehmen zugeordnet werden.<br> Bitte überprüfen Sie, ob die Daten des Lieferunternehmens in liftbase den Daten auf der Rechnung entsprechen.",
            "payment_details_not_equal": "Die Zahlungsdaten des Lieferunternehmens stimmen nicht mit den erkannten Daten oder den Formulardaten überein. <br> <b>Lieferunternehmen:</b> {supplier_name} <br> <b>USt-IdNr.:</b> {supplier_vat_number} <br> <b>IBAN:</b> {supplier_iban} <br> <b>BIC:</b> {supplier_bic}",
            "payment_details_not_equal_business_partner": "Die Zahlungsdaten des Geschäftspartners stimmen nicht mit den erkannten Daten oder den Formulardaten überein. <br> <b>Geschäftspartner:</b> {supplier_name} <br> <b>USt-IdNr.:</b> {supplier_vat_number} <br> <b>IBAN:</b> {supplier_iban} <br> <b>BIC:</b> {supplier_bic}",
            "supplier_dialog_info": "\n" +
                "<div style=\"text-align: justify\">\n" +
                "    <style>\n" +
                "        .modal-header {\n" +
                "            margin-bottom: 0;\n" +
                "        }\n" +
                "\n" +
                "        .modal-p {\n" +
                "            margin-bottom: 10px !important;\n" +
                "        }\n" +
                "    </style>\n" +
                "\n" +
                "    <p class=\"modal-p\">\n" +
                "        Wir haben festgestellt, dass sich das zugeordnete Lieferunternehmen geändert hat.\n" +
                "    </p>\n" +
                "\n" +
                "    <p class=\"modal-p\">\n" +
                "        <strong>Möglicher Grund:</strong><br>\n" +
                "        Die Belegerkennung konnte kein oder ein falsches Lieferunternehmen zuordnen.\n" +
                "    </p>\n" +
                "\n" +
                "    <b class=\"modal-header\">Automatische Zuordnung optimieren</b>\n" +
                "    <p class=\"modal-p\">\n" +
                "        Wussten Sie, dass Sie in <strong>liftbase</strong> die automatische Zuordnung für zukünftige Belege ganz einfach verbessern können?\n" +
                "        Hinterlegen Sie dazu in den Stammdaten Ihres Lieferunternehmens die Bankverbindung (IBAN, BIC) oder die Umsatzsteuer-ID.\n" +
                "        Diese Angaben nutzt <strong>liftbase</strong>, um beim nächsten Mal das richtige Lieferunternehmen automatisch zuzuordnen.\n" +
                "    </p>\n" +
                "    <p class=\"modal-p\">\n" +
                "        Im Bereich <strong>„Zahlungsdaten“</strong> können Sie die von der Belegerkennung erkannten Daten übernehmen oder eigene Daten erfassen.\n" +
                "    </p>\n" +
                "\n" +
                "    <img src=\"images/example-payment-data.png\" alt=\"Beispielansicht\"\n" +
                "         style=\"border: 1px solid #9c9c9c; border-radius: 5px; max-width: 100%; margin-bottom: 10px;text-align: center\"><br>\n" +
                "\n" +
                "    <b class=\"modal-header\">Automatische Prüfung der Bankverbindung</b>\n" +
                "    <p class=\"modal-p\">\n" +
                "        Die in <strong>liftbase</strong> hinterlegte Bankverbindung wird bei jedem Beleg automatisch überprüft.\n" +
                "        Falls ein Beleg eine abweichende Bankverbindung enthält, werden Sie darauf hingewiesen.\n" +
                "    </p>\n" +
                "\n" +
                "    <p class=\"modal-p\"><strong>Ihre Vorteile:</strong></p>\n" +
                "    <ul>\n" +
                "        <li>Betrügerische Rechnungen mit gefälschter Bankverbindung zuverlässig erkennen</li>\n" +
                "        <li>Schnell feststellen, wenn Ihr Lieferunternehmen die Bank gewechselt hat</li>\n" +
                "    </ul>\n" +
                "</div>",
            "supplier_dialog_title": "Automatische Lieferunternehmen-Erkennung",
            "select_columns_btn": "Spalten auswählen",
            "export_to_datev_btn": "An DATEV übermitteln",
            "export_to_datev_csv_btn": "DATEV CSV Export",
            "export_to_ms365_btn": "An D365 übermitteln",
            "export_btn_incomplete_form_tooltip": "Bitte vervollständigen Sie die Rechnungsdaten.",
            "export_btn_send_to_clearing_tooltip": "Zur erneuten Übertragung an D365, bitte über Schritt \"Klärung\" erneut zur Buchhaltung schicken.",
            "export_error": "<b>Die Rechnung konnte nicht übermittelt werden</b>.<br>",
            "no_export_config_datev_tooltip": "Es wurde keine Verbindung zu <b>{export_name}</b> eingerichtet. <br>Für das gewählte Unternehmen <b>{client_name}</b> wurde in der Konfiguration kein DATEV-Mandant zugeordnet. <br>Wenden Sie sich ggf. an eine Person mit Administrations-Rechten, <br>um die Verbindung im Administrations-Bereich einzurichten.",
            "no_export_config_tooltip": "Es wurde keine Verbindung zu {export_name} eingerichtet.<br>Wenden Sie sich ggf. an eine Person mit Administrations-Rechten, <br>um die Verbindung im Administrations-Bereich einzurichten.",
            "confirm_before_leave_msg": "Ihre Rechnung wurde nicht gespeichert. Sind Sie sicher, dass Sie die Seite verlassen wollen?",
            "can_not_edit": "Ihnen fehlt die Berechtigung zu Bearbeitung der Daten. Bitte senden Sie die Rechnung über die Aktionen zur Klärung, um Änderungen an den Daten vorzunehmen.",
            "total_brutto_missing": "Bitte geben Sie das Gesamt-Brutto ein.",
            "total_brutto_zero": "Darf keinen Betrag von 0 {currency} enthalten.",
            "total_brutto_does_not_match_with_positions": "Gesamtbeträge müssen der Summe der Positionen entsprechen.",
            "total_brutto_difference": "Abweichung Gesamt\u00ADbetrag vs Einzel\u00ADpositionen: {value}",
            "combination_invalid": "Die Kombination aus Sachkonto, Kostenstelle und Profitcenter ist in D365 nicht zulässig.",
            "possible_combinations": "Mögliche Kombinationen",
            "current_combination": "Aktuelle Kombination",
            "combination": "Kombination",
            "total_invoiced": "Gesamtbetrag der Rechnungen",
            "total_expected_procurement": "Gesamtbestellwert",
            "total_expected_contract": "Gesamtvertragswert",
            "min_approval_one_person": "1 Person",
            "min_approval_qty": "{qty} verschiedenen Personen",
            "min_approval_error_msg": "Die Freigabe reicht für diese Rechnung nicht aus. Bitte fügen Sie eine weitere Person zur Freigabe hinzu. Diese Rechnung muss von <b>mindestens {min_approval_msg}</b> freigegeben werden.",
            "min_approval_error_title": "Freigabe nicht ausreichend",
            "no_approval_limit_msg": "Ihre Freigabegrenze reicht für diese Rechnung nicht aus. Bitte fügen Sie eine weitere Person zur Freigabe hinzu, welche eine ausreichende Freigabegrenze besitzt.",
            "no_approval_limit_title": "Freigabegrenze",
            "confirm_without_approval_limit_msg": "Keine, der gewählten Personen besitzt die notwendige Freigabegrenze für den Wert dieser Rechnung. Entsprechende Freigaben können später noch hinzugefügt werden. Sind Sie sicher, dass Sie fortfahren wollen?",
            "confirm_without_approval_limit_title": "Freigabegrenze",
            "invoice_vat_number": "Erkannte Umsatzsteuer-IDs",
            "supplier_vat_number": "USt-IdNr. in den Stammdaten",
            "business_partner_vat_number": "USt-IdNr. in den Stammdaten des Geschäftspartners",
            "copy_vat_number_to_supplier": "In die Stammdaten übernehmen",
            "supplier_payment_data": "Bankverbindung in den Stammdaten",
            "business_partner_payment_data": "Bankverbindung in den Stammdaten des Geschäftspartners",
            "invoice_payment_data": "Bankverbindung auf dem Beleg",
            "copy_payment_data_to_supplier": "Vom Beleg in die Stammdaten übernehmen",
            "copy_payment_data_to_supplier_tooltip": "Beim Klicken werden die im Formular angegebenen Zahlungsdaten in die Stammdaten des Lieferunternehmens übernommen.",
            "copy_payment_data_to_business_partner_tooltip": "Beim Klicken werden die im Formular angegebenen Zahlungsdaten in die Stammdaten des Geschäftspartners übernommen.",
            "magic_suggestions_btn_tooltip": "Ausfüllvorschläge basierend auf früheren Rechnungen desselben Lieferunternehmens",
            "magic_suggestions_btn_tooltip_business_partner": "Ausfüllvorschläge basierend auf früheren Rechnungen desselben Geschäftspartners",
            "magic_suggestions_dialog": {
                "title": "Vorschläge für diese Rechnung",
                "message": "Wählen Sie die Felder aus, die Sie auf Basis anderer Rechnungen dieses Lieferunternehmens übernehmen möchten.",
                "info_based_on_invoices": "Vorschläge basieren auf folgenden RE-Nummern:",
                "select_supplier_msg": "Bitte wählen Sie im Formular ein Lieferunternehmen aus, um Vorschläge zu laden.",
                "no_data": "Keine Vorschläge für dieses Lieferunternehmen gefunden.",
                "error_load": "Fehler beim Laden der Vorschläge.",
                "applied_success": "Vorschläge übernommen."
            },
            "magic_suggestions_dialog_business_partner": {
                "message": "Wählen Sie die Felder aus, die Sie auf Basis anderer Rechnungen dieses Geschäftspartners übernehmen möchten.",
                "select_supplier_msg": "Bitte wählen Sie im Formular einen Geschäftspartner aus, um Vorschläge zu laden.",
                "no_data": "Keine Vorschläge für diesen Geschäftspartner gefunden."
            },
            "procurement_summary": {
                "dialog_title": "Inhalt der Bestellanforderung",
                "open_dialog": "Details anzeigen",
                "line_count": "{count} Positionen im Überblick",
                "empty": "Für diese Bestellanforderung sind keine Positionen vorhanden.",
                "empty_filtered": "Für das ausgewählte Lieferunternehmen \"{supplier_name}\" wurden in der Bestellanforderung keine Positionen gefunden.",
                "filtered_by_supplier": "Es werden nur Positionen des Lieferunternehmens \"{supplier_name}\" angezeigt.",
                "item": "Position"
            },
            "lines": {
                "add_tooltip": "Rechnungsposition hinzufügen",
                "get_from_recognition": "Erkannte Positionen laden",
                "show_mismatch_panel_button": "Abweichungen anzeigen",
                "hide_mismatch_panel_button": "Abweichungen ausblenden",
                "mismatch_warning_title": "Abweichungen zwischen berechnetem und Beleg‑Brutto erkannt",
                "match_suggestion": "Vorschlag",
                "match_confirmed": "Bestätigt",
                "match_automatic": "Automatisch",
                "match_automatic_suggestion": "Autom. Vorschlag",
                "confirm_match": "Match bestätigen",
                "review_match": "Prüfen",
                "match_confirm_dialog": {
                    "title": "Positionszuordnung bestätigen",
                    "message": "Diese Positionen können ein Match sein. Bitte prüfen Sie die Werte und wählen Sie, wie die Zuordnung gespeichert werden soll.",
                    "copied_fields_title": "Weitere Daten, die übernommen werden",
                    "copy_hint": "Nur Zuordnung bestätigt den Bezug zur Bestellung. Daten übernehmen kopiert zusätzlich Kostenstelle, Sachkonto und Finanzdimensionen in die Rechnungsposition.",
                    "link_only_btn": "Nur Zuordnung bestätigen",
                    "copy_data_btn": "Zuordnung und Daten übernehmen"
                },
                "legend": {
                    "description": "Legende",
                    "no_order": "Artikel kommt in der Bestellung nicht vor.",
                    "variance": "Abweichung in markierten Spalten.",
                    "not_invoiced": "Bestellter Artikel wurde auf der Rechnung nicht gefunden.",
                    "matched": "Artikel auf Bestellung und Rechnung ist identisch."
                },
                "group_by_tax": "Nach Steuersatz gruppieren",
                "group_by_tax_hint": "Gespeicherte Positionen nach Steuersatz zusammenfassen (z. B.: Summe 19% Steuer).",
                "form": {
                    "item": "Artikel",
                    "new": "Neue Rechnungsposition",
                    "validation": {
                        "description_required": "Bitte geben Sie einen Namen ein.",
                        "item_number_required": "Bitte geben Sie eine Artikelnummer ein.",
                        "tax_percentage_required": "Bitte geben Sie eine gültige Steuer aus.",
                        "unit_net_price_required": "Bitte geben Sie eine gültige Nummer an.",
                        "quantity_required": "Bitte geben Sie eine gültige Nummer an.",
                        "commercial_discount_invalid": "Rabatt und Basisbetrag müssen dasselbe Vorzeichen haben, Prozentsätze müssen zwischen 0 % und 100 % liegen und Rabatte dürfen nicht höher als ihr Basisbetrag sein."
                    },
                    "tour": {
                        "name": "Geben Sie einen aussagekräftigen Namen für das Produkt an.",
                        "number": "Hier können Sie die Artikelnummer des Produkts erfassen.",
                        "price": "Geben Sie einen Steuersatz sowie einen Netto-Preis an. Der Brutto-Preis wird dann mit dem Steuersatz berechnet."
                    }
                },
                "table": {
                    "source": "Quelle",
                    "item_number": "Art. Nr.",
                    "name": "Name",
                    "quantity": "Anz.",
                    "tax": "Steuer (%)",
                    "netto_price": "Einzel-Netto",
                    "brutto_price": "Einzel-Brutto",
                    "line_discount_percentage": "Rabatt (%)",
                    "show_discounts": "Rabatt angeben",
                    "show_discounts_tooltip": "Zeigt die Felder für Preis- und Positionsrabatte an. Wird automatisch aktiviert, wenn ein Rabatt vorhanden ist.",
                    "unit_price_base_amount": "Einheitspreis vor Preisrabatt",
                    "unit_price_base_amount_tooltip": "Ursprünglicher Preis je Einheit, bevor ein Preisrabatt abgezogen wird.",
                    "unit_price_discount_amount": "Preisrabatt je Einheit",
                    "unit_price_discount_amount_tooltip": "Rabattbetrag je Einheit, der vom ursprünglichen Einheitspreis abgezogen wird.",
                    "line_discount_amount": "Positionsrabatt gesamt",
                    "line_discount_amount_tooltip": "Rabattbetrag für die gesamte Rechnungsposition, nicht je Einheit.",
                    "line_discount_base_amount": "Rabattbasis Position",
                    "line_discount_base_amount_tooltip": "Gesamtbetrag der Position, auf den der Positionsrabatt angewendet wird.",
                    "line_discount_percentage_tooltip": "Prozentsatz, der auf die gesamte Rechnungsposition angewendet wird.",
                    "total_netto_price": "Gesamt-Netto",
                    "tax_amount": "Gesamt-Steuer",
                    "total_brutto_price": "Gesamt-Brutto",
                    "calc_brutto_from_net": "Brutto aus Netto berechnen",
                    "calc_net_from_brutto": "Netto aus Brutto berechnen",
                    "calc_brutto_from_net_tooltip": "Berechnet nur den Einzel-Brutto-Preis aus Einzel-Netto und Steuersatz. Positionsrabatte werden nicht verändert.",
                    "calc_net_from_brutto_tooltip": "Berechnet nur den Einzel-Netto-Preis aus Einzel-Brutto und Steuersatz. Positionsrabatte werden nicht verändert.",
                    "discount_validation_error": "Bitte prüfen Sie die rot markierten Werte.",
                    "cost_center": "Kostenstelle",
                    "profit_center": "Profitcenter",
                    "ledger_account": "Sachkonto",
                    "tax_group": "Steuergruppe",
                    "tax_item_group": "Steuer-Artikelgruppe",
                    "open_bcase": "Dokument anzeigen",
                    "no_order_position": "Keine Bestellpositionen gefunden. Bitte ordnen Sie der Rechnung <b>eine BANF und ein Lieferunternehmen</b> zu.",
                    "no_contract_position": "Keine Vertragspositionen gefunden. Bitte ordnen Sie der Rechnung <b>einen Vertrag und ein Lieferunternehmen</b> zu.",
                    "copy_from_procurement": "Alle Artikel der Bestellung einfügen",
                    "copy_from_contract": "Alle Artikel des Vertrags einfügen",
                    "no_order_tooltip": "Noch keine Bestellanforderung verknüpft.",
                    "no_supplier_tooltip": "Noch kein Lieferunternehmen verknüpft.",
                    "validation_error": "Bitte korrigieren Sie die Fehler in der Tabelle."
                }
            },
            "export_dialog": {
                "title": {
                    "D365": "Journal erstellen",
                    "DATEV": "An DATEV übermitteln",
                    "DATEV CSV": "DATEV CSV Export"
                },
                "description": "Die folgenden Belege werden an {export_name} übermittelt.",
                "description_csv": "Die folgenden Belege werden für {export_name} exportiert.",
                "btn_confirm": "Übermitteln",
                "btn_confirm_csv": "Exportieren",
                "btn_finish": "Schließen",
                "export_feedback_csv": "Exportiert",
                "export_feedback": "Übermittelt",
                "exported_csv": "Exportiert",
                "exported": "Übermittelt",
                "continue_background": "Im Hintergrund fortfahren",
                "exported_at": "Zuletzt exportiert",
                "is_loading": "Übermittlung läuft",
                "is_loading_csv": "Exportierung läuft",
                "include_exported": "Bereits exportierte Rechnungen einbeziehen",
                "export_selected_invoices_btn": "Auswahl ({quantity}) an {export_name} senden",
                "export_cancelled_invoices_btn": "Ausgewählte stornierte ({quantity}) an {export_name} senden",
                "export_all_cancelled_invoices_btn": "Alle stornierten ({quantity}) an {export_name} senden",
                "export_all_invoices_btn": "Alle Belege ({quantity}) an {export_name} senden"
            },
            "export_menu": {
                "title": "Export",
                "group_ready": {
                    "title": "Export: Abgeschlossene Rechnungen"
                },
                "group_cancelled": {
                    "title": "Export: Stornierte Rechnungen"
                }
            },
            "bulk_cancel_dialog": {
                "selected_btn": {
                    "invoice": "Markierte Rechnungen ({quantity}) aussteuern",
                    "outgoing-invoice": "Markierte Ausgangsrechnungen ({quantity}) stornieren",
                    "procurement": "Markierte Bestellungen ({quantity}) stornieren",
                    "contract": "Markierte Verträge ({quantity}) stornieren",
                    "mixed": "Markierte Belege ({quantity}) stornieren"
                },
                "confirm_title": {
                    "invoice": "Rechnungen aussteuern",
                    "outgoing-invoice": "Ausgangsrechnungen stornieren",
                    "procurement": "Bestellungen stornieren",
                    "contract": "Verträge stornieren",
                    "mixed": "Belege stornieren"
                },
                "confirm_message": {
                    "invoice": "Möchten Sie wirklich alle markierten Rechnungen ({quantity}) aussteuern?",
                    "outgoing-invoice": "Möchten Sie wirklich alle markierten Ausgangsrechnungen ({quantity}) stornieren?",
                    "procurement": "Möchten Sie wirklich alle markierten Bestellungen ({quantity}) stornieren?",
                    "contract": "Möchten Sie wirklich alle markierten Verträge ({quantity}) stornieren?",
                    "mixed": "Möchten Sie wirklich alle markierten Belege ({quantity}) stornieren?"
                },
                "confirm_btn": {
                    "invoice": "Aussteuern",
                    "outgoing-invoice": "Stornieren",
                    "procurement": "Stornieren",
                    "contract": "Stornieren",
                    "mixed": "Stornieren"
                },
                "success": {
                    "invoice": "{quantity} Rechnungen wurden ausgesteuert.",
                    "outgoing-invoice": "{quantity} Ausgangsrechnungen wurden storniert.",
                    "procurement": "{quantity} Bestellungen wurden storniert.",
                    "contract": "{quantity} Verträge wurden storniert.",
                    "mixed": "{quantity} Belege wurden storniert."
                },
                "partial_success": {
                    "invoice": "{successCount} von {quantity} Rechnungen wurden ausgesteuert.",
                    "outgoing-invoice": "{successCount} von {quantity} Ausgangsrechnungen wurden storniert.",
                    "procurement": "{successCount} von {quantity} Bestellungen wurden storniert.",
                    "contract": "{successCount} von {quantity} Verträgen wurden storniert.",
                    "mixed": "{successCount} von {quantity} Belegen wurden storniert."
                },
                "error": {
                    "invoice": "Die markierten Rechnungen konnten nicht ausgesteuert werden.",
                    "outgoing-invoice": "Die markierten Ausgangsrechnungen konnten nicht storniert werden.",
                    "procurement": "Die markierten Bestellungen konnten nicht storniert werden.",
                    "contract": "Die markierten Verträge konnten nicht storniert werden.",
                    "mixed": "Die markierten Belege konnten nicht storniert werden."
                }
            },
            "bulk_repeat_recognition_dialog": {
                "bulk_repeat_recognition_selected_invoices_btn": "Belegerkennung wiederholen ({quantity})",
                "confirm_title": "Belegerkennung wiederholen",
                "confirm_message": "Die bestehenden Daten in den markierten Rechnungen ({quantity}) werden überschrieben. Sind Sie sicher, dass Sie fortfahren wollen?",
                "intro_message": "Die Belegerkennung für die ausgewählten Rechnungen ({quantity}) wird erneut gestartet. Bestehende Formulardaten können überschrieben werden.",
                "background_notice": "Sie können jetzt ausführen und auf das Feedback warten oder den Vorgang direkt im Hintergrund starten.",
                "run_now_btn": "Jetzt ausführen",
                "run_background_btn": "Im Hintergrund starten",
                "background_started": "Die Belegerkennung wurde für {quantity} Rechnungen im Hintergrund gestartet.",
                "success": "Die Belegerkennung wurde für {quantity} Rechnungen erneut gestartet.",
                "partial_success": "Die Belegerkennung wurde für {successCount} von {quantity} Rechnungen erneut gestartet.",
                "error": "Die Belegerkennung für die markierten Rechnungen konnte nicht erneut gestartet werden."
            },
            "select_columns_dialog": {
                "title": "Spalten auswählen",
                "select_fields": "Die folgenden Spalten werden unter <i>Meine Aufgaben</i> und <i>Alle Belege</i> angezeigt.",
                "btn_confirm": "Anwenden",
                "btn_finish": "Schließen",
            },
            "copy_procurement_dialog": {
                "title": "Daten übernehmen",
                "message": "Möchten Sie einige Daten der Bestellung in diese Rechnung übernehmen?",
                "message_contract": "Möchten Sie einige Daten des Vertrags in diese Rechnung übernehmen?",
                "overwrite_checkbox": "Die bestehenden Daten im Formular überschreiben.",
                "select_supplier_msg": "Wählen Sie aus, von welchem Lieferunternehmen Sie die Daten kopieren möchten:",
                "select_supplier_placeholder": "Lieferunternehmen auswählen",
                "confirm_btn": "Bestätigen"
            },
            "copy_from_recognition_dialog": {
                "title": "Daten übernehmen",
                "message": "Möchten Sie einige Daten aus der Rechnungserkennung oder dem Formular in dieses Lieferunternehmen übernehmen?",
                "add_payment_method": "Möchten Sie zusätzlich die Zahlungsart aktualisieren?",
                "select_iban": "Wählen Sie aus den gefundenen IBANs aus.",
                "select_vat_number": "Wählen Sie aus den gefundenen Umsatzsteuer-IDs aus.",
                "select_bic": "Wählen Sie aus den gefundenen BICs aus.",
                "success_msg": "Lieferunternehmen aktualisiert.",
                "confirm_btn": "Bestätigen"
            },
            "validation": {
                "invoice_date_required": "Bitte geben Sie ein Rechnungsdatum ein.",
                "due_date_required": "Bitte geben Sie eine Fälligkeit ein.",
                "due_date_invalid1": "Fälligkeitsdatum darf nicht vor dem Rechnungsdatum liegen.",
                "delivery_date_required": "Bitte geben Sie ein Leistungsdatum ein.",
                "ledger_account_required": "Bitte wählen Sie eine Sachkonto aus.",
                "branch_required": "Bitte wählen Sie eine Niederlassung aus.",
                "department_required": "Bitte wählen Sie eine Abteilung aus.",
                "posting_key_required": "Bitte wählen Sie einen Steuerschlüssel aus.",
                "document_discount_tax_required": "Wählen Sie für den Dokumentrabatt einen MwSt.-Satz aus, der in mindestens einer Rechnungsposition verwendet wird.",
                "supplier_required": "Bitte wählen Sie ein Lieferunternehmen aus.",
                "business_partner_required": "Bitte wählen Sie einen Geschäftspartner aus.",
                "cost_center_required": "Bitte wählen Sie eine Kostenstelle aus.",
                "cost_type_required": "Bitte wählen Sie eine Kostenart aus.",
                "profit_center_required": "Bitte wählen Sie eine Profitcenter aus.",
                "employee_required": "Bitte wählen Sie eine Mitarbeitende aus.",
                "d365_branch_id_required": "Bitte wählen Sie eine Niederlassung aus.",
                "d365_employee_id_required": "Bitte wählen Sie eine Mitarbeitende aus.",
                "d365_department_required": "Bitte wählen Sie eine D365 Abteilung aus.",
                "financial_dimension_required": "Bitte wählen Sie eine Finanzdimension aus.",
                "client_required": "Bitte wählen Sie ein Unternehmen aus.",
                "number_required": "Bitte geben Sie die Rechnungsnummer ein.",
                "prefix_required": "Bitte geben Sie das Präfix und die Rechnungsnummer ein.",
                "number_invalid_d365": "Darf höchstens 20 Zeichen enthalten.",
                "number_invalid": "Darf höchstens 36 Zahlen, Groß- und Kleinbuchstaben, keine Umlaute und die Zeichen $ % & * + - / enthalten.",
                "notes_length": "Darf höchstens 120 Zeichen enthalten.",
                "discount_percentage_invalid1": "Skontosatz muss größer als 0 sein.",
                "discount_percentage_invalid2": "Skonto 1 muss größer als Skonto 2 sein.",
                "discount_amount_invalid1": "Nur positives Skonto ist für positive Rechnungsbeträge zulässig.",
                "discount_amount_invalid2": "Nur negatives Skonto ist für negative Rechnungsbeträge zulässig.",
                "discount_amount_invalid3": "Skonto 1 muss größer als Skonto 2 sein.",
                "discount_amount_invalid4": "Skonto muss kleiner als der Gesamtbetrag sein.",
                "discount_amount_invalid5": "Die Summe der Skontobeträge muss kleiner als der Gesamtbetrag sein.",
                "discount_date_invalid1": "Skonto 1 und 2 müssen zw. Beleg- und Fälligkeitsdatum liegen.",
                "discount_date_invalid2": "Skonto 1 - Datum muss vor Skonto 2 - Datum liegen.",
                "missing_discount_field": "Alle Skonto-Felder müssen ausgefüllt sein.",
                "procurement_required": "Bitte wählen Sie eine Bestellanforderung aus.",
                "contract_required": "Bitte wählen Sie einen Vertrag aus.",
                "iban_required": "Bitte geben Sie eine IBAN ein.",
                "bank_country_required": "Bitte geben Sie ein Bank Land ein.",
                "bank_country_invalid": "Bitte geben Sie einen zweistelligen ISO-Ländercode ein.",
                "bank_account_required": "Bitte geben Sie eine Kontonummer ein.",
                "bank_code_required": "Bitte geben Sie eine Bankleitzahl ein.",
            }
        }
    },
    "outgoing_invoice": {
        "description": "Ausgangsrechnung",
        "page": {
            "upload": {
                "title": "Neue Ausgangsrechnungen hochladen"
            }
        }
    },
    "invoice_line": {
        "item_number": "Artikelnummer",
        "quantity": "Menge",
        "unit_net_price": "Netto-Preis",
        "tax_percentage": "Steuer",
        "has_discount": "Position hat einen Rabatt",
        "unit_price_base_amount": "Einzelpreis vor Rabatt (BT-148)",
        "unit_price_discount_amount": "Preisrabatt (BT-147)",
        "line_discount_amount": "Positionsrabatt (BT-136)",
        "line_discount_base_amount": "Basisbetrag Positionsrabatt (BT-137)",
        "line_discount_percentage": "Positionsrabatt % (BT-138)"
    },
    "location": {
        "name": "Name",
        "number": "Nummer",
        "address": "Anschrift",
        "form_sequence": "name,number,address"
    },
    "spreadsheet": {
        "add_row": "Neue Zeile",
        "download": "Tabelle herunterladen",
        "save": "Tabelle speichern"
    },
    "audit_log": {
        "description": "Bearbeitungen",
        "history": "Bearbeitungen",
        "table": "Tabelle",
        "lb_user_id": "Benutzer",
        "data_before": "Bevor",
        "data_after": "Nachher",
        "created_at": "Datum",
        "type": {
            "insert": "Hinzugefügt",
            "update": "Bearbeitet",
            "delete": "Entfernt"
        },
        "msg": {
            "deleted": "entfernt",
            "inserted": "hinzugefügt",
            "was_deleted": "Wurde entfernt.",
            "was_inserted": "Wurde hinzugefügt."
        },
        "none": "kein(e)",
        "empty": "Keine Bearbeitungen vorhanden."
    },
    "txt_before_leave_page": "Ihre Änderungen werden eventuell nicht gespeichert. Sind Sie sicher, dass Sie fortfahren wollen?",
    "easybill_invoice": {
        "from_tenant": "von Tenant",
        "no_invoice": "Noch keine Rechnung erstellt.",
        "number": "Nummer",
        "service_date": "Zeitraum",
        "from": "Vom",
        "until": "bis",
        "total": "Gesamt",
        "due_date": "Fälligkeit",
        "status": "Status",
        "paid_at": "Bezahlt am",
        "payment_missing": "Ausstehend",
        "sepa": "SEPA",
        "tour": {
            "invoice_table": "Hier sehen Sie eine detaillierte Übersicht über alle liftbase-Rechnungen inklusive Status. Die Rechnungen können über einen Button herunter geladen werden."
        }
    },
    "configuration": {
        "description": "Konfiguration",
        "sepa_number": "Gläubiger-Identifikationsnummer",
        "sepa_mandate_reference": "Mandatsreferenz",
        "remove_sepa_msg": "Sind Sie sicher, dass Sie die SEPA Lastschrift widerrufen wollen?",
        "remove_sepa_btn": "Widerrufen",
        "system-modules-procurement": "Module - Bestellanforderungen",
        "system-modules-invoice": "Module - Rechnungen",
        "system-modules-bank-statements": "Module - Kontoauszugsabgleich",
        "system-modules-permissions": "Module - Berechtigungsgruppen",
        "system-modules-multilingualism": "Module - Mehrsprachige Stammdaten",
        "system-modules-invoice-export": "Module - Rechnungsexport an",
        "purchaseorder-defaults-selectproduct": "Rollenvorbelegungen - Person „Produktauswahl“",
        "purchaseorder-defaults-sendorder": "Rollenvorbelegungen - Person „Beauftragung“",
        "purchaseorder-defaults-clearing": "Rollenvorbelegungen - Person „Klärung Einkauf“",
        "purchaseorder-defaults-consignee": "Rollenvorbelegungen - Person „Wareneingang“",
        "invoice-defaults-manual_check": "Rollenvorbelegungen - Person „Manuelle Prüfung (Rechnung)“",
        "invoice-defaults-clearing": "Rollenvorbelegungen - Person „Klärung Buchhaltung“",
        "purchaseorder-defaults-init_seq": "Bestellanforderungen - Bestellnummern ab",
        "purchaseorder-product-require_product_group": "Bestellanforderungen - Alle Produkte müssen einer Warengruppe zugeordnet sein-",
        "purchaseorder-product-require_product_selection": "Bestellanforderungen - Bestellanforderungsprozess",
        "email-send-order": "Bestellungen - E-Mail-Bestellung",
        "purchaseorder-pdf-free-text": "Bestellungen - Bestell-PDF",
        "type_email-send-order": "html-i18n",
        "type_purchaseorder-pdf-free-text": "html-i18n",
        "invoice-recognition-lines": "Rechnungen - Rechnungspositionen aus Belegerkennung automatisch erstellen.",
        "invoice-recognition-timeout": "Rechnungen - Timeout für Azure-Belegerkennung",
        "invoice-form-procurement-required": "Rechnungen - Verknüpfung der Bestellanforderung erforderlich.",
        "notifications-mail-interval": "Benachrichtigungen - E-Mail-Intervall in Minuten",
        "punchout-amazon-identity": "Integrationen - Punch-out Amazon - Identity",
        "punchout-amazon-secret": "Integrationen - Punch-out Amazon - Secret",
        "punchout-amazon-url": "Integrationen - Punch-out Amazon - Punch-out-URL",
        "punchout-amazon-order-url": "Integrationen - Punch-out Amazon - Bestell-URL",
        "punchout-amazon-email": "Integrationen - Punch-out Amazon - E-Mail",
        "punchout-amazon-supplier": "Integrationen - Punch-out Amazon - Standard-Lieferunternehmen",
        "punchout-mercateo-identity": "Integrationen - Punch-out Mercateo - Identity",
        "punchout-mercateo-secret": "Integrationen - Punch-out Mercateo - Secret",
        "punchout-mercateo-url": "Integrationen - Punch-out Mercateo - Punch-out-URL",
        "punchout-mercateo-order-url": "Integrationen - Punch-out Mercateo - Bestell-URL",
        "punchout-mercateo-email": "Integrationen - Punch-out Mercateo - E-Mail",
        "punchout-mercateo-supplier": "Integrationen - Punch-out Mercateo - Standard-Lieferunternehmen",
        "punchout-rajapack-identity": "Integrationen - Punch-out RAJA - Identity",
        "punchout-rajapack-secret": "Integrationen - Punch-out RAJA - Secret",
        "punchout-rajapack-url": "Integrationen - Punch-out RAJA - Punch-out-URL",
        "punchout-rajapack-order-url": "Integrationen - Punch-out RAJA - Bestell-URL",
        "punchout-rajapack-email": "Integrationen - Punch-out RAJA - E-Mail",
        "punchout-rajapack-supplier": "Integrationen - Punch-out RAJA - Standard-Lieferunternehmen",
        "punchout-conrad-identity": "Integrationen - Punch-out Conrad - Identity",
        "punchout-conrad-secret": "Integrationen - Punch-out Conrad - Secret",
        "punchout-conrad-url": "Integrationen - Punch-out Conrad - Punch-out-URL",
        "punchout-conrad-order-url": "Integrationen - Punch-out Conrad - Bestell-URL",
        "punchout-conrad-email": "Integrationen - Punch-out Conrad - E-Mail",
        "punchout-conrad-supplier": "Integrationen - Punch-out Conrad - Standard-Lieferunternehmen",
        "punchout-thgeyer-identity": "Integrationen - Punch-out TH.GEYER - Identity",
        "punchout-thgeyer-secret": "Integrationen - Punch-out TH.GEYER - Secret",
        "punchout-thgeyer-url": "Integrationen - Punch-out TH.GEYER - Punch-out-URL",
        "punchout-thgeyer-supplier": "Integrationen - Punch-out TH.GEYER - Standard-Lieferunternehmen",
        "punchout-reichelt-identity": "Integrationen - Punch-out Reichelt - Identity",
        "punchout-reichelt-secret": "Integrationen - Punch-out Reichelt - Secret",
        "punchout-reichelt-url": "Integrationen - Punch-out Reichelt - Punch-out-URL",
        "punchout-reichelt-supplier": "Integrationen - Punch-out Reichelt - Standard-Lieferunternehmen",
        "validation": {
            "bic_invalid": "Bitte geben Sie einen gültigen BIC ein.",
            "iban_invalid": "Bitte geben Sie eine gültige IBAN-Nummer ein.",
            "default_decimal_places_invalid": "Bitte 2 bis 4 Nachkommastellen angeben."
        },
        "datev": {
            "description": "DATEV",
            "connection": "Verbindung mit DATEV",
            "status_active": "aktiv",
            "status_inactive": "inaktiv",
            "from": "von",
            "until": "bis",
            "load_clients": "DATEV Unternehmen laden",
            "remove_connection": "Verbindung entfernen",
            "deactivate_connection": "Verbindung deaktivieren",
            "add_connection": "Verbindung aktivieren",
            "connected_by": "Verbindung von {name} ist hergestellt.",
            "apps_manager": "Hier können Sie die <a href=\"https://apps.datev.de/tokrevui\" target=\"_blank\">mit DATEV verbundenen Anwendungen</a> verwalten.",
            "no_client_found": "Keine DATEV Unternehmen gefunden.",
            "msg_no_clients": "Keine Einträge gefunden oder Sie haben keine nötigen Berechtigungen oder die Verbindung muss erneut eingerichtet werden.",
            "fiscal_year_start": "Geschäftsjahr",
            "account_length": "Kontolänge",
            "is_accounts_payable_ledger_available": "Rechnungseingang",
            "is_accounts_receivable_ledger_available": "Rechnungsausgang",
            "client_number": "Unternehmensnummer",
            "consultant_number": "Beraternummer",
            "client_name": "Unternehmen",
            "liftbase_client": "liftbase Unternehmen",
            "save_client": "Unternehmen speichern",
            "change_client": "Unternehmen ändern"
        },
        "ms365": {
            "description": "D365",
            "connection": "Verbindung mit D365",
            "status_active": "aktiv",
            "status_inactive": "inaktiv",
            "org_url": "Organisations-URL",
            "auth_type": "Authentifizierung",
            "oauth": "OAuth (Benutzerzustimmung)",
            "client_secret_auth": "Client Credentials (App Client ID + Secret)",
            "app_client_id": "App Client ID (Azure Application)",
            "app_tenant_id": "Azure Tenant ID",
            "client_secret": "Client Secret",
            "connect_and_load_data": "Verbindung einrichten und Daten laden",
            "connect": "Verbindung einrichten",
            "load_data": "Alle Daten laden",
            "remove_connection": "Verbindung entfernen",
            "add_connection": "Verbindung einrichten",
            "client_credentials_note": "Wenn App Client ID und Client Secret angegeben sind, wird für den Rechnungs-Export der Client-Credentials-Flow verwendet. Der E-Mail-Import bleibt unverändert (OAuth).",
            "last_sync_at": "Letzte Synchronisierung: {last_sync_at}",
            "no_client_found": "Keine D365 Mandanten wurden gefunden.",
            "msg_no_clients": "Keine Einträge gefunden oder Sie haben keine nötigen Berechtigungen oder die Verbindung muss erneut eingerichtet werden.",
            "client_number": "D365 Unternehmennummer",
            "client_name": "D365 Unternehmen",
            "liftbase_client": "liftbase Unternehmen",
            "save_client": "Unternehmen speichern",
            "change_client": "Unternehmen ändern",
            "sync_running": "Die Daten werden geladen. Der Vorgang kann einige Minuten dauern.",
            "journal_name": "Journal Name",
            "http_read_timeout": {
                "label": "HTTP-Read-Timeout für D365",
                "hint": "Legt fest, wie lange liftbase bei D365-Anfragen auf eine Antwort wartet. Leer lassen, um die globale Backend-Konfiguration zu verwenden. Beispiele: <b>420s</b>, <b>5m</b>, <b>1h</b>.",
                "error": "Bitte einen positiven Timeout angeben, z. B. 420s, 5m oder 1h."
            }
        },
        "datev-csv": {
            "description": "DATEV CSV"
        },
        "template": {
            "module-procurement": {
                "group": "Module",
                "label": "Bestellanforderungen",
                "tour": [
                    {
                        "target": ".step-modules",
                        "content": "<p>Bitte wählen die liftbase Module aus, die Sie aktivieren möchten. Informationen zu den Kosten finden Sie auf <a href=\"liftbase.de/preise\" target=\"_blank\">liftbase.de/preise</a>.</p>"
                    }
                ]
            },
            "module-invoice": {
                "group": "Module",
                "label": "Rechnungen"
            },
            "module-outgoing-invoice": {
                "group": "Module",
                "label": "Ausgangsrechnungen"
            },
            "module-bank-statements": {
                "group": "Module",
                "label": "Kontoauszugsabgleich"
            },
            "module-contract": {
                "group": "Module",
                "label": "Verträge"
            },
            "module-permissions": {
                "group": "Module",
                "label": "Berechtigungsgruppen"
            },
            "module-multilingualism": {
                "group": "Module",
                "label": "Mehrsprachige Stammdaten"
            },
            "module-supplier-communication": {
                "group": "Module",
                "label": "Lieferantenkommunikation"
            },
            "module-liquidity-planning": {
                "group": "Module",
                "label": "Liquiditätsplanung"
            },
            "insolvency-law-fields": {
                "group": "Module",
                "label": "Insolvenzrechtlich Felder anzeigen"
            },
            "approval-limit-priority": {
                "group": "Module",
                "label": "Freigabe-Priorität"
            },
            "custom-fields": {
                "group": "Module",
                "label": "Benutzerdefinierte Felder"
            },
            "module-invoice-export": {
                "group": "Module",
                "label": "Rechnungsexport an",
                "options": [
                    {
                        "value": "datev",
                        "content": "DATEV"
                    },
                    {
                        "value": "ms365",
                        "content": "D365"
                    },
                    {
                        "value": "datev-csv",
                        "content": "DATEV CSV"
                    }
                ]
            },
            "procurement-select-product": {
                "group": "Rollenvorbelegungen",
                "label": "Person „Produktauswahl“",
                "tour": [
                    {
                        "target": ".step-assignment",
                        "content": "<p>Hier können globale Rollenvorbelegungen hinterlegt werden. Sind keine Rollenvorbelegungen auf Ebene des Unternehmens oder der Abteilung definiert, übernehmen die hier eingetragenen Personen die jeweiligen Schritte im Ablauf der Bestellanforderungen und Rechnungen.</p>"
                    }
                ]
            },
            "procurement-send-order": {
                "group": "Rollenvorbelegungen",
                "label": "Person „Beauftragung“"
            },
            "procurement-clearing": {
                "group": "Rollenvorbelegungen",
                "label": "Person „Klärung Einkauf“",
                "hint": "Für die Klärung in Bestellabläufen."
            },
            "procurement-consignee": {
                "group": "Rollenvorbelegungen",
                "label": "Person „Wareneingang“"
            },
            "invoice-manual-check": {
                "group": "Rollenvorbelegungen",
                "label": "Person „Manuelle Prüfung (Rechnung)“"
            },
            "invoice-clearing": {
                "group": "Rollenvorbelegungen",
                "label": "Person „Klärung Buchhaltung“",
                "hint": "Für die Klärung während der Rechnungsablage."
            },
            "contract-clearing": {
                "group": "Rollenvorbelegungen",
                "label": "Person „Klärung Vertrag“",
                "hint": "Für die Klärung in Vertragsabläufen"
            },
            "procurement-init-seq": {
                "group": "Bestellanforderungen",
                "label": "Bestellnummern ab",
                "hint": "Geben Sie hier eine Zahl an, ab der die Bestellnummern starten sollen.",
                "validation": {
                    "interval": "Muss zwischen 0 und 999999999 liegen.",
                    "type": "Darf nur ganze Zahlen enthalten."
                },
                "tour": [
                    {
                        "target": ".step-procurement",
                        "content": "Hier finden Sie Einstellungen an den Bestellanforderungen. Stellen Sie z.B. ein mit welcher Nummer die Bestellanforderungen starten sollen und ob alle Produkte in den Bestellanforderungen einer Warengruppe zugeordnet werden müssen."
                    }
                ]
            },
            "procurement-require-product-group": {
                "group": "Bestellanforderungen",
                "label": "Alle Produkte müssen einer Warengruppe zugeordnet sein."
            },
            "procurement-skip-place-order": {
                "group": "Bestellanforderungen",
                "label": "Automatische Übermittlung der Bestellung an den Online-Shop",
                "hint": "Nach dem PunchOut wartet der Online-Shop auf die Freigabe im Bestellsystem. Ohne diese Option muss die Übermittlung manuell über den Button „Elektronisch übermitteln“ gestartet werden. Mit dieser Option wird die Bestellung nach der Freigabe automatisch elektronisch übermittelt. Funktioniert nur für Bestellungen mit einem einzigen Lieferunternehmen."
            },
            "procurement-require-product-selection": {
                "group": "Bestellanforderungen",
                "label": "Bestellanforderungsprozess ",
                "options": [
                    {
                        "value": "true",
                        "content": "mit Produktauswahl<br><ul><li>BANF erfassen</li><li>Produktauswahl</li><li>Freigabe</li><li>Beauftragung</li><li>Wareneingang</li></ul>"
                    },
                    {
                        "value": "false",
                        "content": "ohne Produktauswahl<br><ul><li>BANF erfassen</li><li>Freigabe</li><li>Beauftragung</li><li>Wareneingang</li></ul>"
                    }
                ]
            },
            "email-send-order": {
                "group": "Bestellungen",
                "label": "E-Mail-Bestellung",
                "hint": "E-Mail-Anschreiben, welches im Schritt der Beauftragung inklusive der Bestell-PDF generiert und an das Lieferunternehmen gesendet werden kann.",
                "default_value": "Sehr geehrte Damen und Herren,<br>anbei sende ich Ihnen unsere Bestellung als PDF. Bitte senden Sie uns eine Auftragsbestätigung zu.",
                "tour": [
                    {
                        "target": ".step-email-order-free-text",
                        "content": "Verfassen Sie hier einen Text, welcher in dem E-Mail-Anschreiben abgebildet wird, welches im Schritt der Beauftragung inklusive der Bestell-PDF generiert und an das Lieferunternehmen gesendet werden kann."
                    },
                    {
                        "target": ".step-pdf-free-text",
                        "content": "Verfassen Sie hier einen Text, welcher im Schritt der Beauftragung auf der generierten Bestell-PDF abgebildet wird, die anschließend an das Lieferunternehmen gesendet werden kann."
                    }
                ]
            },
            "procurement-pdf-free-text": {
                "group": "Bestellungen",
                "label": "Bestell-PDF",
                "hint": "Anschreiben, welches im Schritt der Beauftragung auf der generierten Bestell-PDF abgebildet wird, die anschließend an das Lieferunternehmen gesendet werden kann.",
                "default_value": ""
            },
            "procurement-pdf-show-department": {
                "group": "Bestellungen",
                "label": "Abteilung im Bestell-PDF anzeigen"
            },
            "procurement-pdf-show-cost-center": {
                "group": "Bestellungen",
                "label": "Kostenstelle im Bestell-PDF anzeigen"
            },
            "procurement-pdf-show-created-by": {
                "group": "Bestellungen",
                "label": "Erstellt von im Bestell-PDF anzeigen"
            },
            "procurement-pdf-show-approver": {
                "group": "Bestellungen",
                "label": "Freigeber im Bestell-PDF anzeigen"
            },
            "procurement-pdf-show-offer": {
                "group": "Bestellungen",
                "label": "Angebot in Positionsliste anzeigen"
            },
            "procurement-pdf-show-vat-number": {
                "group": "Bestellungen",
                "label": "USt-IdNr. im Bestell-PDF anzeigen"
            },
            "invoice-recognition-lines": {
                "group": "Rechnungen",
                "label": "Rechnungspositionen aus Belegerkennung automatisch erstellen."
            },
            "invoice-recognition-group-by-tax": {
                "group": "Rechnungen",
                "label": "Erkannte Rechnungspositionen nach Steuersatz gruppieren",
                "hint": "Wenn aktiviert, werden erkannte Positionen nach Steuersatz zusammengefasst (z. B.: Summe 19% Steuer)."
            },
            "invoice-recognition-ai-validation-mode": {
                "group": "Rechnungen",
                "label": "Standardmodus für KI-Validierung beim Rechnungsupload",
                "hint": "Dieser Modus ist beim Upload vorausgewählt und kann vor dem Erstellen der Rechnung geändert werden.",
                "options": [
                    {
                        "value": "none",
                        "content": "Keine KI-Validierung"
                    },
                    {
                        "value": "advisory",
                        "content": "Aktivieren, Status unverändert lassen"
                    },
                    {
                        "value": "ready-for-export",
                        "content": "Aktivieren und zu „Bereit zum Export“ schieben"
                    }
                ]
            },
            "invoice-recognition-custom-fields": {
                "group": "Rechnungen",
                "label": "Benutzerdefinierte Felder bei Azure-Erkennung extrahieren",
                "hint": "Wenn aktiviert, senden wir queryFields (basierend auf Ihren Custom Fields) an Azure Document Intelligence, um Werte zu extrahieren. Dies kann die Verarbeitungskosten erhöhen."
            },
            "invoice-recognition-custom-prompt": {
                "group": "Rechnungen",
                "label": "Globaler Custom Prompt für die Belegerkennung",
                "hint": "Diese Anweisungen werden für die Belegerkennung des Tenants angewendet und mit Custom Prompts für Unternehmen oder Lieferunternehmen kombiniert."
            },
            "invoice-recognition-model": {
                "group": "Rechnungen",
                "label": "Azure Belegerkennung – Modell",
                "options": [
                    {
                        "value": "document-intelligence",
                        "content": "Azure Document Intelligence (klassisch)"
                    },
                    {
                        "value": "content-understanding",
                        "content": "Azure Content Understanding (GenAI)"
                    },
                    {
                        "value": "azure-open-ai",
                        "content": "Azure OpenAI Responses API"
                    }
                ]
            },
            "invoice-recognition-timeout": {
                "group": "Rechnungen",
                "label": "Timeout pro Azure-Region für die Belegerkennung",
                "hint": "Legt fest, wie lange liftbase eine Azure-Region abfragt, bevor zur nächsten konfigurierten Region gewechselt wird. Standard: <b>150s</b>. Beispiele: <b>150s</b>, <b>5m</b>, <b>1h</b>.",
                "validation": {
                    "format": "Bitte eine Dauer wie 150s, 5m oder 1h eingeben."
                }
            },
            "invoice-procurement-required": {
                "group": "Rechnungen",
                "label": "Verknüpfung der Bestellanforderung oder des Vertrags erforderlich.",
            },
            "invoice-approval": {
                "group": "Rechnungen",
                "label": "Wann soll eine Rechnung freigegeben werden?",
                "options": [
                    {
                        "value": "always",
                        "content": "<b>Immer</b><br>Rechnungen müssen in jedem Fall freigegeben werden."
                    },
                    {
                        "value": "if-no-order",
                        "content": "<b>Nur, wenn weder eine BE noch ein VT zugeordnet ist</b><br>Eine Freigabe ist nur erforderlich, wenn weder eine Bestellanforderung (BE) noch ein Vertrag (VT) vorhanden ist."
                    },
                    {
                        "value": "never",
                        "content": "<b>Nie</b><br>Rechnungen benötigen keine separate Freigabe."
                    }
                ]
            },
            "notifications-mail-interval": {
                "group": "Benachrichtigungen",
                "label": "E-Mail-Intervall in Minuten",
                "tour": [
                    {
                        "target": ".step-notification",
                        "content": "Stellen Sie hier global ein, wie oft Personen maximal über neue Aufgaben per E-Mail informiert werden sollen. E-Mail-Benachrichtigungen werden nur gesendet, wenn eine Person eine neue Aufgabe erhalten hat."
                    }
                ]
            },
            "product-default-tax": {
                "group": "Artikel",
                "label": "Standard-Steuersatz (%)"
            },
            "product-default-currency": {
                "group": "Artikel",
                "label": "Standardwährung"
            },
            "product-default-unit": {
                "group": "Artikel",
                "label": "Standardeinheit"
            },
            "punchout-amazon-identity": {
                "group": "Integrationen",
                "subgroup": "Punch-out Amazon",
                "label": "Identity",
                "tour": [
                    {
                        "target": ".step-punchout-amazon",
                        "content": "Hier können Sie Ihren Zugang zu integrierten Marktplätzen wie Amazon und Mercateo einrichten. Eine Anleitung dazu finden Sie <a href=\"https://liftbase.de/handbuch/einrichtung/punch-out\" target=\"_blank\">in unserem Handbuch</a>."
                    }
                ]
            },
            "punchout-amazon-secret": {
                "group": "Integrationen",
                "subgroup": "Punch-out Amazon",
                "label": "Secret"
            },
            "punchout-amazon-url": {
                "group": "Integrationen",
                "subgroup": "Punch-out Amazon",
                "label": "Punch-out-URL"
            },
            "punchout-amazon-order-url": {
                "group": "Integrationen",
                "subgroup": "Punch-out Amazon",
                "label": "Bestell-URL"
            },
            "punchout-amazon-email": {
                "group": "Integrationen",
                "subgroup": "Punch-out Amazon",
                "label": "E-Mail",
                "hint": "Die E-Mail-Adresse des Amazon-Hauptaccounts. <br>Leer lassen, um E-Mail-Adresse der angemeldeten Person zu übermitteln. <br>Erfordert ggf. Amazon-Account pro Person."
            },
            "punchout-amazon-supplier": {
                "group": "Integrationen",
                "subgroup": "Punch-out Amazon",
                "label": "Standard-Lieferunternehmen",
                "hint": "Zu welchem Lieferunternehmen sollen Bestellungen dieses Punch-out Anbieters zugeordnet werden (z. B. in Auswertungen)?"
            },
            "punchout-mercateo-identity": {
                "group": "Integrationen",
                "subgroup": "Punch-out Mercateo",
                "label": "Identity"
            },
            "punchout-mercateo-secret": {
                "group": "Integrationen",
                "subgroup": "Punch-out Mercateo",
                "label": "Secret"
            },
            "punchout-mercateo-url": {
                "group": "Integrationen",
                "subgroup": "Punch-out Mercateo",
                "label": "Punch-out-URL"
            },
            "punchout-mercateo-order-url": {
                "group": "Integrationen",
                "subgroup": "Punch-out Mercateo",
                "label": "Bestell-URL"
            },
            "punchout-mercateo-email": {
                "group": "Integrationen",
                "subgroup": "Punch-out Mercateo",
                "label": "E-Mail",
                "hint": "Die E-Mail-Adresse des Mercateo-Hauptaccounts. <br>Leer lassen, um E-Mail-Adresse der angemeldeten Person zu übermitteln. <br>Erfordert ggf. Mercateo-Account pro Person."
            },
            "punchout-mercateo-supplier": {
                "group": "Integrationen",
                "subgroup": "Punch-out Mercateo",
                "label": "Standard-Lieferunternehmen",
                "hint": "Zu welchem Lieferunternehmen sollen Bestellungen dieses Punch-out Anbieters zugeordnet werden (z. B. in Auswertungen)?"
            },
            "punchout-rajapack-identity": {
                "group": "Integrationen",
                "subgroup": "Punch-out RAJA",
                "label": "Identity"
            },
            "punchout-rajapack-secret": {
                "group": "Integrationen",
                "subgroup": "Punch-out RAJA",
                "label": "Secret"
            },
            "punchout-rajapack-url": {
                "group": "Integrationen",
                "subgroup": "Punch-out RAJA",
                "label": "Punch-out-URL"
            },
            "punchout-rajapack-order-url": {
                "group": "Integrationen",
                "subgroup": "Punch-out RAJA",
                "label": "Bestell-URL"
            },
            "punchout-rajapack-email": {
                "group": "Integrationen",
                "subgroup": "Punch-out RAJA",
                "label": "E-Mail"
            },
            "punchout-rajapack-supplier": {
                "group": "Integrationen",
                "subgroup": "Punch-out RAJA",
                "label": "Standard-Lieferunternehmen",
                "hint": "Zu welchem Lieferunternehmen sollen Bestellungen dieses Punch-out Anbieters zugeordnet werden (z. B. in Auswertungen)?"
            },
            "punchout-conrad-identity": {
                "group": "Integrationen",
                "subgroup": "Punch-out Conrad",
                "label": "Identity"
            },
            "punchout-conrad-secret": {
                "group": "Integrationen",
                "subgroup": "Punch-out Conrad",
                "label": "Secret"
            },
            "punchout-conrad-url": {
                "group": "Integrationen",
                "subgroup": "Punch-out Conrad",
                "label": "Punch-out-URL"
            },
            "punchout-conrad-order-url": {
                "group": "Integrationen",
                "subgroup": "Punch-out Conrad",
                "label": "Bestell-URL"
            },
            "punchout-conrad-email": {
                "group": "Integrationen",
                "subgroup": "Punch-out Conrad",
                "label": "E-Mail"
            },
            "punchout-conrad-supplier": {
                "group": "Integrationen",
                "subgroup": "Punch-out Conrad",
                "label": "Standard-Lieferunternehmen",
                "hint": "Zu welchem Lieferunternehmen sollen Bestellungen dieses Punch-out Anbieters zugeordnet werden (z. B. in Auswertungen)?"
            },
            "punchout-thgeyer-identity": {
                "group": "Integrationen",
                "subgroup": "Punch-out TH.GEYER",
                "label": "Identity"
            },
            "punchout-thgeyer-secret": {
                "group": "Integrationen",
                "subgroup": "Punch-out TH.GEYER",
                "label": "Secret"
            },
            "punchout-thgeyer-url": {
                "group": "Integrationen",
                "subgroup": "Punch-out TH.GEYER",
                "label": "Punch-out-URL"
            },
            "punchout-thgeyer-supplier": {
                "group": "Integrationen",
                "subgroup": "Punch-out TH.GEYER",
                "label": "Standard-Lieferunternehmen",
                "hint": "Zu welchem Lieferunternehmen sollen Bestellungen dieses Punch-out Anbieters zugeordnet werden (z. B. in Auswertungen)?"
            },
            "punchout-reichelt-identity": {
                "group": "Integrationen",
                "subgroup": "Punch-out Reichelt",
                "label": "Identity"
            },
            "punchout-reichelt-secret": {
                "group": "Integrationen",
                "subgroup": "Punch-out Reichelt",
                "label": "Secret"
            },
            "punchout-reichelt-url": {
                "group": "Integrationen",
                "subgroup": "Punch-out Reichelt",
                "label": "Punch-out-URL"
            },
            "punchout-reichelt-supplier": {
                "group": "Integrationen",
                "subgroup": "Punch-out Reichelt",
                "label": "Standard-Lieferunternehmen",
                "hint": "Zu welchem Lieferunternehmen sollen Bestellungen dieses Punch-out Anbieters zugeordnet werden (z. B. in Auswertungen)?"
            },
            "tour": [
                {
                    "target": "",
                    "content": ""
                }
            ]
        },
        "tour": {
            "tab_general": "Hier kann der Name Ihres Unternehmens für die liftbase-Umgebung angegeben werden.",
            "tab_contact": "Geben Sie hier die Kontaktdaten Ihres Unternehmens an. Die Daten werden z.B. für die Aus- und Zustellung der Rechnungen für die liftbase-Nutzung benötigt.",
            "tab_bank": "Hier können Sie für die Abrechnung von liftbase eine SEPA-Lastschrift hinterlegen und ggf. widerrufen.",
            "tab_datev": "Hier können Sie die Integration mit DATEV einrichten. Melden Sie sich zuerst bei DATEV an, um alle verfügbaren Unternehmen zu laden. Anschließend ordnen Sie den Unternehmen aus DATEV ein Unternehmen aus liftbase zu und stellen die Verbindung für jedes Unternehmen einzeln her, um den Export zu ermöglichen. Die Verbindung der Unternehmen hat eine Gültigkeit von 2 Jahren und verlängert sich jedes Mal, wenn sie für einen Export verwendet wird.",
            "tab_marketplaces": "Hier können Sie Ihren Zugang zu integrierten Marktplätzen wie Amazon und Mercateo einrichten. Eine Anleitung dazu finden Sie <a href=\"https://liftbase.de/handbuch/einrichtung/punch-out\" target=\"_blank\">in unserem Handbuch</a>."
        }
    },
    "error_title": "Fehler",
    "request_error": "Fehler beim ausführen der Anfrage. Bitte prüfen Sie Ihre Internet-Verbindung oder versuchen Sie es später erneut.",
    "saved_success": "Das Dokument wurde gespeichert.",
    "duplicate_exists_check_records": "Ein identischer Datensatz existiert bereits. Der Eintrag wurde nicht erstellt. Bitte prüfen Sie Ihre Stammdaten.",
    "save_error": "Es ist ein Fehler beim Speichern aufgetreten.",
    "help_page": {
        "title": "Hilfe",
        "popup_feedback_msg": "Ihr Browser ist richtig eingerichtet. Sie können dieses Fenster jetzt schließen.",
        "punchout_error_msg": "Es ist ein Fehler aufgetreten. Bitte prüfen Sie die Punch-out-Konfigurationen oder wenden sich an eine Person mit Administratorenrechten.",
        "popup_did_not_open": "Wurde soeben kein neues Fenster geöffnet, sind Pop-ups in Ihrem Browser blockiert. Es kann daher bei der Anwendung zu Einschränkungen kommen.",
        "test_email_msg": "Es sollte sich ein E-Mail-Programm oder eine Liste zur Auswahl von Programmen geöffnet haben. Richten Sie sich ggf. ein E-Mail-Programm ein, welches Sie in der Liste auswählen können.",
        "tour_restart": "Die Tour wurde neu gestartet.",
        "manual_title": "Handbuch",
        "manual_msg": "<p>Im Handbuch finden Sie verschiedene Artikel und Anleitungen über die Verwendung und Einrichtung von liftbase.</p>",
        "manual_open_btn": "Handbuch öffnen",
        "function_title": "Testfunktionen",
        "popup_msg": "<p>Hier können Sie testen, ob in Ihrem Browser Pop-up-Fenster zugelassen sind, die für Ihre Produktauswahl bei den externen Marktplätzen benötigt werden.</p>",
        "popup_test_btn": "Pop-up-Blocker testen",
        "email_msg": "<p>Hier können Sie testen, ob Sie E-Mails mit einem E-Mail-Programm öffnen können. Die E-Mail-Funktion wird z. B. verwendet, um Bestellungen an Lieferunternehmen zu senden.</p>",
        "email_test_btn": "E-Mail-Funktion testen",
        "tour_title": "Tour",
        "tour_msg": "<p>Um eine erneute Einführung in liftbase zu erhalten, können Sie hier die Tour neu starten.</p>",
        "tour_btn": "Neu starten"
    },
    "dashboard_page": {
        "no_permission": "Sie haben keine Berechtigung für das Dashboard.",
        "no_option": "Kein",
        "title": "Dashboard",
        "date_picker": {
            "start_placeholder": "Startdatum",
            "end_placeholder": "Startdatum",
            "separator": "bis"
        },
        "ai": {
            "title": "AI-Statistiken",
            "menu_title": "AI-Stats",
            "add_widget": "Neues Widget hinzufügen",
            "prompt_placeholder": "Beschreiben Sie das gewünschte Diagramm (z. B. Zeige Bestellungen pro Tag)",
            "empty_state": "Keine Widgets vorhanden. Fügen Sie eines mit einem Prompt hinzu.",
            "remove": "Entfernen",
            "limits_info": "Sie können nur Gesamtsummen der Belege (Bestellung, Rechnung, Vertrag) anfragen – entweder als ANZAHL oder als WERT – aggregiert nach einer Zeiteinheit (Tag, Monat usw.). Die KI liefert generische Felder (time und value) sowie Metadaten, damit das Diagramm generisch gerendert werden kann.",
            "edit_label_title": "Widget-Beschreibung bearbeiten",
            "edit_label_message": "Es wird nur die Beschreibung/der Titel auf der Karte geändert. Abfrage und Diagramm bleiben unverändert.",
            "chart_type": {
                "bar": "Balken",
                "line": "Linie",
                "pie": "Torte"
            },
            "date_picker": {
                "required": "Zeitraum ist erforderlich"
            },
            "loading": {
                "adding_widget": "Widget wird hinzugefügt…",
                "refresh_widget": "Aktualisieren…",
                "refresh_all": "Alle Widgets werden aktualisiert…"
            },
            "errors": {
                "create_failed": "Widget konnte nicht erstellt werden.",
                "render_failed": "Diagramm konnte nicht gerendert werden."
            }
        },
        "hub": {
            "title": "Alle Dashboards an einem Ort",
            "subtitle": "Diese Übersicht ist der zentrale Einstieg für Procurement, Eingangsrechnungen, Ausgangsrechnungen, E‑Rechnung und AI.",
            "procurement_title": "Procurement Dashboard",
            "procurement_description": "Bestehende Einkaufsdiagramme, Budgets und Ausgabenanalysen.",
            "einvoice_title": "E‑Rechnung Dashboard",
            "einvoice_description": "Lieferantenquote, Risiko und Analyse elektronischer Rechnungsformate.",
            "invoice_title": "Eingangsrechnungsdashboard",
            "invoice_description": "Auswertungen für echte Eingangsrechnungen auf Basis Ihrer aktuellen Filter.",
            "outgoing_invoice_title": "Ausgangsrechnungsdashboard",
            "outgoing_invoice_description": "Auswertungen für echte Ausgangsrechnungen auf Basis Ihrer aktuellen Filter.",
            "supplier_title": "Lieferanten-Dashboard",
            "supplier_description": "Vogelperspektive auf Lieferunternehmen, Ausgaben, Bestellungen, Rechnungen und Kommunikation.",
            "ai_description": "Dynamische AI-Diagramme auf Basis promptgesteuerter Widgets.",
            "demo_badge": "Testversion"
        },
        "supplier": {
            "menu_title": "Lieferanten-Dashboard",
            "eyebrow": "Einkaufsassistent",
            "title": "Lieferanten-Dashboard",
            "subtitle": "Wählen Sie ein Lieferunternehmen aus und sehen Sie Ausgaben, Bestellungen, Rechnungen, SupplierConnect-E-Mails und eine automatische KI-Zusammenfassung.",
            "selected_supplier": "Ausgewähltes Lieferunternehmen",
            "change_supplier": "Lieferunternehmen wechseln",
            "top_suppliers_title": "Top 10 Lieferunternehmen",
            "top_suppliers_subtitle": "Die meistgenutzten Lieferunternehmen im gewählten Zeitraum und im sichtbaren Berechtigungsbereich.",
            "top_supplier_spend": "{amount} netto",
            "empty_top_suppliers": "Keine Lieferunternehmen im gewählten Zeitraum gefunden.",
            "orders": "Bestellungen",
            "invoices": "Rechnungen",
            "total_spend": "Ausgaben",
            "total_spend_hint": "Summe sichtbarer Eingangsrechnungen im Zeitraum",
            "procurement_value": "Bestellwert",
            "procurement_value_hint": "Summe sichtbarer Bestellungen im Zeitraum",
            "order_count": "Bestellungen",
            "order_count_hint": "Sichtbare Bestellungen im Zeitraum",
            "invoice_count": "Rechnungen",
            "invoice_count_hint": "Sichtbare Eingangsrechnungen im Zeitraum",
            "email_count": "E-Mails",
            "email_count_hint": "SupplierConnect-Kommunikation und importierte E-Mails aus sichtbaren Belegen",
            "ai_summary_title": "KI-Zusammenfassung",
            "ai_summary_subtitle": "Automatisch aus den sichtbaren Bestellungen, Rechnungen und SupplierConnect-E-Mails erzeugt.",
            "ai_summary_loading": "KI analysiert",
            "ai_summary_empty": "Keine belastbare KI-Zusammenfassung verfügbar.",
            "ai_section_titles": {
                "highlights": "Besonderheiten",
                "disputes": "Streitpunkte und Risiken",
                "agreements": "Sondervereinbarungen",
                "next_steps": "Nächste Schritte",
                "general": "Zusammenfassung"
            },
            "ai_summary_disabled": "KI ist für Ihren Mandanten deaktiviert. Aktivieren Sie KI in den Mandanteneinstellungen, um automatische Zusammenfassungen zu erhalten.",
            "refresh_ai_summary": "Zusammenfassung aktualisieren",
            "charts_title": "Ausgaben und Belege",
            "charts_subtitle": "Monatliche Entwicklung von Ausgaben, Bestellungen und Rechnungen im aktuellen Zeitraum.",
            "spend_chart_title": "Ausgaben pro Monat",
            "document_chart_title": "Bestellungen und Rechnungen pro Monat",
            "spend_mix_chart_title": "Ausgaben nach Belegart",
            "status_chart_title": "Belege nach Status",
            "invoice_spend_chart_title": "Rechnungsausgaben pro Monat",
            "procurement_spend_chart_title": "Bestellwert pro Monat",
            "invoice_count_chart_title": "Rechnungen pro Monat",
            "procurement_count_chart_title": "Bestellungen pro Monat",
            "invoice_status_chart_title": "Rechnungen nach Status",
            "procurement_status_chart_title": "Bestellungen nach Status",
            "procurements_title": "Bestellungen",
            "procurements_subtitle": "Sichtbare Bestellungen zu diesem Lieferunternehmen.",
            "invoices_title": "Rechnungen",
            "invoices_subtitle": "Sichtbare Eingangsrechnungen zu diesem Lieferunternehmen.",
            "contracts_title": "Verträge",
            "contracts_subtitle": "Sichtbare Verträge und informative Hinweise zu diesem Lieferunternehmen.",
            "contract_term": "Laufzeit",
            "contract_renewal": "Verlängerung",
            "contract_notice": "Kündigungsfrist",
            "contract_findings": "Vertragshinweise",
            "empty_contracts": "Keine Verträge gefunden.",
            "contracts_disclaimer": "Die hier angezeigten Vertragsinformationen und Hinweise dienen nur zur Information und sind keine Rechtsberatung.",
            "contract_finding_severity": {
                "high": "Hoch",
                "medium": "Mittel",
                "low": "Niedrig",
                "info": "Information"
            },
            "unknown": "Unbekannt",
            "emails_title": "E-Mails",
            "emails_subtitle": "SupplierConnect-Kommunikation und importierte Rechnungs-E-Mails aus sichtbaren Belegen.",
            "email_type_filter": "E-Mail-Typ",
            "email_type_all": "Alle",
            "email_type_communication": "Kommunikation",
            "email_type_imported_invoice": "Importierte Rechnung",
            "expand_email": "E-Mail ausklappen",
            "collapse_email": "E-Mail einklappen",
            "email_source_supplier_connect": "SupplierConnect",
            "email_source_imported": "Importierte E-Mail",
            "email_direction_outgoing": "Ausgehend",
            "email_direction_incoming": "Eingehend",
            "imported_email_hint": "Eingangsrechnung aus importierter E-Mail.",
            "loading_original_email": "Original-E-Mail wird geladen…",
            "open_document": "Beleg öffnen",
            "show_more": "Mehr anzeigen",
            "show_less": "Weniger anzeigen",
            "empty_procurements": "Keine Bestellungen gefunden.",
            "empty_invoices": "Keine Rechnungen gefunden.",
            "empty_emails": "Keine E-Mails gefunden.",
            "empty_filtered_emails": "Keine E-Mails für diesen Filter gefunden.",
            "net_value": "Netto",
            "no_subject": "Ohne Betreff",
            "last_three_months": "Letzte 3 Monate",
            "last_six_months": "Letzte 6 Monate",
            "nav": {
                "summary": "Übersicht",
                "charts": "Grafiken",
                "emails": "E-Mails",
                "procurements": "Bestellungen",
                "invoices": "Rechnungen",
                "contracts": "Verträge"
            }
        },
        "invoice": {
            "title": "Eingangsrechnungsdashboard",
            "incoming_subtitle": "Dieses Dashboard arbeitet mit echten Eingangsrechnungen und zeigt Status und Verteilungen auf Basis Ihrer aktuellen Filter.",
            "outgoing_subtitle": "Dieses Dashboard arbeitet mit echten Ausgangsrechnungen und zeigt Status und Verteilungen auf Basis Ihrer aktuellen Filter.",
            "sample_data": "Beispieldaten",
            "accordions": {
                "summary": "Kennzahlen",
                "status": "Status"
            },
            "hero": {
                "data_label": "Datenbasis",
                "live_value": "Echte Belegdaten",
                "period_label": "Zeitraum",
                "documents_label": "Belege im Blick",
                "filters_label": "Aktive Filter"
            },
            "filters": {
                "title": "Filterkontext",
                "subtitle": "Wählen Sie Zeitraum, Organisation und Lieferunternehmen, um alle Bereiche des Dashboards gleichzeitig zu schärfen.",
                "active_filters_label": "Aktive Filter",
                "active_filters_suffix": "aktive Filter",
                "period_label": "Zeitraum"
            },
            "summary": {
                "incoming_count_label": "Rechnungen",
                "outgoing_count_label": "Ausgangsrechnungen",
                "gross_total_label": "Bruttovolumen",
                "gross_total_hint": "Bruttosumme im gewählten Zeitraum",
                "suppliers_label": "Lieferunternehmen im Filter",
                "suppliers_kicker": "Lieferanten",
                "business_partners_label": "Geschäftspartner im Filter",
                "business_partners_kicker": "Partner",
                "value_kicker": "Wert",
                "departments_kicker": "Abteilungen",
                "departments_label": "Abteilungen im Filter",
                "clients_kicker": "Kunden",
                "clients_label": "Kunden im Filter",
                "incoming_count_hint": "Beleganzahl im gewählten Zeitraum",
                "outgoing_count_hint": "Beleganzahl im gewählten Zeitraum",
                "incoming_suppliers_hint": "Einzigartige Lieferunternehmen im gefilterten Rechnungsbestand",
                "outgoing_business_partners_hint": "Einzigartige Geschäftspartner im gefilterten Ausgangsrechnungsbestand",
                "outgoing_suppliers_hint": "Einzigartige Lieferunternehmen im gefilterten Ausgangsrechnungsbestand",
                "incoming_departments_hint": "Einzigartige Abteilungen im gefilterten Rechnungsbestand",
                "outgoing_clients_hint": "Einzigartige Kunden im gefilterten Ausgangsrechnungsbestand"
            },
            "status_sections": {
                "incoming_title": "Rechnungen nach Status",
                "incoming_subtitle": "Statuskarten auf Basis derselben Filter wie im Procurement-Dashboard.",
                "outgoing_title": "Ausgangsrechnungen nach Status",
                "outgoing_subtitle": "Statuskarten für ausgehende Rechnungen in derselben kompakten Übersicht."
            },
            "datasets": {
                "incoming": "Rechnungen",
                "outgoing": "Ausgangsrechnungen"
            },
            "sections": {
                "incoming_subtitle": "Diagramme für eingehende Rechnungen mit denselben Kernfiltern wie im Procurement-Dashboard.",
                "outgoing_subtitle": "Diagramme für ausgehende Rechnungen mit Fokus auf Kunden, Lieferunternehmen, Status und Organisationsdaten."
            },
            "empty_state": "Keine Rechnungsdaten für die aktuelle Filterkombination gefunden.",
            "presets": {
                "this_month": "Dieser Monat",
                "last_3_months": "Letzte 3 Monate",
                "year_to_date": "Jahr bis heute"
            },
            "status": {
                "approved": "Freigegeben",
                "pending": "In Prüfung",
                "blocked": "Blockiert"
            },
            "kpis": {
                "total_invoices": "Rechnungen gesamt",
                "approved_rate": "Freigabequote",
                "pending_review": "Offene Prüfung",
                "avg_gross": "Durchschnittlicher Bruttowert"
            },
            "charts": {
                "status_distribution": "Verteilung nach Rechnungsstatus",
                "status_distribution_subtitle": "Schneller Überblick, wie sich Rechnungen aktuell durch den Prozess bewegen.",
                "volume_trend": "Trend des Rechnungsvolumens",
                "volume_trend_subtitle": "Freigegebene versus offene Dokumente im ausgewählten Testzeitraum.",
                "count_by_status_subtitle": "Beleganzahl je Status.",
                "value_by_status_subtitle": "Bruttosumme je Status.",
                "department_count_subtitle": "Verteilung nach Abteilung.",
                "department_value_subtitle": "Bruttosumme nach Abteilung.",
                "cost_center_count_subtitle": "Beleganzahl nach Kostenstelle.",
                "cost_center_value_subtitle": "Bruttosumme nach Kostenstelle.",
                "ledger_count_subtitle": "Top Sachkonten nach Beleganzahl.",
                "incoming_status_count_title": "Rechnungen nach Status",
                "incoming_status_value_title": "Rechnungswert nach Status",
                "incoming_supplier_count_title": "Rechnungen nach Lieferunternehmen",
                "incoming_supplier_count_subtitle": "Top Lieferunternehmen nach Beleganzahl.",
                "incoming_supplier_value_title": "Rechnungswert nach Lieferunternehmen",
                "incoming_supplier_value_subtitle": "Top Lieferunternehmen nach Bruttosumme.",
                "incoming_department_count_title": "Rechnungen nach Abteilung",
                "incoming_department_value_title": "Rechnungswert nach Abteilung",
                "incoming_cost_center_count_title": "Rechnungen nach Kostenstelle",
                "incoming_cost_center_value_title": "Rechnungswert nach Kostenstelle",
                "incoming_ledger_count_title": "Rechnungen nach Sachkonto",
                "incoming_monthly_title": "Rechnungsverlauf pro Monat",
                "incoming_monthly_subtitle": "Zeitreihe für eingehende Rechnungen.",
                "outgoing_status_count_title": "Ausgangsrechnungen nach Status",
                "outgoing_status_value_title": "Ausgangsrechnungswert nach Status",
                "outgoing_client_count_title": "Ausgangsrechnungen nach Kunde",
                "outgoing_client_count_subtitle": "Top Kunden nach Beleganzahl.",
                "outgoing_client_value_title": "Ausgangsrechnungswert nach Kunde",
                "outgoing_client_value_subtitle": "Top Kunden nach Bruttosumme.",
                "outgoing_business_partner_count_title": "Ausgangsrechnungen nach Geschäftspartner",
                "outgoing_business_partner_count_subtitle": "Top Geschäftspartner nach Beleganzahl.",
                "outgoing_business_partner_value_title": "Ausgangsrechnungswert nach Geschäftspartner",
                "outgoing_business_partner_value_subtitle": "Bruttosumme nach Geschäftspartner.",
                "outgoing_department_count_title": "Ausgangsrechnungen nach Abteilung",
                "outgoing_cost_center_value_title": "Ausgangsrechnungswert nach Kostenstelle",
                "outgoing_ledger_count_title": "Ausgangsrechnungen nach Sachkonto",
                "outgoing_monthly_title": "Ausgangsrechnungsverlauf pro Monat",
                "outgoing_monthly_subtitle": "Zeitreihe für ausgehende Rechnungen."
            },
            "table": {
                "title": "Periodenaufschlüsselung",
                "subtitle": "Ergänzende Beispieltabelle zu den Diagrammen oben.",
                "period": "Periode",
                "total": "Gesamt",
                "approved": "Freigegeben",
                "pending": "Offen",
                "gross_value": "Bruttowert"
            }
        },
        "ordered_by": "Beauftragt von",
        "count_by_status": "Anzahl nach Status",
        "diagrams": {
            "title": "Diagramme",
            "count_by_status": "Anzahl je Status",
            "value_by_status": "Beträge je Status (Netto in EUR)",
            "count_by_department": "Anzahl je Abteilung",
            "value_by_department": "Beträge je Abteilung (Netto in EUR)",
            "count_by_cost_center": "Anzahl je Kostenstelle",
            "value_by_cost_center": "Beträge je Kostenstelle (Netto in EUR)",
            "count_by_ledger_account": "Anzahl je Sachkonto",
            "value_by_ledger_account": "Beträge je Sachkonto (Netto in EUR)"
        },
        "budgets": {
            "title": "Budgets und Ausgaben",
            "approved_status": "Freigegeben",
            "in_approval_status": "In Freigabe",
            "open_status": "Offen",
            "no_budget": "Ohne Budget",
            "from": "Ab",
            "no_name": "Ohne Name"
        },
        "products": {
            "title": "Produkte",
            "approved_status": "Freigegeben",
            "in_approval_status": "In Freigabe"
        },
        "no_data": "Keine Bestellanforderungen gefunden.",
        "from_budget": "vom Budget",
        "data": "Ausgaben",
        "shortcuts": {
            "this_week": "Diese Woche",
            "last_week": "Letzte Woche",
            "this_month": "Dieser Monat",
            "last_month": "Letzter Monat",
            "last_30_days": "Letzte 30 Tage",
            "last_3_months": "Letzte 3 Monate",
            "last_6_months": "Letzte 6 Monate",
            "this_year": "Dieses Jahr",
            "last_year": "Letztes Jahr"
        },
        "tour": {
            "title": "Das Dashboard bietet Ihnen Statistiken und Auswertungsmöglichkeiten zu Ihren Bestellanforderungen.",
            "filters_title": "Filtern",
            "filters": "Wählen Sie dazu zunächst einen gewünschten Zeitraum aus und filtern Sie die auszuwertenden Bestellanforderungen nach Unternehmen, Bestellperson, Kostenstelle, Sachkonto oder Abteilung.",
            "count_by_status_title": "Anzahl nach Status",
            "count_by_status": "Hier sehen Sie, wie viele der vorgefilterten Bestellanforderungen sich in den verschiedenen Status befinden.",
            "graphic_title": "Diagramme",
            "graphic": "Hier sehen Sie eine graphische Darstellung der Anzahl oder Beträge der Bestellanforderungen, jeweils nach Status, Abteilungen oder Kostenstellen gruppiert.",
            "budget_title": "Budgets und Ausgaben",
            "budget": "Dieser Bereich liefert Ihnen eine Übersicht über die Budgets und Ausgaben Ihrer Kostenstellen. Anhand der farbigen Balken sehen Sie, wie der Verbrauch der Budgets ist und wie viele der Ausgaben sich noch in der Freigabe befinden.",
            "progress_bar_cost_center_title": "Balken nach Kostenstelle",
            "progress_bar_cost_center": "Hier können Sie eine detailliertere Übersicht zu den verschiedenen Budgets einer Kostenstelle aufklappen. Zu den einzelnen Budgets können außerdem die getätigten Bestellungen aufgelistet werden. Ausgaben ohne Budget sind unter einem gesonderten Balken gelistet."
        },
        "einvoice": {
            "title": "E‑Rechnung Dashboard",
            "analysis_period": "Analyse-Zeitraum",
            "filters": {
                "date_range": "Zeitraum",
                "client": "Unternehmen",
                "supplier": "Lieferunternehmen",
                "select_period": "Zeitraum wählen"
            },
            "placeholders": {
                "all": "Alle"
            },
            "kpis": {
                "percent_einvoices": "E‑Rechnungsquote",
                "total_tax_eur": "Vorsteuer-Gesamt",
                "potential_loss": "Vorsteuer-Risiko",
                "total_invoices": "Rechnungen gesamt",
                "non_einvoice_quote": "Nicht-E‑Rechnungsquote",
                "top_10_risk_share": "Top-10 Lieferanten Anteil am Vorsteuer-Risiko",
                "total_suppliers": "Lieferanten gesamt",
                "suppliers_with_einvoice": "Lieferanten mit E‑Rechnung",
                "suppliers_without_einvoice": "Lieferanten ohne E‑Rechnung",
                "avg_einvoice_quote": "Durchschnittliche E‑Quote (aktive Lieferanten)",
                "evaluated_months": "Ausgewertete Monate",
                "data_coverage": "Datenabdeckung",
                "risk_concentration": "Risikokonzentration",
                "only_suppliers_with_min_1": "nur Lieferanten mit mindestens 1 E‑Rechnung"
            },
            "charts": {
                "format_distribution": "Formatverteilung",
                "format_distribution_subtitle": "Anteile XML, PDF+XML und nicht strukturierte Rechnungen",
                "monthly_trend": "Monatstrend nach Rechnungsformat",
                "monthly_trend_subtitle": "Gestapelte Mengen je Monat",
                "top_suppliers_risk": "Top Lieferanten nach Vorsteuer-Risiko",
                "top_suppliers_risk_subtitle": "Hohe Risikokonzentration auf einzelne Lieferanten"
            },
            "table": {
                "monthly_evolution": "Monatliche Entwicklung",
                "all_suppliers": "Alle Lieferanten nach E‑Quote (absteigend)",
                "month": "MONAT",
                "xml": "XML",
                "pdf_xml": "PDF+XML",
                "non_einvoice": "NICHT E‑RECHNUNG",
                "risk": "VORSTEUER-RISIKO",
                "supplier": "LIEFERANT",
                "quote": "E‑QUOTE",
                "total_tax": "STEUER GESAMT"
            },
            "banner": {
                "title": "Geschätzte Höhe von Umsatzsteuer, die ab 01.01.2027 nicht vom Finanzamt erstattet wird:",
                "subtitle": "{percent}% der geschätzten Umsatzsteuer (Formrisiko-Modell)",
                "description": "Zeitraum: {start} bis {end}. Empfangspflicht seit 01.01.2025. Regulatorischer Druck steigt ab 01.01.2027. Erhöhtes formales Gültigkeitsrisiko für nicht strukturierte inländische B2B-Rechnungen ab 01.01.2028. Modell bewertet nur Format-Compliance."
            },
            "hint": "Achtung: Der Staat wird bald keine Steuererstattungen mehr für nicht-elektronische Rechnungen gewähren. Kontaktieren Sie Ihre Lieferanten so schnell wie möglich, um sicherzustellen, dass Sie Ihre E‑Rechnungen korrekt erhalten und kein Geld verlieren.",
            "alert": {
                "title": "Achtung: Höheres steuerliches und formales Risiko bei nicht-elektronischen Rechnungen",
                "item_1": "Ab 01.01.2027 steigt das Risiko bei nicht strukturierten Rechnungen deutlich.",
                "item_2": "Für solche Rechnungen kann das Finanzamt die Vorsteuererstattung verweigern.",
                "item_3": "Ab 01.01.2028 gilt dies für alle Lieferanten – auch unter 800.000 € Umsatz (Übergangsregelung nur für 2027).",
                "item_4": "Empfehlung: Stellen Sie alle Ihre Lieferanten frühzeitig auf E-Rechnungen um und fordern Sie eine angepasste Rechnungsstellung an."
            },
            "action_button": "Kontakt aufnehmen",
            "email_dialog": {
                "title": "Kontaktaufnahme",
                "to": "Empfänger E-Mail",
                "to_placeholder": "email1@firma.de; email2@firma.de",
                "subject": "Betreff",
                "message": "Nachricht",
                "download_eml": ".eml herunterladen",
                "send_email": "E-Mail senden",
                "recipient_type": "Empfänger-Typ",
                "recipient_type_supplier": "Lieferunternehmen",
                "recipient_type_client": "Unternehmen",
                "invalid_recipients": "Bitte mindestens eine gültige E-Mail-Adresse angeben.",
                "send_success": "E-Mail erfolgreich gesendet ({count}).",
                "send_error": "E-Mail konnte nicht versendet werden.",
                "select_supplier_warning": "Bitte wählen Sie zuerst einen Lieferanten aus.",
                "default_subject": "Wichtig: Umstellung auf E-Rechnungen - {supplier}",
                "default_message": "Sehr geehrte Damen und Herren von {supplier},\n\nwir überprüfen derzeit unsere Vorsteuer-Erstattungsprozesse. Im Zeitraum vom {startDate} bis {endDate} haben wir in Ihren Rechnungen insgesamt {amount} an Steuern identifiziert, die nicht als E-Rechnung (ZUGFeRD oder XRechnung) übermittelt wurden.\n\nBitte beachten Sie, dass der Staat in Kürze keine Steuererstattungen mehr für nicht-elektronische Rechnungen gewähren wird. Um unsere weitere Zusammenarbeit sicherzustellen und finanzielle Verluste zu vermeiden, bitten wir Sie höflich, so bald wie möglich auf den Versand von elektronischen Rechnungen umzustellen.\n\nVielen Dank für Ihre Kooperation.\n\nMit freundlichen Grüßen\n{userName}\n{tenantName}\nIhre Buchhaltung",
                "client_default_subject": "E-Rechnungsstatus und Handlungsbedarf - {client}",
                "client_default_message": "Sehr geehrte Damen und Herren von {client},\n\nim Zeitraum {startDate} bis {endDate} wurde bei Ihren Belegen ein potenzielles formales Risiko von {amount} erkannt.\nBitte prüfen Sie die Umstellung auf strukturierte E-Rechnungsformate, um Compliance-Risiken zu reduzieren.\n\nViele Grüße\n{userName}\n{tenantName}"
            }
        }
    },
    "exceptions_center": {
        "menu_title": "Pendenzen",
        "title": "Pendenzen & Ausnahmen",
        "subtitle": "Diese Ansicht bündelt die dringendsten Rechnungen, Bestellungen und Verträge, die jetzt eine manuelle Bearbeitung brauchen.",
        "total_items": "Offene Punkte",
        "total_items_hint": "Gefilterte Einträge, die aktuell in der zentralen Arbeitsliste sichtbar sind.",
        "filters_title": "Arbeitsliste filtern",
        "filters_subtitle": "Fokussieren Sie die Liste nach Dokumenttyp, Schweregrad oder Freitextsuche.",
        "clear_filters": "Filter zurücksetzen",
        "search_placeholder": "Nach Referenz, Mandant, Lieferant oder Grund suchen",
        "type_filter": "Dokumenttypen",
        "severity_filter": "Schweregrad",
        "quick_filters_title": "Schnellfilter",
        "focus_areas_title": "Fokusbereiche",
        "analysis_title": "Analyse",
        "document_mix_title": "Dokumentenmix",
        "amount_at_risk": "Finanzieller Umfang",
        "active_filters_title": "Aktive Filter",
        "filtered_total_hint": "{filtered} von {total} Einträgen sichtbar",
        "total_reference": "von {count} gesamt",
        "active_state": "Filter aktiv",
        "list_title": "Operative Arbeitsliste",
        "list_subtitle": "{count} Einträge entsprechen aktuell den gewählten Filtern.",
        "empty_state": "Für die aktuelle Filterkombination wurden keine Pendenzen gefunden.",
        "open_case": "Fall öffnen",
        "updated_label": "Letzte Aktualisierung",
        "reasons_count": "{count} Hinweise",
        "filter_groups": {
            "severity": "Schweregrad",
            "type": "Typ",
            "focus": "Fokus",
            "search": "Suche"
        },
        "summary": {
            "severity_kicker": "Schweregrad",
            "document_kicker": "Dokumenttyp",
            "severity_title": "Nach Schweregrad",
            "document_title": "Nach Dokumenttyp"
        },
        "signals": {
            "critical": "Jetzt kritisch",
            "unassigned": "Ohne Verantwortliche",
            "stale": "Überfällige Einträge"
        },
        "focus_areas": {
            "payments": "Zahlungen",
            "approvals": "Freigaben",
            "master-data": "Stammdaten",
            "ownership": "Verantwortung",
            "export": "Export",
            "deadlines": "Fristen"
        },
        "severity": {
            "critical": "Kritisch",
            "high": "Hoch",
            "medium": "Mittel"
        },
        "document_types": {
            "invoice": "Rechnung",
            "outgoing_invoice": "Ausgangsrechnung",
            "procurement": "Bestellung",
            "contract": "Vertrag",
            "bank_statement": "Kontoauszug"
        },
        "reasons": {
            "invoice_duplicate": "Mögliche Dublette bei der Rechnung erkannt.",
            "invoice_ai_validation_failed": "Die KI-Validierung hat die Rechnung nicht freigegeben und zur manuellen Prüfung weitergeleitet.",
            "invoice_overdue": "Das Fälligkeitsdatum der Rechnung ist seit {days} Tag(en) überschritten.",
            "invoice_missing_due_date": "Für die Rechnung ist kein Fälligkeitsdatum hinterlegt.",
            "invoice_waiting_approval": "Die Rechnung wartet in einem Freigabeschritt.",
            "invoice_missing_link": "Die Rechnung ist weder mit einer Bestellung noch mit einem Vertrag verknüpft.",
            "invoice_missing_supplier": "Der Rechnung ist kein Lieferant zugeordnet.",
            "invoice_missing_accounting_data": "Der Rechnung fehlen buchhalterische Dimensionen wie Kostenstelle oder Sachkonto.",
            "invoice_ready_for_export": "Die Rechnung ist bereit für den Export, wurde aber noch nicht exportiert.",
            "outgoing_invoice_duplicate": "Mögliche Dublette bei der Ausgangsrechnung erkannt.",
            "outgoing_invoice_overdue": "Das Fälligkeitsdatum der Ausgangsrechnung ist seit {days} Tag(en) überschritten.",
            "outgoing_invoice_missing_due_date": "Für die Ausgangsrechnung ist kein Fälligkeitsdatum hinterlegt.",
            "outgoing_invoice_waiting_processing": "Die Ausgangsrechnung wartet in Freigabe oder Buchhaltung.",
            "outgoing_invoice_missing_client": "Der Ausgangsrechnung ist kein Kunde zugeordnet.",
            "outgoing_invoice_missing_accounting_data": "Der Ausgangsrechnung fehlen buchhalterische Dimensionen wie Kostenstelle oder Sachkonto.",
            "outgoing_invoice_not_exported": "Die Ausgangsrechnung ist abgeschlossen, wurde aber noch nicht exportiert.",
            "procurement_waiting_approval": "Die Bestellung wartet auf Freigabe.",
            "procurement_ordered_without_invoice": "Zur bestellten Beschaffung liegt nach dem Lieferdatum noch keine Rechnung vor.",
            "procurement_approved_without_invoice": "Zur freigegebenen Beschaffung liegt auch nach einer Woche noch keine Rechnung vor.",
            "procurement_missing_delivery_date": "Für die Beschaffung ist kein Lieferdatum geplant.",
            "procurement_not_allocated": "Die Bestellung ist nicht vollständig allokiert.",
            "procurement_open_value_remaining": "Für die Beschaffung ist trotz begonnener Rechnungsbearbeitung noch ein offener Wert vorhanden.",
            "procurement_missing_supplier": "Der Bestellung ist kein Lieferant zugeordnet.",
            "procurement_missing_accounting_data": "Der Bestellung fehlen buchhalterische Dimensionen wie Kostenstelle oder Sachkonto.",
            "contract_termination_deadline_passed": "Der Kündigungsstichtag ist bereits überschritten.",
            "contract_termination_deadline_soon": "Der Kündigungsstichtag liegt innerhalb der nächsten {days} Tag(e).",
            "contract_termination_deadline_near": "Der Kündigungsstichtag liegt innerhalb der nächsten 30 Tage.",
            "contract_end_date_passed": "Das Laufzeitende des Vertrags ist bereits überschritten.",
            "contract_end_date_soon": "Das Laufzeitende des Vertrags liegt innerhalb der nächsten {days} Tag(e).",
            "contract_end_date_near": "Das Laufzeitende des Vertrags liegt innerhalb der nächsten 30 Tage.",
            "contract_missing_owner": "Dem Vertrag ist keine verantwortliche Person zugeordnet.",
            "contract_missing_supplier": "Dem Vertrag ist kein Lieferant zugeordnet.",
            "bank_statement_failed": "Die Verarbeitung des Kontoauszugs ist fehlgeschlagen.",
            "bank_statement_partial": "Die Verarbeitung des Kontoauszugs wurde nur teilweise abgeschlossen.",
            "bank_statement_unmatched_entries": "Im Kontoauszug sind noch {count} nicht zugeordnete Buchung(en) vorhanden.",
            "bank_statement_processing_too_long": "Der Kontoauszug wird seit mehr als einem Tag verarbeitet.",
            "bank_statement_empty": "Der Kontoauszug wurde ohne Buchungen verarbeitet.",
            "bank_statement_missing_owner": "Im Kontoauszug ist kein Kontoinhaber hinterlegt.",
            "item_unassigned": "Dem aktuellen Workflow-Schritt ist kein verantwortlicher Benutzer zugeordnet.",
            "item_stale": "Der Eintrag wurde seit {days} Tag(en) nicht relevant aktualisiert."
        }
    },
    "overview_page": {
        "title": "Übersicht",
        "procurement_abbr": "BE",
        "invoice_abbr": "RE",
        "outgoing_invoice_abbr": "AR",
        "draft_abbr": "EN",
        "contract_abbr": "VT",
        "delivery_note_abbr": "LS",
        "all_docs": "Alle Belege",
        "all_docs_tree": "Alle Belege (Baumansicht)",
        "all_docs_list": "Alle Belege (Listenansicht)",
        "search_all_documents": "In allen Belegen suchen",
        "export_ready_docs": "Bereit zum Export",
        "my_tasks": "Meine Aufgaben",
        "my_orders": "Meine Bestellungen",
        "my_bank_statements": "Meine Kontoauszüge",
        "previous_document": "Vorheriger Beleg",
        "next_document": "Nächster Beleg",
        "collapse_sidebar": "Seitenleiste einklappen",
        "expand_sidebar": "Seitenleiste ausklappen",
        "collapse_properties_sidebar": "Aktionsleiste einklappen",
        "expand_properties_sidebar": "Aktionsleiste ausklappen",
        "properties_sidebar": {
            "no_step": "Kein aktiver Schritt",
            "completed": "Abgeschlossen"
        },
        "saved_searches": "Gespeicherte Suchen",
        "my_orders_no_invoices": "Zu dieser Bestellung ist noch keine Rechnung verknüpft.",
        "my_orders_goods_receipt": "Wareneingang",
        "procurements": "Bestellanforderungen",
        "invoices": "Rechnungen",
        "outgoing_invoices": "Ausgangsrechnungen",
        "list_column_incoming_invoice": "Eingang",
        "list_column_outgoing_invoice": "Ausgang",
        "contracts": "Verträge",
        "drafts": "Entwürfe",
        "no_selection": "Kein Dokument ausgewählt.",
        "common_fields": "Gemeinsame Felder",
        "comment_box_placeholder": "Ihr Kommentar...",
        "comment_box_btn": "Kommentieren",
        "comment_box_mentions_loading": "Nutzer werden geladen...",
        "comment_box_mentions_empty": "Keine Nutzer gefunden.",
        "communication": {
            "tooltip": "Lieferanten kontaktieren",
            "tooltip_business_partner": "Geschäftspartner kontaktieren",
            "disabled_hint": "Bitte ein aktives Postfach mit aktivierter Lieferantenkommunikation fuer diesen Dokumenttyp in den Einstellungen hinterlegen.",
            "dialog_title": "Lieferanten kontaktieren",
            "dialog_title_business_partner": "Geschäftspartner kontaktieren",
            "send_order_dialog_title": "Bestellung per SupplierConnect senden",
            "from_mailbox": "Absender-Postfach",
            "from_mailbox_placeholder": "Postfach auswaehlen",
            "supplier": "Lieferant",
            "to": "An",
            "visibility": "Sichtbarkeit",
            "internal_note": "Interne Nachricht",
            "internal_tag": "Intern",
            "external_tag": "Extern",
            "external_hint": "Extern: Der Lieferant und alle ausgewählten Empfänger erhalten diese Nachricht.",
            "internal_hint": "Intern: Nur erwähnte liftbase Nutzer erhalten eine Benachrichtigung. Der Lieferant wird nicht kontaktiert.",
            "cc_mentions": "Cc Nutzer (@mention)",
            "cc_mentions_placeholder": "Verwenden Sie @, um Nutzer aus dem System zu markieren",
            "internal_recipients": "Interne Empfänger",
            "cc_emails": "Cc E-Mail-Adressen",
            "cc_emails_placeholder": "E-Mail hinzufügen und Enter drücken",
            "subject": "Betreff",
            "body": "Nachricht",
            "body_placeholder": "Nachricht schreiben...",
            "attach_order_pdf": "Bestell-PDF anhängen",
            "attach_invoice_document": "Rechnungsdokument anhängen",
            "attach_order_pdf_mode_plain": "Ohne Angebot",
            "attach_order_pdf_mode_with_line_attachments": "Mit Angebot",
            "reply_info": "Antworten werden nur an das konfigurierte Kommunikationspostfach gesendet. Die startende Person wird anschließend benachrichtigt.",
            "internal_reply_info": "Interne Nachrichten werden nur an erwähnte liftbase Nutzer gesendet.",
            "send": "E-Mail senden",
            "dialog_options_action": "Weitere E-Mail-Optionen",
            "validation": "Bitte füllen Sie alle Pflichtfelder aus.",
            "sent_success": "Kommunikation erfolgreich gesendet.",
            "sent_error": "Kommunikation konnte nicht gesendet werden.",
            "sent_error_mailbox_reconnect": "Die Kommunikation konnte nicht gesendet werden, weil das Microsoft-Postfach {mailbox} nicht mehr verbunden ist.\nBitte verbinden Sie das Postfach in den Einstellungen erneut und versuchen Sie es danach noch einmal.",
            "sent_error_mailbox_incomplete": "Die Kommunikation konnte nicht gesendet werden, weil beim Postfach {mailbox} SMTP-Host, Benutzername oder Passwort fehlen.\nBitte vervollständigen Sie die Postfach-Konfiguration in den Einstellungen.",
            "history_title": "Lieferantenkommunikation",
            "history_title_business_partner": "Geschäftspartnerkommunikation",
            "history_empty": "Für dieses Dokument wurde noch keine Kommunikation gestartet.",
            "recipients": "Empfänger",
            "cc": "Cc",
            "attachments": "Anhänge",
            "attachments_available": "Mit Anhängen",
            "statuses": {
                "pending": "Ausstehend",
                "sent": "Gesendet",
                "failed": "Fehlgeschlagen",
                "received": "Empfangen"
            },
            "reply_action": "Antworten",
            "forward_action": "Weiterleiten",
            "forward_dialog_title": "E-Mail weiterleiten",
            "forward_subject_prefix": "WG:",
            "forwarded_message_title": "Weitergeleitete Nachricht",
            "forward_attachments_hint": "Diese Anhänge werden zusammen mit der weitergeleiteten E-Mail gesendet.",
            "history_quote_title": "Kommunikationsverlauf",
            "history_date_label": "Datum",
            "history_from_label": "Von",
            "history_to_label": "An",
            "history_subject_label": "Betreff",
            "show_less": "Weniger anzeigen",
            "involved_button": "Beteiligte",
            "involved_title": "Beteiligte Personen und E-Mails",
            "involved_search_placeholder": "Nach Name oder E-Mail suchen",
            "involved_copy_email": "E-Mail kopieren",
            "involved_copied": "E-Mail kopiert",
            "involved_empty": "Keine Beteiligten gefunden",
            "involved_sections": {
                "suppliers": "Lieferanten",
                "users": "Interne Nutzer",
                "manual": "Manuelle E-Mails",
                "mailbox": "Postfach"
            },
            "address_book_source_supplier": "Lieferantenadresse",
            "address_book_source_saved": "Bereits verwendet",
            "address_book_delete": "Gespeicherte Suggestion entfernen",
            "address_book_delete_success": "Gespeicherte Suggestion entfernt.",
            "address_book_delete_error": "Die gespeicherte Suggestion konnte nicht entfernt werden."
        },
        "edit_filename_title": "Dateiname bearbeiten",
        "edit_filename_msg": "Bitte geben Sie den neuen Dateinamen ein. <br> Alter Name: {filename}",
        "duplicate_invoice": {
            "message": "Dublette - Es wurde mindestens eine Rechnung mit gleicher Rechnungsnummer gefunden:",
            "invoice_number": "Belegnummer",
            "invoice_date": "Datum",
        },
        "task_list": {
            "name": "Bezeichnung",
            "status": "Status",
            "date": "Datum",
            "draft": "Entwurf"
        },
        "searchbar": {
            "search": "Suche",
            "filter_by": "Filter nach",
            "created_at": "Erstelldatum",
            "timeline": "Timeline",
            "last_used": "Zuletzt verwendet",
            "favorites": "Favoriten",
            "no_search": "Keine",
            "save_search": "Suche speichern",
            "save_search_prompt": "Möchten Sie diese Suche speichern? Geben Sie eine Bezeichnung ein.",
            "label_placeholder": "Bezeichnung",
            "label_required": "Bitte geben Sie eine Bezeichnung ein.",
            "label_exists": "Diese Bezeichnung existiert bereits.",
            "saved_success": "Die Suche wurde gespeichert.",
            "edit_saved_search": "Gespeicherte Suche umbenennen",
            "edit_saved_search_title": "Gespeicherte Suche umbenennen",
            "edit_saved_search_prompt": "Wie soll diese gespeicherte Suche heißen?",
            "edited_success": "Die gespeicherte Suche wurde umbenannt.",
            "delete_saved_search": "Gespeicherte Suche löschen",
            "delete_saved_search_title": "Gespeicherte Suche löschen",
            "delete_saved_search_prompt": "Möchten Sie die gespeicherte Suche \"{label}\" wirklich löschen?",
            "deleted_success": "Die gespeicherte Suche wurde gelöscht.",
            "timeline_props": {
                "editor_name": "Bearbeiter*in",
                "entry_type": "Timeline-Schritt",
                "current_editor_name": "Aktuelle*r Bearbeiter*in",
                "current_entry_type": "Aktueller Schritt"
            },
            "common_props": {
                "client_name": "Unternehmen-Name",
                "client_number": "Unternehmen-Nummer",
                "department_name": "Abteilung-Name",
                "department_number": "Abteilung-Nummer",
                "cost_center_name": "Kostenstellen-Name",
                "cost_center_number": "Kostenstellen-Nummer",
                "ledger_account_name": "Sachkonto-Name",
                "ledger_account_number": "Sachkonto-Number",
                "cost_type_name": "Kostenart",
                "product_names": "Produkt",
                "product_numbers": "Artikelnummer",
                "status": "Status",
                "supplier_display_name": "Lieferunternehmen",
                "payment_in_advance": "Vorkasse"
            },
            "procurement_props": {
                "order_number_formatted": "Bestellnummer",
                "name": "Bezeichnung",
                "creator_name": "Erstellt von",
                "consignee_name": "Wareneingang",
                "supplier_names": "Lieferunternehmen",
                "delivery_date_overdue": "Lieferdatum überschritten"
            },
            "invoice_props": {
                "invoice_number": "Rechnungsnummer",
                "invoice_number_formatted": "Interne RE-Nummer",
                "invoice_prefix": "Rechnungspräfix",
                "procurement_number": "Bestellnummer",
                "creator_name": "Hochgeladen von",
                "supplier_name": "Lieferunternehmen-Name",
                "supplier_number": "Lieferunternehmen-Nummer",
                "invoice_date": "Rechnungsdatum",
                "due_date": "Fälligkeit"
            },
            "time_ranges": {
                "today": "heute",
                "yesterday": "gestern",
                "past_7_days": "letzte 7 Tage",
                "past_30_days": "letzte 30 Tage",
                "this_week": "diese Woche",
                "last_week": "letzte Woche",
                "this_month": "dieser Monat",
                "last_month": "letzter Monat",
                "this_year": "dieses Jahr",
                "last_year": "letztes Jahr"
            }
        },
        "export": {
            "all_information": "Alle Informationen",
            "export_procurement": "Bestellanforderungen exportieren",
            "export_documents": "Dokumente exportieren",
            "registers": "Einträge",
            "export": "Export",
            "to_export": "Exportieren",
            "export_with_products": "Export mit Produkten",
            "custom_export": "Konfigurierter Export",
            "select_fields": "Wählen Sie die Felder aus, welche exportiert werden sollen.",
            "select_all": "Alle auswählen",
            "deselect_all": "Alle entfernen",
            "general": "Allgemein",
            "products": "Produkte",
            "include_product": "Inkl. Produkte",
            "filter": " Filter",
            "no_filter": "kein Filter",
            "format": "Dateiformat",
            "csv": "CSV",
            "xlsx": "XLSX",
            "loading": "wird geladen",
            "error": "Fehler beim Export. Bitte versuchen Sie es erneut.",
            "labels": {
                "procurement": {
                    "order_number_formatted": "LB-Nummer",
                    "name": "Bezeichnung",
                    "status": "Status",
                    "creator_name": "Erstellt von",
                    "total_price_brutto": "Gesamt Brutto",
                    "total_price_netto": "Gesamt Netto",
                    "type_total_price_brutto": "currency",
                    "type_total_price_netto": "currency",
                    "created_at": "Erstelldatum",
                    "client_number": "Unternehmen Nummer",
                    "client_name": "Unternehmen Name",
                    "department_name": "Abteilung Name",
                    "department_number": "Abteilung Nummer",
                    "cost_center_name": "Kostenstelle Name",
                    "cost_center_number": "Kostenstelle Nummer",
                    "consignee_name": "Wareneingang",
                    "shipping_date": "Lieferdatum",
                    "shipping_name": "Lieferanschrift Name",
                    "shipping_consignee": "Lieferanschrift Name empfangender Person",
                    "shipping_dropoff_location": "Lieferanschrift Name des Ablageorts",
                    "shipping_address": "Lieferanschrift Straße und Nr.",
                    "shipping_complement": "Lieferanschrift Straße 2",
                    "shipping_country": "Lieferanschrift Land",
                    "shipping_zipcode": "Lieferanschrift PLZ",
                    "shipping_city": "Lieferanschrift Stadt",
                    "shipping_phone_country_code": "Lieferanschrift Telefonland",
                    "shipping_phone_number": "Lieferanschrift Telefonnummer",
                    "billing_name": "Rechnungsanschrift Name",
                    "billing_consignee": "Rechnungsanschrift Name empfangender Person",
                    "billing_dropoff_location": "Rechnungsanschrift Name des Ablageorts",
                    "billing_address": "Rechnungsanschrift Straße und Nr.",
                    "billing_complement": "Rechnungsanschrift Straße 2",
                    "billing_country": "Rechnungsanschrift Land",
                    "billing_zipcode": "Rechnungsanschrift PLZ",
                    "billing_city": "Rechnungsanschrift Stadt",
                    "billing_phone_country_code": "Rechnungsanschrift Telefonland",
                    "billing_phone_number": "Rechnungsanschrift Telefonnummer"
                },
                "product": {
                    "product_name": "Produktname",
                    "product_number": "Artikelnummer",
                    "product_supplier_name": "Lieferunternehmen Name",
                    "product_supplier_email": "Lieferunternehmen E-Mail",
                    "product_cost_center_name": "Kostenstelle Name (Produkt)",
                    "product_cost_center_number": "Kostenstelle Nummer (Produkt)",
                    "product_tax": "Steuer",
                    "product_quantity": "Menge (Produkt)",
                    "product_total_netto": "Gesamt-Netto (Produkt)",
                    "product_total_brutto": "Gesamt-Brutto (Produkt)",
                    "product_netto": "Einzelpreis-Netto",
                    "product_brutto": "Einzelpreis-Brutto",
                    "product_unit_price_base_amount": "Einzelpreis vor Rabatt (Produkt)",
                    "product_unit_price_discount_amount": "Preisrabatt (Produkt)",
                    "product_line_discount_amount": "Positionsrabatt (Produkt)",
                    "product_line_discount_base_amount": "Basisbetrag Positionsrabatt (Produkt)",
                    "product_line_discount_percentage": "Positionsrabatt % (Produkt)",
                    "product_unit": "Einheit",
                    "product_img_url": "Bild URL",
                    "product_shop_url": "Shop URL",
                    "product_shipping_name": "Lieferanschrift Name (Produkt)",
                    "product_shipping_consignee": "Lieferanschrift Name empfangender Person (Produkt)",
                    "product_shipping_dropoff_location": "Lieferanschrift Name des Ablageorts (Produkt)",
                    "product_shipping_address": "Lieferanschrift Straße und Nr. (Produkt)",
                    "product_shipping_complement": "Lieferanschrift Straße 2 (Produkt)",
                    "product_shipping_country": "Lieferanschrift Land (Produkt)",
                    "product_shipping_zipcode": "Lieferanschrift PLZ (Produkt)",
                    "product_shipping_city": "Lieferanschrift Stadt (Produkt)",
                    "product_shipping_phone_country_code": "Lieferanschrift Telefonland (Produkt)",
                    "product_shipping_phone_number": "Lieferanschrift Telefonnummer (Produkt)",
                    "product_received_at": "letzter Wareneingang (Datum)",
                    "product_received_by": "letzter Wareneingang (Person)"
                },
                "invoice": {
                    "invoice_number_formatted": "RE-Nummer",
                    "number": "Rechnungsnummer",
                    "invoice_prefix": "Rechnungspräfix",
                    "creator_name": "Hochgeladen von",
                    "status": "Status",
                    "procurement_name": "Bestellanforderung",
                    "procurement_number": "Bestellnummer",
                    "client_number": "Unternehmen Nummer",
                    "client_name": "Unternehmen Name",
                    "department_name": "Abteilung",
                    "cost_center_number": "Kostenstelle Nummer",
                    "cost_center_name": "Kostenstelle Name",
                    "total_price_netto": "Gesamt Netto",
                    "total_price_brutto": "Gesamt Brutto",
                    "document_discount_amount": "Dokumentrabatt Betrag",
                    "document_discount_base_amount": "Dokumentrabatt Basisbetrag",
                    "document_discount_percentage": "Dokumentrabatt %",
                    "document_discount_tax_percentage": "MwSt.-Satz des Dokumentrabatts %",
                    "created_at": "Hochgeladen am",
                    "invoice_date": "Rechnungsdatum",
                    "due_date": "Fälligkeitsdatum",
                    "delivery_date": "Leistungsdatum",
                    "currency": "Währung",
                    "ledger_account_name": "Sachkonto Name",
                    "ledger_account_number": "Sachkonto Nummer",
                    "posting_key_number": "Steuerschlüssel Nummer",
                    "posting_key_tax": "Steuerschlüssel Steuer",
                    "supplier_name": "Lieferunternehmen",
                    "paid": "Bezahlt"
                },
                "contract": {
                    "name": "Name",
                    "contract_date": "Vertragsdatum",
                    "contract_number_formatted": "VR-nummer",
                    "contract_number": "Vertragsnummer",
                    "category": "Kategorie",
                    "status": "Status",
                    "term_type": "Laufzeittyp",
                    "payment_method": "Zahlungsart",
                    "external_contract_number": "Externe Vertragsnummer",
                    "creator_name": "Erstellt von",
                    "created_at": "Erstelldatum",
                    "client_number": "Unternehmen Nummer",
                    "client_name": "Unternehmen Name",
                    "department_name": "Abteilung Name",
                    "department_number": "Abteilung Nummer",
                    "cost_center_name": "Kostenstelle Name",
                    "cost_center_number": "Kostenstelle Nummer",
                    "supplier_name": "Lieferunternehmen Name",
                    "supplier_number": "Lieferunternehmen Nummer",
                    "responsible_name": "Verantwortlich",
                    "notes": "Notiz",
                    "payment_direction": "Verhältnis",
                    "recurring_invoice": "Dauerrechnung",
                    "start_date": "Laufzeitbeginn",
                    "end_date": "Laufzeitende",
                    "duration": "Vertragsdauer",
                    "duration_unit_type": "Vertragsdauer-Zeiteinheit",
                    "renewal_type": "Verlängerungsart",
                    "renewal_duration": "Verlängerungsdauer",
                    "renewal_duration_unit_type": "Verlängerungsdauer-Zeiteinheit",
                    "notice_period": "Kündigungsfrist",
                    "notice_period_unit_type": "Kündigungsfrist-Zeiteinheit",
                    "termination_special_right": "Sonderkündigungsrecht",
                    "termination_deadline": "Kündigungsstichtag",
                    "next_possible_contract_end": "Nächstmögliches Vertragsende",
                    "terminated_on": "Gekündigt am",
                    "termination_to": "Kündigung zum",
                    "payment_timing": "Zahlungstyp",
                    "usage_type": "Rhythmus",
                }
            }
        },
        "actions": {
            "tour": {
                "procurement_reassignment_title": "Bestellanforderung zuweisen/klären",
                "procurement_reassignment_msg": "Diese Aufgabe liegt aktuell bei einer anderen Person. Mit diesem Button können Sie die Aufgabe zur Klärung oder zur weiteren Bearbeitung einer dritten Person oder sich selbst zuweisen. In der Klärung können Bestellanforderungen auch storniert werden.",
                "invoice_reassignment_title": "Rechnung zuweisen/klären",
                "invoice_reassignment_msg": "Diese Aufgabe liegt aktuell bei einer anderen Person. Mit diesem Button können Sie die Aufgabe zur Klärung oder zur weiteren Bearbeitung einer dritten Person oder sich selbst zuweisen. In der Klärung können Rechnungen auch ausgesteuert werden."
            },
            "skip_confirm_dialog_title": "Belegerkennung abbrechen",
            "skip_confirm_dialog_msg": "Um zu überprüfen, ob bereits ein Ergebnis der Belegerkennung vorliegt, aktualisieren Sie die Ansicht im Aufgabenmenü. <br>Sind Sie sicher, dass Sie die Erkennung der Rechnungsdaten abbrechen und die Rechnungsdaten manuell erfassen wollen?",
            "button_hint": {
                "to_approval": "Zur Freigabe",
                "to_send_order": "Zur Beauftragung",
                "to_accounting": "Zur Buchhaltung",
                "approve": "Freigeben",
                "self_assign": "Annehmen",
                "finish_order": "Beauftragung abschließen",
                "finish_delivery": "Abschließen",
                "skip_recognition": "Belegerkennung abbrechen",
                "to_export": "Zum Export",
                "default": "Fortsetzen",
                "cancel_or_assign_procurement": "Zuweisen/Stornieren",
                "cancel_or_assign_invoice": "Zuweisen/Aussteuern",
                "clearing_or_assign": "Zuweisen/Klären"
            },
            "assignment_tooltip": "Klärung oder Zuweisung",
            "restart_approval_tooltip": "Timeline neu starten",
            "restart_or_clearing_tooltip": "Timeline neu starten oder zur Klärung zuweisen",
            "restart_approval_error": "Der Freigabeprozess konnte nicht neu gestartet werden.",
            "assignment_dialog": {
                "title_procurement_assign_or_cancel": "Zuweisung oder Stornierung",
                "title_invoice_assign_or_cancel": "Zuweisung oder Aussteuerung",
                "title_assign": "Zuweisung",
                "title_clearing_or_assign": "Klärung oder Zuweisung",
                "assign_title": "Aktuelle Aufgabe anderer Person zuweisen",
                "assign_msg": "Die aktuell zugewiesene Person ist nicht verfügbar oder nicht für diese Aufgabe zuständig, daher soll eine andere Person diese Aufgabe übernehmen.",
                "clearing_title": "Zur Klärung zuweisen",
                "clearing_msg": "Die aktuell zugewiesene Person ist verfügbar und für diese Aufgabe zuständig, aber der Vorgang kann aus anderen Gründen so nicht weiter bearbeitet werden. Daher möchten Sie einen Klärungsprozess einleiten.",
                "cancel_procurement_title": "Stornierung",
                "cancel_procurement_msg": "Die Bestellung wird unwiderruflich storniert und kann nicht weiter bearbeitet werden. Stornierte Bestellungen finden Sie in der Übersicht unter dem Status \"Abgewiesen\".",
                "cancel_invoice_title": "Aussteuerung",
                "cancel_invoice_msg": "Die Rechnung wird unwiderruflich ausgesteuert und kann nicht weiter bearbeitet werden. Ausgesteuerte Rechnungen finden Sie in der Übersicht aller Belege unter dem Status \"Ausgesteuert\".",
                "assign_to": "Zuweisen an",
                "reason": "Grund",
                "declined_invoice_alert_title": "Ausgesteuerte Rechnung kann nicht erneut geöffnet werden",
                "declined_invoice_alert_message": "Diese Rechnung wurde bereits ausgesteuert. Sie kann nur noch zur Klärung weitergeleitet werden, um Daten bei Bedarf anzupassen. Danach darf sie nicht wieder geöffnet werden und muss erneut eingereicht werden.",
                "clearing_footer_info": "Die aktuelle Aufgabe wird abgebrochen. Es wird eine neue Aufgabe für die ausgewählte Person zur Klärung gestartet.",
                "reassignment_footer_info": "Es wird nur die bearbeitende Person der aktuellen Aufgabe gewechselt.",
                "restart_approval_title": "Freigabeprozess neu starten",
                "restart_approval_dialog_title": "Timeline neu starten",
                "restart_or_clearing_dialog_title": "Timeline neu starten oder zur Klärung zuweisen",
                "restart_approval_msg": "Die Rechnung wird zur manuellen Prüfung zurückgesetzt und durchläuft eine neue Freigaberunde. Der bisherige Verlauf bleibt erhalten.",
                "restart_approval_footer_info": "Die Rechnung wird zur manuellen Prüfung zurückgesetzt. Der bisherige Timeline-Verlauf bleibt erhalten.",
                "cancel_invoice_btn": "Aussteuern",
                "cancel_procurement_btn": "Stornieren",
                "assign_btn": "Zuweisen",
                "restart_approval_btn": "Neu starten",
                "prevent_approve_group_msg": "Bitte weisen Sie diesen Schritt einer Person zu, bevor Sie ihn freigeben.",
                "clearing_dialog": {
                    "title": "Vorbelegung von Klärung",
                    "procurement_message": "Die Person im Schritt „Klärung“ ergibt sich aus verschiedenen Vorbelegungen von zuständigen Personen je Abteilung, Unternehmen, einer globalen Rollenvorbelegung und der Person, welche die Bestellung erstellt hat. Die Person, die in der Liste zuoberst steht, wird für die Aufgabe vorbelegt.",
                    "invoice_message": "Die Person im Schritt „Klärung“ ergibt sich aus verschiedenen Vorbelegungen von zuständigen Personen je Unternehmen, einer globalen Rollenvorbelegung und der Person, welche die Rechnung erstellt hat. Die Person, die in der Liste zuoberst steht,wird für die Aufgabe vorbelegt.",
                    "department_form": "Abteilung im Formular",
                    "department_creator": "Abteilung der bestellenden Person",
                    "client_form": "Unternehmen im Formular",
                    "client_creator": "Unternehmen der bestellenden Person",
                    "no_selection": "noch nicht ausgewählt",
                    "no_action": "nicht anwendbar"
                },
                "cancellation_dialog": {
                    "title_procurement": "Stornierung",
                    "btn_procurement": "Stornieren",
                    "message_procurement": "Möchten Sie diese Bestellung wirklich stornieren?",
                    "title_invoice": "Aussteuerung",
                    "btn_invoice": "Aussteuern",
                    "message_invoice": "Möchten Sie diese Rechnung wirklich aussteuern?"
                }
            }
        },
        "tour": {
            "overview": {
                "search_box": "Mit der Suche können Sie die Bestellanforderungen unter \"Meine Aufgaben\" und \"Alle Belege\" filtern und nach verschiedenen Informationen suchen, um bestimmte Bestellanforderungen schneller zu finden.",
                "tab_tasks": "Hier sehen Sie die Bestellanforderungen, für die Sie aktuell zuständig sind. In der rechten Spalte sehen Sie den Status Ihrer Aufgaben.",
                "tab_all_procurements": "In dieser Baumstruktur finden Sie alle Bestellanforderungen, nach aktuellem Status sortiert.",
                "refresh_btn": "Hier können Sie die Übersicht über die Bestellanforderungen aktualisieren.",
                "type_filter": "Hier können Sie nach dem Typ der Aufgabe filtern."
            },
            "procurement": {
                "form_title": "Formular der Bestellanforderung",
                "form": "Hier sehen Sie Informationen zu der Bestellanforderung.",
                "approve_btn_title": "Bestellanforderung weiterleiten",
                "approve_btn": "Wenn Sie eine Aufgabe erledigt haben und die Bestellanforderung an die nächste zuständige Person oder den nächsten Schritt weiterleiten wollen, drücken Sie den blauen Haken.",
                "reassign_btn": "Wenn Sie die Aufgabe nicht abschließen wollen, weil es z.B. noch Unklarheiten gibt oder eine andere Person die Aufgabe weiterbearbeiten soll, können Sie den roten Button drücken. Dann können Sie die Aufgabe entweder abgeben oder jemandem zur Klärung zuweisen. In der Klärung können Bestellanforderungen auch storniert werden.",
                "add_comment": "Über das Kommentarfeld können Sie zu der Bestellanforderung einen Kommentar abgeben. Dieser wird dann in der Timeline angezeigt.",
                "timeline_title": "Timeline",
                "timeline": "Die Timeline zeigt den vergangenen und zukünftigen Ablauf der Bestellanforderung sowie den aktuellen Status (blau) und Kommentare zu der Bestellanforderung. Über die Zahnrad-Schaltfläche kann die Sortierung umgekehrt werden.",
                "timeline_preferences": "Über diesen Button können Anzeigeeinstellungen an der Timeline vorgenommen werden. Beispielsweise kann eingestellt werden, ob die Ereignisse auf- oder absteigend sortiert werden sollen und ob Bearbeitungen der Bestellanforderung ein- oder ausgeblendet werden sollen."
            },
            "invoice": {
                "form_title": "Formular der Rechnung",
                "form": "Hier können Sie die Informationen zu der Rechnung erfassen oder bearbeiten.",
                "add_line": "Hier können Sie eine Rechnungsposition hinzufügen.",
                "edit_lines": "Hier können Sie Informationen zur der Rechnungspositionen anpassen.",
                "approve_btn_title": "Rechnung weiterleiten",
                "approve_btn": "Wenn Sie eine Aufgabe erledigt haben und die Rechnung an die nächste zuständige Person oder den nächsten Schritt weiterleiten wollen, drücken Sie den blauen Haken.",
                "reassign_btn": "Wenn Sie die Aufgabe nicht abschließen wollen, weil es z.B. noch Unklarheiten gibt oder eine andere Person die Aufgabe weiterbearbeiten soll, können Sie den roten Button drücken. Dann können Sie die Aufgabe entweder abgeben oder jemandem zur Klärung zuweisen. In der Klärung können Rechnung auch ausgesteuert werden.",
                "add_comment": "Über das Kommentarfeld können Sie zu der Rechnung einen Kommentar abgeben. Dieser wird dann in der Timeline angezeigt.",
                "timeline_title": "Timeline",
                "timeline": "Die Timeline zeigt den vergangenen und zukünftigen Ablauf der Rechnung sowie den aktuellen Status (blau) und Kommentare zu der Rechnung. Über die Zahnrad-Schaltfläche kann die Sortierung umgekehrt werden.",
                "timeline_preferences": "Über diesen Button können Anzeigeeinstellungen an der Timeline vorgenommen werden. Beispielsweise kann eingestellt werden, ob die Ereignisse auf- oder absteigend sortiert werden sollen und ob Bearbeitungen der Rechnung ein- oder ausgeblendet werden sollen."
            },
            "welcome": {
                "logo_title": "Willkommen bei liftbase!",
                "logo": "<p>Um Ihnen den Einstieg zu erleichtern, erklären wir Ihnen das wichtigste mit einer Tour durch liftbase.</p> <p>Verwenden Sie die Buttons unten oder Ihre Pfeiltasten, um durch die Tour zu navigieren.</p>",
                "menu": "In der oberen rechten Ecke befindet sich das Hauptmenü, über das Sie alle wichtigen Bereiche von liftbase finden.",
                "menu_help": "Sie können die einzelnen Abschnitte der Tour jederzeit beenden und zu einem späteren Zeitpunkt im Hilfe-Menü neu starten.",
                "menu_admin": "Hier finden Sie den nächsten Abschnitt der Tour."
            }
        }
    },
    "liquidity_planning": {
        "subtitle": "Visualisieren Sie den aktuellen Cashflow je Unternehmen, planen Sie Folgewochen und vergleichen Sie alternative Szenarien.",
        "horizon_hint": "Standardansicht: aktuelle Kalenderwoche, 12 Folgewochen und anschließend 6 Monatsblöcke. Manuelle Einträge werden immer auf KW-Basis gepflegt.",
        "scenario_placeholder": "Szenario wählen",
        "scenario": "Szenario",
        "start_date": "Startdatum",
        "start_date_required": "Bitte geben Sie ein Startdatum ein.",
        "start_date_min_today": "Das Startdatum muss heute oder später sein.",
        "active_filters": "Aktive Filter",
        "default_scenario_name": "Hauptszenario",
        "no_scenarios_found": "Keine Szenarien gefunden.",
        "opening_balance": "Saldo zu Beginn",
        "ending_balance": "Saldo zum Periodenende",
        "inflow": "Einzahlungen",
        "outflow": "Auszahlungen",
        "total_in_period": "Gesamtsumme im sichtbaren Zeitraum",
        "last_visible_period": "Saldo am Ende der letzten sichtbaren Periode",
        "empty_client_description": "Wählen Sie zuerst ein Unternehmen aus, um die Liquiditätsplanung zu laden.",
        "empty_scenario_description": "Für dieses Unternehmen gibt es noch kein Szenario. Legen Sie jetzt das erste Szenario an.",
        "table_row_label": "Position",
        "manual_row_label": "Zeilenbezeichnung",
        "manual_row_label_required": "Bitte geben Sie eine Zeilenbezeichnung ein.",
        "add_manual_row": "Manuelle Zeile hinzufügen",
        "add_manual_row_individual": "Einzeln eingeben",
        "add_manual_row_spreadsheet": "Arbeitsblatt (Excel)",
        "manual_spreadsheet_hint": "Die erste Zeile wird in der Planung ausgewiesen. Das gesamte Arbeitsblatt wird gespeichert.",
        "manual_spreadsheet_unavailable": "Die Tabelle ist nicht verfügbar. Bitte schließen Sie den Editor und öffnen Sie ihn erneut.",
        "manual_spreadsheet_values_required": "Bitte tragen Sie mindestens einen Wert oder eine Formel in die erste Zeile ein.",
        "manual_edit": "Manuell pflegen",
        "manual_entries": "Manuelle Einträge",
        "manual_entries_hint": "Pflegen Sie hier Bezeichnung und Betrag je Kalenderwoche. In der Monatsansicht werden die Wochen automatisch verdichtet.",
        "manual_week": "Kalenderwoche",
        "manual_entry_label": "Bezeichnung",
        "manual_entry_amount": "Betrag",
        "manual_entries_count": "{count} manuelle Einträge",
        "documents_count": "{count} Datensätze",
        "pending": "Überfällig",
        "open_outgoing_invoices": "Offene Ausgangsrechnungen",
        "open_incoming_invoices": "Offene Eingangsrechnungen",
        "open_procurements": "Offene Bestellungen",
        "view_records": "Datensätze anzeigen",
        "records_number": "Nummer",
        "records_name": "Name",
        "records_date": "Datum",
        "records_amount": "Betrag",
        "unassigned_cost_type": "Ohne Kostenart",
        "unassigned_revenue_type": "Ohne Erlösart",
        "select_cost_type": "Kostenart wählen",
        "select_revenue_type": "Erlösart wählen",
        "manual_row_type_save_error": "Die manuelle Zeile konnte nicht der gewählten Kosten- bzw. Erlösart zugeordnet werden. Bitte Hasura-Metadaten aktualisieren (metadata apply) und erneut speichern.",
        "balance_source_statement": "Anker aus Kontoauszug bis {date}",
        "balance_source_manual": "Nur manuelle Szenario-Anpassung aktiv",
        "balance_source_none": "Kein historischer Kontostand vorhanden",
        "load_error": "Die Liquiditätsplanung konnte nicht geladen werden.",
        "save_error": "Das Szenario konnte nicht gespeichert werden.",
        "create_scenario": "Szenario anlegen",
        "copy_scenario": "Szenario kopieren",
        "delete_scenario": "Szenario löschen",
        "delete_scenario_confirm": "Möchten Sie dieses Szenario wirklich löschen? Dieser Schritt ist irreversibel.",
        "create_scenario_prompt": "Geben Sie den Namen für das neue Szenario ein.",
        "edit_scenario_prompt": "Geben Sie den neuen Namen für dieses Szenario ein.",
        "copy_scenario_prompt": "Geben Sie den Namen für die Kopie ein.",
        "copy_suffix": "Kopie",
        "name_required": "Bitte geben Sie einen Namen ein.",
        "delete_manual_row_confirm": "Möchten Sie diese manuelle Zeile wirklich löschen?",
        "table_width": "Spaltenbreite",
        "show_chart": "Diagramm anzeigen",
        "view_standard": "Standard (13 KW + 6 Monate)",
        "view_all_weeks": "Alle Wochen",
        "view_all_months": "Alle Monate",
        "add_manual_row_inflow": "Manuelle Einzahlung",
        "add_manual_row_outflow": "Manuelle Auszahlung",
        "discard_unsaved_title": "Ungespeicherte Änderungen",
        "discard_unsaved_confirm": "Sie haben ungespeicherte Änderungen. Wenn Sie die Ansicht wechseln, gehen diese verloren. Möchten Sie fortfahren?",
        "discard_unsaved_confirm_button": "Änderungen verwerfen"
    },
    "operator_area": {
        "title": "Operator",
        "tenant_menu": "Tenants",
        "feature_billing_menu": "Feature-Monetarisierung",
        "feature_usage_menu": "Feature-Nutzung",
        "mcp_usage_menu": "MCP-Nutzung",
        "invoice_recognition_menu": "Belegerkennung",
        "ai_llm_menu": "KI/LLM-Monitor",
        "holiday_settings_menu": "Feiertage",
        "einvoice_acceptance_menu": "E-Rechnung Akzeptanzregeln",
        "bank_statement_fixtures_menu": "Kontoauszug-Testdateien",
        "procurement_menu": "Bestellanforderungen",
        "invoice_menu": "Rechnungen",
        "invoice_export_log_menu": "Export-Protokoll",
        "no_permission": "Sie haben keine Berechtigung, diesen Bereich zu sehen.",
        "invoice_export_log": {
            "title": "Export-Protokoll",
            "filters": {
                "tenant": "Tenant filtern",
                "invoice_id": "Rechnungs-ID",
                "export_group": "Exportgruppe",
                "module": "Modul",
                "source": "Quelle",
                "include_exported": "Bereits exportierte einbezogen",
                "clear": "Filter zurücksetzen"
            },
            "sources": {
                "bulk": "Mehrfachauswahl",
                "individual": "Einzelexport"
            },
            "statuses": {
                "success": "Erfolg",
                "partial": "Teilweise",
                "failed": "Fehler",
                "empty": "Ohne Export"
            },
            "columns": {
                "id": "ID",
                "status": "Status",
                "created_at": "Erstellt am",
                "tenant": "Tenant",
                "module": "Modul",
                "source": "Quelle",
                "include_exported": "Bereits exportierte",
                "requested_by": "Angefordert von",
                "export_group": "Exportgruppe",
                "requested": "Angefragt",
                "exported": "Exportiert",
                "skipped": "Übersprungen",
                "failed": "Fehler",
                "requested_invoice_ids": "Angefragte Rechnungen",
                "actually_exported_invoice_ids": "Tatsächlich exportierte Rechnungen",
                "skipped_already_exported_invoice_ids": "Bereits exportierte übersprungen",
                "failed_invoice_ids": "Fehlgeschlagene Rechnungen",
                "error_details": "Registrierter Fehler"
            },
            "copy_success": "Export-Protokoll wurde kopiert.",
            "copy_failed": "Export-Protokoll konnte nicht kopiert werden.",
            "errors": {
                "load_failed": "Das Export-Protokoll konnte nicht geladen werden."
            }
        },
        "holiday_settings": {
            "title": "Feiertagskalender",
            "subtitle": "Pflegen Sie Feiertage nach Land und Bundesland/Region. Leere Bundesland-Liste bedeutet, dass der Feiertag landesweit gilt.",
            "add": "Feiertag hinzufügen",
            "create_title": "Feiertag anlegen",
            "edit_title": "Feiertag bearbeiten",
            "year_filter": "Jahr filtern",
            "state_filter": "Bundesland filtern",
            "country_filter": "Land filtern",
            "regions_placeholder": "Bundesländer/Regionen auswählen oder eingeben",
            "nationwide": "Landesweit",
            "empty_regions_hint": "Wenn kein Bundesland hinterlegt ist, gilt der Feiertag für das gesamte Land.",
            "delete_confirm": "Möchten Sie diesen Feiertag wirklich löschen?"
        },
        "einvoice_acceptance": {
            "title": "E-Rechnung Akzeptanzregeln",
            "subtitle": "Konfigurieren Sie KI-Ausnahmeanweisungen und die Kritikalität lokaler E-Rechnungsprüfungen.",
            "add": "Regel hinzufügen",
            "create_title": "Akzeptanzregel anlegen",
            "edit_title": "Akzeptanzregel bearbeiten",
            "error_code": "Regel / Fehlercode",
            "error_code_placeholder": "Regel suchen, z. B. BR-CL-23 oder Einheitencode",
            "error_code_description": "Kurzbeschreibung",
            "instruction": "Anweisung für die KI",
            "instruction_placeholder": "Regel: BR-CL-23\nBefund: Nicht standardisierter Einheitencode\nEntscheidung: ACCEPT, sofern Menge, Leistung, Summen und Steuerberechnung trotzdem eindeutig sind\nBegründung: Die Abweichung betrifft den technischen Einheitencode, führt aber nicht automatisch zu einer inhaltlich oder steuerlich unbrauchbaren Rechnung.",
            "enabled": "Aktiv",
            "delete_confirm": "Möchten Sie diese Akzeptanzregel wirklich löschen?",
            "with_ai": "Mit KI",
            "without_ai": "Ohne KI",
            "edit_lists": "Regellisten bearbeiten",
            "edit_lists_title": "Regellisten ohne KI bearbeiten",
            "edit_lists_hint": "Verschieben Sie jede lokale Prüfregel in die passende Liste. Änderungen werden erst beim Speichern übernommen.",
            "manual_rule": "Manuelle Regel",
            "manual_rule_placeholder": "Beliebigen Regel- oder Fehlercode eingeben",
            "add_manual_rule": "Regel hinzufügen",
            "critical": "Kritisch",
            "critical_hint": "Ein Befund aus dieser Liste hält die E-Rechnung blockiert.",
            "non_critical": "Nicht kritisch",
            "non_critical_hint": "Eine E-Rechnung mit ausschließlich Befunden aus dieser Liste kann die lokale Prüfung bestehen.",
            "comment": "Kommentar",
            "comment_placeholder": "Optionaler Kommentar zu dieser Regel",
            "edit_comment_title": "Regelkommentar bearbeiten",
            "no_comment": "Kein Kommentar"
        },
        "bank_statement_fixtures": {
            "title": "Kontoauszug-Testdateien",
            "subtitle": "Download von automatisch generierten Kontoauszug-Testdateien auf Basis offener Rechnungen des aktuellen Tenants.",
            "access_notice": "Nur für Operatoren. Die ZIP-Datei enthält echte tenantbezogene Testfälle inklusive manifest.json.",
            "format_label": "Ausgabeformat",
            "format_placeholder": "Kontoauszugformat auswählen",
            "format_hint": "Wählen Sie ein Zielformat. Alle heruntergeladenen Varianten werden in diesem Format erzeugt.",
            "format_required": "Bitte wählen Sie zuerst ein Kontoauszugformat aus.",
            "client_hint": "Wählen Sie das Unternehmen aus, dessen offene Rechnungen für die Kontoauszug-Testdateien verwendet werden sollen.",
            "client_required": "Bitte wählen Sie zuerst ein Unternehmen aus.",
            "client_placeholder": "Unternehmen mit offenen Rechnungen auswählen",
            "load_clients_error": "Die verfügbaren Unternehmen konnten nicht geladen werden.",
            "setup_title": "Konfiguration",
            "setup_hint": "Wählen Sie zuerst das Zielformat und das Unternehmen aus, bevor Sie einzelne oder alle Testfälle herunterladen.",
            "selection_ready": "Bereit zum Erzeugen der Testdateien",
            "selection_incomplete": "Bitte Format und Unternehmen auswählen",
            "selection_hint": "Das ausgewählte Unternehmen liefert die offenen Rechnungen und Stammdaten für jede heruntergeladene Variante.",
            "selection_format": "Format",
            "selection_company": "Unternehmen",
            "variants_title": "Verfügbare Testfälle",
            "variants_hint": "Wählen Sie unten einen gezielten Testfall aus oder laden Sie nach der Konfiguration direkt die komplette ZIP-Datei herunter.",
            "technical_details": "Technische Vorschau",
            "missing_value": "Nicht ausgewählt",
            "download_all": "Alle Varianten herunterladen",
            "download_variant": "Variante herunterladen",
            "download_ready": "Der Download wurde gestartet.",
            "download_error": "Die Testdateien konnten nicht heruntergeladen werden.",
            "endpoint_label": "Endpunkt",
            "auto_match_title": "Auto-Match",
            "auto_match_description": "Lädt gezielte Testfälle herunter, bei denen Buchungen automatisch mit offenen Rechnungen abgeglichen werden sollten.",
            "mixed_title": "Gemischter Testfall",
            "mixed_description": "Enthält einen automatischen Treffer, eine nicht zuordenbare Belastung und eine ignorierte Gutschrift.",
            "random_title": "Random Multi-Match",
            "random_description": "Enthält mehrere realistische Buchungen mit mehreren Treffern, zusätzlichen unmatched-Buchungen und einer ignorierten Gutschrift.",
            "counterparty_distinction_title": "Gegenpartei vs. Kontoinhaber",
            "counterparty_distinction_description": "Erzeugt einen gezielten CAMT-Testfall, bei dem Gegenpartei und Kontoinhaber im Auszug absichtlich unterschiedlich sind, damit beide Spalten separat geprüft werden können.",
            "supplier_iban_mismatch_title": "Lieferanten-IBAN Abweichung",
            "supplier_iban_mismatch_description": "Lädt einen gezielten Testfall herunter, bei dem das Lieferunternehmen erkannt wird, der IBAN im Kontoauszug aber von den Stammdaten abweicht."
        },
        "tenant": {
            "description": "Tenant",
            "new": "Neuer Tenant",
            "edit": "Bearbeiten",
            "archive": "Archivieren",
            "delete": "Löschen",
            "activate": "Wiederherstellen",
            "procurement_count": "BANF",
            "user_count": "Benutzer",
            "automatic_billing": "Automatische Abrechnung",
            "automatic_billing_via": "Ja (via {id})",
            "automatic_billing_missing_easybill_id": "Ja (keine ID verknüpft)",
            "storage_usage": "Speicherplatz",
            "tabs": {
                "general": "Allgemein",
                "invoice_config": "Abrechnung",
                "ai": "KI"
            },
            "standard_package": "Basispaket",
            "invoice": {
                "items": {
                    "label": "Zusatzpositionen",
                    "description": "Bezeichnung",
                    "price": "Netto-Betrag",
                    "start_date": "Startdatum",
                    "end_date": "Enddatum"
                },
                "tiered_price": {
                    "label": "Staffel Preise",
                    "unit_price": "Einzelpreis",
                    "base_price": "Grundpreis",
                    "doc_amount": "Menge"
                }
            },
            "contact_email_tooltip": "Mit dieser E-Mail kann der Tenant sich erstmal einloggen.",
            "no_bank_info": "Die Daten sind noch nicht vorhanden und können nur vom Tenant erzeugt werden.",
            "no_connection_with_easybill": "Dieser Tenant ist noch nicht mit Easybill verbunden. Bitte hinterlegen Sie die Tenant-ID im Easybill System.",
            "sync_with_easybill": "Alle Daten von Easybill abrufen",
            "update_from_easybill_btn": "Von Easybill abrufen",
            "update_from_easybill_tooltip": "Tenant von Easybill abrufen",
            "send_to_easybill_btn": "In Easybill erstellen",
            "send_to_easybill_tooltip": "Tenant in Easybill erstellen",
            "link_existing_easybill_btn": "Mit bestehender Easybill-ID verknüpfen",
            "link_existing_easybill_tooltip": "Vorhandene Easybill-Kunden-ID manuell hinterlegen",
            "link_easybill_replace_title": "Easybill-ID ersetzen?",
            "link_easybill_replace_message": "Dieser Tenant ist bereits mit der Easybill-ID {current} verknüpft. Soll die Verknüpfung auf {next} geändert werden?",
            "link_easybill_title": "Easybill-ID verknüpfen",
            "link_easybill_prompt": "Bitte geben Sie die vorhandene Easybill-Kunden-ID ein.",
            "link_easybill_invalid": "Bitte geben Sie eine numerische ID ein.",
            "create_and_send_invoice_tooltip": "Rechnung in Easybill erstellen und an Kunden absenden",
            "create_and_send_invoice_btn": "Rechnung erstellen/absenden",
            "open_invoices": "Abrechnungen ansehen",
            "delete_procurements": "BANF Löschen",
            "delete_invoices": "Rechnungen Löschen",
            "confirm_before_delete_msg": "<p>Möchten Sie diesen Tenant und alle seinen Daten wirklich von der Datenbank löschen?</p><p> <i>Diese Aktion kann nicht rückgängig gemacht werden.</i></p><p><b>Geben Sie den Namen des Tenants an:</b></p>",
            "confirm_before_delete_error_msg": "Der Tenant wurde nicht gelöscht, weil der Name falsch eingegeben wurde.",
            "deleted_msg": "Der Tenant wurde endgültig gelöscht.",
            "updated_msg": "Es wurde aktualisiert.",
            "created_msg": "Es wurde erstellt.",
            "sync_msg_error": "Dieser Tenant ist noch nicht mit Easybill verbunden. Bitte hinterlegen Sie die Tenant-ID im Easybill System.",
            "create_invoice_dialog": {
                "title": "Abrechnung erstellen",
                "message": "Wählen Sie den Zeitraum für die Rechnung aus.",
                "date_placeholder": "Wählen Sie einen Monat aus.",
                "create_btn": "Erstellen"
            },
            "validation": {
                "name_required": "Bitte geben Sie einen Namen ein.",
                "name_exists": "Der Name existiert bereits.",
                "email_required": "Bitte geben Sie eine Kontakt-E-Mail ein.",
                "email_invalid": "Bitte geben Sie eine gültige E-Mail ein."
            },
            "ai": {
                "enabled": "KI-Funktionen aktivieren",
                "model_name": "Name des KI-Modells",
                "max_tokens": "Maximale Tokens pro Anfrage (pro 1.000 Tokens)",
                "price_input_tokens": "Preis pro 1.000 Eingabe-Tokens (Cent)",
                "price_output_tokens": "Preis pro 1.000 Ausgabe-Tokens (Cent)"
            }
        },
        "procurement": {
            "title": "Bestellanforderungen von Tenant",
            "delete_title": "Bestellanforderung löschen",
            "result_found": "Treffer",
            "delete_result_found": "Treffer löschen",
            "start_date": "Startdatum",
            "end_date": "Enddatum",
            "range_separator": "bis",
            "confirm_delete_msg": "Sind Sie sicher, dass Sie die ausgewählten Bestellanforderungen endgültig aus der Datenbank löschen möchten?",
            "confirm_delete_title": "Bestellanforderung löschen",
            "confirm_delete_btn": "Löschen"
        },
        "invoice": {
            "title": "Rechnungen von Tenant",
            "delete_title": "Rechnungen löschen",
            "result_found": "Treffer",
            "delete_result_found": "Treffer löschen",
            "start_date": "Startdatum",
            "end_date": "Enddatum",
            "range_separator": "bis",
            "confirm_delete_msg": "Sind Sie sicher, dass Sie die ausgewählten Rechnungen endgültig aus der Datenbank löschen möchten?",
            "confirm_delete_title": "Rechnung löschen",
            "confirm_delete_btn": "Löschen"
        },
        "feature_usage": {
            "title": "Feature-Nutzung nach Tenant",
            "empty_state": "Für den ausgewählten Zeitraum wurde keine getrackte Feature-Nutzung gefunden.",
            "not_available": "k. A.",
            "unknown_tenant": "Unbekannter Tenant",
            "filters": {
                "tenant_placeholder": "Nach Tenant filtern"
            },
            "units": {
                "ms": "ms",
                "seconds": "s"
            },
            "summary": {
                "total_usage": "Erfasste Nutzungen",
                "active_tenants": "Aktive Tenants",
                "used_features": "Genutzte Features",
                "avg_usage_per_tenant": "Ø Nutzung pro Tenant",
                "top_feature": "Top-Feature",
                "of_active_base": "der aktiven Basis",
                "top_feature_hint": "{usage} erfasste Nutzungen in {tenants} Tenants"
            },
            "charts": {
                "top_features": "Top-Features",
                "top_features_subtitle": "Features mit der höchsten Nachfrage im gewählten Zeitraum.",
                "daily_trend": "Tagesverlauf",
                "daily_trend_subtitle": "Getracktes Nutzungsvolumen pro Tag.",
                "procurement_sources": "Beschaffungsquellen",
                "procurement_sources_subtitle": "Wie Produkte im gewählten Zeitraum in Bestellanforderungen gelangt sind.",
                "punchout_providers": "Punchout-Anbieter",
                "punchout_providers_subtitle": "Marktplatznutzung nach importierten Punchout-Produkten.",
                "daily_usage_label": "Nutzung"
            },
            "procurement_sources": {
                "punchout": "Punchout",
                "catalog": "Produktkatalog",
                "on_the_fly": "On-the-fly",
                "unknown_punchout": "Unbekannter Punchout"
            },
            "errors": {
                "schema_missing": "Feature-Usage-Tracking ist in dieser Umgebung noch nicht verfuegbar. Bitte die Hasura-Migration und die Metadata fuer tenant_feature_usage anwenden und die Seite neu laden.",
                "load_failed": "Feature-Nutzung konnte nicht geladen werden."
            },
            "tables": {
                "features": "Feature-Ranking",
                "features_subtitle": "Nachfrage pro Feature über die aktive Tenant-Basis.",
                "tenants": "Tenant-Ranking",
                "tenants_subtitle": "Aktivste Tenants und ihre dominanten Features.",
                "modules": "Modul-Überblick",
                "modules_subtitle": "Konsolidierte Nachfrage je Katalogmodul."
            },
            "columns": {
                "feature": "Feature",
                "module": "Modul",
                "total_usage": "Nutzung",
                "active_tenants": "Tenants",
                "avg_per_tenant": "Ø / Tenant",
                "event_breakdown": "Ereignisse",
                "top_tenant": "Top-Tenant",
                "last_used": "Letzte Nutzung",
                "tenant": "Tenant",
                "used_features": "Features",
                "top_feature": "Top-Feature"
            }
        },
        "mcp_usage": {
            "title": "MCP-Nutzung",
            "empty_state": "Für den ausgewählten Zeitraum wurde keine MCP-Nutzung gefunden.",
            "no_errors": "Für den ausgewählten Zeitraum wurden keine MCP-Fehler gefunden.",
            "not_available": "k. A.",
            "units": {
                "ms": "ms",
                "seconds": "s"
            },
            "unknown_tenant": "Unbekannter Tenant",
            "filters": {
                "tenant_placeholder": "Nach Tenant filtern"
            },
            "summary": {
                "total_calls": "MCP-Aufrufe",
                "active_tenants": "Aktive Tenants",
                "active_users": "Aktive Benutzer",
                "success_rate": "Erfolgsquote",
                "error_calls_suffix": "Aufrufe mit Fehlern",
                "quality_score": "Qualitätswert",
                "quality_score_hint": "Abgeleitet aus Tool-Ergebnissen, Warnungen und Ergebnisqualität.",
                "answer_completion": "Abgeleitete Vollständigkeit",
                "empty_results_suffix": "leere Ergebnisse",
                "avg_duration": "Ø Dauer",
                "paginated_calls": "Paginierte Aufrufe",
                "quality_signals_suffix": "Qualitätssignale",
                "session_feedback": "Session-Feedback",
                "session_feedback_hint": "Anonymisierte Produkt-Insights aus MCP-Gesprächen."
            },
            "charts": {
                "daily_trend": "Tagesverlauf",
                "daily_trend_subtitle": "MCP-Aufrufe pro Tag im ausgewählten Zeitraum.",
                "top_tools": "Top-Tools",
                "top_tools_subtitle": "Am häufigsten genutzte MCP-Tools.",
                "outcomes": "Ergebnisse",
                "outcomes_subtitle": "Erfolgreiche, blockierte und fehlgeschlagene Aufrufe.",
                "answer_quality": "Antwortqualität",
                "answer_quality_subtitle": "Abgeleitete Vollständigkeit der Antworten, ohne Prompts oder Antworten zu speichern.",
                "entities": "Objekte",
                "entities_subtitle": "Fachobjekte, die über MCP abgefragt wurden.",
                "calls_label": "Aufrufe"
            },
            "tables": {
                "tools": "Tool-Ranking",
                "tools_subtitle": "Nutzung, Erfolgsquote und durchschnittliche Dauer pro Tool.",
                "tenants": "Tenant-Ranking",
                "tenants_subtitle": "Tenants mit der höchsten MCP-Aktivität.",
                "quality": "Qualitätsfokus",
                "quality_subtitle": "Tools mit leeren Ergebnissen, Warnungen, ignorierten Filtern oder niedriger abgeleiteter Qualität.",
                "answer_reasons": "Antwortgründe",
                "answer_reasons_subtitle": "Warum Antworten vollständig, teilweise, blockiert oder unbekannt waren.",
                "errors": "Fehler-Fokus",
                "errors_subtitle": "Sanitisierte Fehlerkategorien ohne Prompts oder Payloads.",
                "session_feedback": "Session-Feedback",
                "session_feedback_subtitle": "Kurze anonymisierte Hinweise der KI zu Routing-Problemen, Lücken und Fehlverdacht."
            },
            "columns": {
                "tool": "Tool",
                "category": "Kategorie",
                "answer_outcome": "Antwort",
                "reason": "Grund",
                "calls": "Aufrufe",
                "success_rate": "Erfolg",
                "quality_score": "Qualität",
                "empty_results": "Leer",
                "warnings": "Warnungen",
                "ignored_filters": "Ignorierte Filter",
                "avg_duration": "Ø Dauer",
                "tenant": "Tenant",
                "users": "Benutzer",
                "top_tool": "Top-Tool",
                "last_used": "Letzte Nutzung",
                "error": "Fehler",
                "when": "Zeitpunkt",
                "feedback_category": "Kategorie",
                "severity": "Schwere",
                "summary": "Hinweise",
                "related_tools": "Tools",
                "related_entities": "Objekte"
            },
            "outcomes": {
                "success": "Erfolg",
                "error": "Fehler",
                "permission_denied": "Keine Berechtigung",
                "rate_limited": "Rate-Limit",
                "validation_error": "Validierungsfehler",
                "timeout": "Timeout",
                "authentication_error": "Authentifizierungsfehler",
                "unknown": "Unbekannt"
            },
            "answer_outcomes": {
                "complete": "Vollständig",
                "partial": "Teilweise",
                "blocked": "Blockiert",
                "empty_result": "Leeres Ergebnis",
                "low_confidence": "Niedrige Sicherheit",
                "unknown": "Unbekannt"
            },
            "feedback_reasons": {
                "success": "Erfolgreich",
                "no_data": "Keine Daten",
                "authentication_error": "Authentifizierung",
                "permission_denied": "Keine Berechtigung",
                "rate_limited": "Rate-Limit",
                "timeout": "Timeout",
                "validation_error": "Validierungsfehler",
                "ambiguous_master_data": "Mehrdeutige Stammdaten",
                "paginated_result": "Paginierte Ergebnisse",
                "tool_error": "Tool-Fehler",
                "low_confidence": "Niedrige Sicherheit",
                "not_supported": "Nicht unterstützt",
                "filters_ignored": "Ignorierte Filter",
                "warnings": "Warnungen",
                "unknown": "Keine Angabe"
            },
            "entities": {
                "none": "Allgemein",
                "bcase": "Workflow",
                "invoice": "Eingangsrechnungen",
                "outgoing_invoice": "Ausgangsrechnungen",
                "procurement": "Bestellanforderungen",
                "contract": "Verträge",
                "bank_statement_entry": "Kontoauszugsbuchungen"
            },
            "no_session_feedback": "Für den ausgewählten Zeitraum wurde kein Session-Feedback gefunden.",
            "session_feedback_categories": {
                "bug_suspicion": "Fehlerverdacht",
                "missing_capability": "Fehlende Fähigkeit",
                "wrong_routing": "Falsches Routing",
                "data_quality": "Datenqualität",
                "ux_friction": "UX-Reibung",
                "feature_request": "Feature-Wunsch",
                "positive_signal": "Positives Signal",
                "unknown": "Unbekannt"
            },
            "session_feedback_severities": {
                "low": "Niedrig",
                "medium": "Mittel",
                "high": "Hoch",
                "unknown": "Unbekannt"
            },
            "no_quality_issues": "Für den ausgewählten Zeitraum wurden keine MCP-Qualitätssignale gefunden.",
            "errors": {
                "schema_missing": "MCP-Nutzungsanalyse ist in dieser Umgebung noch nicht verfügbar. Bitte die Hasura-Migration und Metadata für mcp_usage_event anwenden und die Seite neu laden.",
                "load_failed": "MCP-Nutzung konnte nicht geladen werden."
            }
        },
        "ai_llm": {
            "title": "KI/LLM-Monitor",
            "empty_state": "Für den ausgewählten Zeitraum liegen keine LLM-Aufrufe vor.",
            "no_errors": "Im ausgewählten Zeitraum liegen keine LLM-Fehler vor.",
            "unknown_tenant": "Unbekannter Tenant",
            "unknown_region": "Unbekannter Azure-Endpunkt",
            "unknown_operation": "Unbekannte Operation",
            "unknown_model": "Unbekanntes Modell",
            "filters": {
                "tenant_placeholder": "Nach Tenant filtern",
                "operation_placeholder": "Nach Operation filtern",
                "model_placeholder": "Nach Modell filtern",
                "status_placeholder": "Nach Status filtern"
            },
            "shortcuts": {
                "this_month": "Aktueller Monat",
                "last_month": "Letzter Monat",
                "last_7_days": "Letzte 7 Tage",
                "last_30_days": "Letzte 30 Tage"
            },
            "summary": {
                "total_calls": "LLM-Aufrufe",
                "total_calls_hint": "Zentral vom Backend protokollierte Azure-OpenAI-Aufrufe.",
                "success_rate": "Erfolgsquote",
                "succeeded_suffix": "erfolgreiche Aufrufe",
                "fallbacks": "Fallbacks genutzt",
                "fallbacks_hint": "Erfolgreiche Aufrufe, die einen zweiten Azure-Endpunkt erreicht haben.",
                "failures": "Fehler",
                "rejected_suffix": "nicht-regionale Ablehnungen",
                "system_status": "Systemstatus",
                "tokens": "Tokens",
                "tokens_hint": "{input} Eingabe / {output} Ausgabe",
                "estimated_cost": "Geschätzte Kosten",
                "estimated_cost_hint": "Wird angezeigt, wenn Token-Preise konfiguriert sind."
            },
            "health_states": {
                "unknown": "Keine Daten",
                "unknown_hint": "Für die ausgewählten Filter wurden keine Aufrufe protokolliert.",
                "normal": "Normal",
                "normal_hint": "LLM-Aufrufe sind im ausgewählten Zeitraum erfolgreich.",
                "degraded": "Beeinträchtigt",
                "degraded_hint": "Fehler oder Fallback-Nutzung benötigen Aufmerksamkeit.",
                "unavailable": "Nicht verfügbar",
                "unavailable_hint": "Es wurden keine erfolgreichen LLM-Aufrufe protokolliert."
            },
            "alerts": {
                "unavailable_title": "LLM wirkt nicht verfügbar",
                "unavailable_description": "Alle protokollierten Aufrufe sind im ausgewählten Zeitraum fehlgeschlagen oder wurden blockiert.",
                "failure_rate_high_title": "Hohe LLM-Fehlerquote",
                "failure_rate_high_description": "Der ausgewählte Bereich hat eine Fehlerquote von {rate}.",
                "failure_rate_warning_title": "Erhöhte LLM-Fehlerquote",
                "failure_rate_warning_description": "Der ausgewählte Bereich hat eine Fehlerquote von {rate}.",
                "fallbacks_title": "Fallbacks wurden genutzt",
                "fallbacks_description": "{count} erfolgreiche Aufruf(e) benötigten einen zweiten Azure-Endpunkt."
            },
            "healthcheck": {
                "action": "Healthcheck starten",
                "title": "Manueller Healthcheck",
                "subtitle": "Live-Test der Azure-OpenAI-Endpunkte, ausgelöst durch einen Operator.",
                "success": "Mindestens ein Azure-Endpunkt hat erfolgreich geantwortet.",
                "warning": "Kein Azure-Endpunkt hat erfolgreich geantwortet.",
                "error": "Der LLM-Healthcheck konnte nicht abgeschlossen werden.",
                "no_endpoints_title": "Keine Azure-Endpunkte getestet",
                "no_endpoints_description": "Bitte prüfen, ob endpoint, api-key und deployment für Azure OpenAI konfiguriert sind.",
                "all_ok_title": "Alle Azure-Endpunkte sind erreichbar",
                "all_ok_description": "{count} Azure-Endpunkt(e) haben erfolgreich geantwortet.",
                "partial_title": "Ein Teil der Azure-Endpunkte ist erreichbar",
                "partial_description": "{succeeded} von {total} Azure-Endpunkt(en) haben erfolgreich geantwortet. Bitte die Fehlerdetails pro Endpunkt prüfen.",
                "none_ok_title": "Kein Azure-Endpunkt hat erfolgreich geantwortet",
                "none_ok_description": "Der Endpunkt kann korrekt sein, aber API-Key, Deployment-Name oder Berechtigungen passen nicht für mindestens einen Azure-OpenAI-Resource."
            },
            "charts": {
                "region_health": "Azure-Endpunkt-Status",
                "region_health_subtitle": "Erfolgreiche und fehlgeschlagene Azure-OpenAI-Aufrufe nach Endpunkt und Operation.",
                "daily_failures": "Fehlerverlauf",
                "daily_failures_subtitle": "Fehlgeschlagene, abgelehnte und blockierte Aufrufe pro Tag.",
                "failures_label": "Fehler"
            },
            "tables": {
                "regions": "Azure-Endpunkte und Operationen",
                "regions_subtitle": "Aggregierter Status nach Azure-OpenAI-Endpunkt, Operation und Modell.",
                "latest_errors": "Letzte Fehler",
                "latest_errors_subtitle": "Aktuelle fehlgeschlagene oder abgelehnte LLM-Aufrufe für die operative Prüfung."
            },
            "columns": {
                "created_at": "Zeitpunkt",
                "tenant": "Tenant",
                "region": "Region",
                "azure_endpoint": "Azure-Endpunkt",
                "operation": "Operation",
                "model": "Modell",
                "calls": "Aufrufe",
                "successes": "Erfolge",
                "failures": "Fehler",
                "failure_rate": "Fehlerquote",
                "avg_duration": "Ø Laufzeit",
                "status": "Status",
                "http_status": "HTTP",
                "retries": "Wiederholungen",
                "duration": "Laufzeit",
                "error": "Fehler"
            },
            "statuses": {
                "succeeded": "Erfolgreich",
                "failed": "Fehlgeschlagen",
                "rejected": "Abgelehnt",
                "circuit_open": "Endpunkt gesperrt"
            },
            "units": {
                "milliseconds": "{value} ms",
                "seconds": "{value} s"
            },
            "errors": {
                "schema_missing": "LLM-Logging ist in dieser Umgebung noch nicht verfügbar. Bitte Hasura-Migration und Metadata für ai_llm_call_log anwenden und die Seite neu laden.",
                "load_failed": "LLM-Dashboard-Daten konnten nicht geladen werden."
            }
        },
        "invoice_recognition": {
            "title": "Belegerkennung – Monitor",
            "empty_state": "Für den ausgewählten Zeitraum liegen keine Daten vor.",
            "no_switchovers": "Im gewählten Zeitraum waren keine regionalen Umschaltungen nötig.",
            "no_in_flight": "Aktuell keine laufenden Erkennungen in der Warteschlange.",
            "unknown_tenant": "Unbekannter Tenant",
            "processing_active": "Wird verarbeitet",
            "processing_idle": "Wartet",
            "copy_success": "In die Zwischenablage kopiert.",
            "copy_failed": "Kopieren fehlgeschlagen.",
            "filters": {
                "tenant_placeholder": "Nach Tenant filtern"
            },
            "shortcuts": {
                "this_month": "Aktueller Monat",
                "last_month": "Letzter Monat",
                "last_7_days": "Letzte 7 Tage",
                "last_30_days": "Letzte 30 Tage"
            },
            "summary": {
                "invoices_processed": "Verarbeitete Belege",
                "invoices_processed_hint": "{attempts} Versuche insgesamt",
                "successful": "Erfolgreich erkannt",
                "switchovers": "Region-Umschaltungen",
                "switchovers_hint": "Belege, die mindestens einen Region-Wechsel erforderten (relevant für MS-Erstattung).",
                "failed": "Endgültig fehlgeschlagen",
                "failed_hint": "Belege ohne erfolgreiche Erkennung (zur manuellen Prüfung übergeben).",
                "in_flight": "Aktuell in Bearbeitung",
                "in_flight_hint": "Belege in der Erkennungs-Warteschlange."
            },
            "charts": {
                "region_status": "Versuche pro Region",
                "region_status_subtitle": "Verteilung der Erkennungsversuche je Region und Status.",
                "daily_failures": "Fehlerverlauf",
                "daily_failures_subtitle": "Fehlgeschlagene Versuche pro Tag im gewählten Zeitraum.",
                "failures_label": "Fehler"
            },
            "tables": {
                "switchovers": "Belege mit Region-Umschaltung",
                "switchovers_subtitle": "Belege, die mindestens einmal auf eine andere Region umgeschaltet werden mussten. Zeile aufklappen, um den vollständigen Versuchsverlauf inkl. Provider-Operation-IDs zu sehen (Beleg für MS-Erstattungen).",
                "region_health": "Region-Status",
                "region_health_subtitle": "Aktuelle Gesundheit jeder Azure-AI-Region im gewählten Zeitraum.",
                "in_flight": "Laufende Erkennungen",
                "in_flight_subtitle": "Belege, die aktuell in der Warteschlange auf eine Antwort warten."
            },
            "columns": {
                "tenant": "Tenant",
                "invoice_id": "Beleg-ID",
                "region_path": "Region-Verlauf",
                "attempt_count": "Versuche",
                "final_status": "Endstatus",
                "last_attempt": "Letzter Versuch",
                "operation_id": "Operation-ID",
                "region": "Region / Modell",
                "total_attempts": "Versuche",
                "successes": "Erfolge",
                "failures": "Fehler",
                "failure_rate": "Fehlerquote",
                "last_failure": "Letzter Fehler",
                "poll_attempts": "Polls",
                "elapsed": "Laufzeit",
                "processing": "Status"
            },
            "statuses": {
                "submitted": "Übermittelt",
                "succeeded": "Erfolgreich",
                "failed": "Fehler",
                "timed_out": "Zeitüberschreitung",
                "submission_failed": "Übermittlung fehlgeschlagen",
                "circuit_open": "Region gesperrt"
            },
            "models": {
                "document_intelligence": "Document Intelligence",
                "content_understanding": "Content Understanding",
                "azure_open_ai": "Azure OpenAI"
            },
            "errors": {
                "load_failed": "Daten konnten nicht geladen werden."
            },
            "tabs": {
                "operations": "Betrieb",
                "quality": "Qualität",
                "approval_quality": "Freigabequalität"
            },
            "approval_quality": {
                "scope_manual": "Manuell geprüft",
                "scope_auto": "Automatisch weitergeleitet",
                "scope_all": "Alle Entscheidungen",
                "methodology": "Standardmäßig werden alle KI-Freigabeentscheidungen verglichen — inklusive automatisch weitergeleiteter. Freigegeben = Buchhaltung, Export oder abgeschlossen; storniert = abgelehnt oder Storno exportiert. Laufende und technisch nicht auswertbare Entscheidungen zählen nicht in die Qualitätsquoten.",
                "invoices_evaluated": "Ausgewertete Belege",
                "invoices_evaluated_hint": "{decided} Entscheidungen, davon {pending} laufend und {unavailable} technisch nicht auswertbar",
                "false_approval_rate": "Falschfreigabequote",
                "false_approval_rate_hint": "{falseApprovals} von {aiApprovals} vorgeschlagenen KI-Freigaben wurden später storniert.",
                "approval_precision": "Korrekte KI-Freigaben",
                "approval_precision_hint": "Anteil der vorgeschlagenen KI-Freigaben, die am Ende freigegeben blieben.",
                "missed_automation_rate": "Verpasste Automatisierung",
                "missed_automation_rate_hint": "{missed} von {approved} final freigegebenen Belegen wurden von der KI nicht freigegeben.",
                "agreement_rate": "Übereinstimmung",
                "agreement_rate_hint": "Anteil der aufgelösten Fälle, in denen KI und Endergebnis übereinstimmen.",
                "matrix_title": "KI-Entscheidung gegen Endergebnis",
                "matrix_subtitle": "Nur abgeschlossene, technisch auswertbare Entscheidungen im gewählten Zeitraum.",
                "actual_approved": "Final freigegeben",
                "actual_cancelled": "Final storniert",
                "ai_approved": "KI hätte freigegeben",
                "ai_rejected": "KI hätte nicht freigegeben",
                "correct": "Korrekt",
                "false_approval": "Falschfreigabe",
                "missed_automation": "Verpasste Automatisierung",
                "false_approvals_title": "Falschfreigaben im Detail",
                "false_approvals_subtitle": "Bis zu 80 Belege, welche die KI freigegeben hätte, die am Ende jedoch storniert wurden.",
                "empty_state": "Für den ausgewählten Zeitraum wurden keine Falschfreigaben gefunden.",
                "load_failed": "Daten zur Freigabequalität konnten nicht geladen werden.",
                "number": "Rechnungsnummer",
                "score": "KI-Score",
                "threshold": "Grenzwert",
                "reasons": "Entscheidende Signale",
                "final_status": "Endstatus",
                "auto_forwarded": "Automatisch",
                "decided_at": "KI-Entscheidung",
                "yes": "Ja",
                "no": "Nein"
            },
            "quality": {
                "scope_all": "Alle Belege",
                "scope_manual": "Manuell geprüft",
                "scope_auto": "KI-Autodurchlauf",
                "methodology": "Vergleich: Snapshot nach Belegerkennung und KI-Validierung gegen den aktuellen Beleg. Geändertes Feld = Erkennung unzutreffend.",
                "invoices_evaluated": "Bewertete Belege",
                "invoices_evaluated_hint": "{manual} manuell geprüft, {auto} automatisch weitergeleitet",
                "mean_field_rate": "Arithmetisches Mittel",
                "mean_field_rate_hint": "Durchschnitt der Erkennungsquoten aller Felder.",
                "median_field_rate": "Median",
                "median_field_rate_hint": "Erkennungsquote des mittleren Feldes, weniger von Ausreißern beeinflusst.",
                "mean_receipt_score": "Mittelwert je Beleg",
                "median_receipt_score_hint": "Median je Beleg: {median}",
                "field_chart_title": "Erkennungsquote je Feld",
                "field_chart_subtitle": "Anteil der Belege, bei denen das Feld nach der Erkennung unverändert blieb.",
                "groups_title": "Feldgruppen",
                "groups_subtitle": "Gewichtete Quote je Gruppe (nur bewertete Felder).",
                "fields_title": "Felder im Detail",
                "fields_subtitle": "Unverändert = korrekt erkannt. Leere Felder auf beiden Seiten fließen nicht ein.",
                "invoices_title": "Belege mit den niedrigsten Quoten",
                "invoices_subtitle": "Die 80 Belege mit der schwächsten Übereinstimmung im gewählten Zeitraum. Zeile aufklappen für geänderte Felder.",
                "empty_state": "Für den Zeitraum liegen noch keine Baselines vor. Die Messung startet mit neu erkannten Belegen nach diesem Release.",
                "load_failed": "Qualitätsdaten konnten nicht geladen werden.",
                "field": "Feld",
                "group": "Gruppe",
                "evaluated": "Bewertet",
                "matched": "Unverändert",
                "rate": "Quote",
                "number": "Rechnungsnummer",
                "receipt_score": "Beleg-Quote",
                "fields_short": "Felder",
                "auto_forwarded": "Autodurchlauf",
                "auto_yes": "Ja",
                "auto_no": "Nein",
                "baseline_at": "Snapshot",
                "baseline": "Nach Erkennung",
                "final_value": "Aktuell",
                "no_mismatches": "Keine abweichenden Felder.",
                "groups": {
                    "document": "Belegdaten",
                    "bank": "Bankdaten",
                    "matching": "Zuordnung",
                    "organization": "Organisation",
                    "lines": "Positionen"
                }
            }
        },
        "feature_billing": {
            "title": "Feature-Monetarisierung",
            "sync": "Katalog synchronisieren",
            "new_package": "Neues Paket",
            "create_package": "Paket erstellen",
            "edit_package": "Paket bearbeiten",
            "sync_success": "Feature-Katalog wurde synchronisiert.",
            "catalog_hint": "In diesem Bereich werden bestehende Module, Features und Pakete monetarisiert, ohne das aktuelle Laufzeitverhalten des Systems zu verändern.",
            "overview_title": "Übersicht & Kennzahlen",
            "show_overview": "Kennzahlen anzeigen",
            "hide_overview": "Kennzahlen ausblenden",
            "edit_feature": "Monetarisierung bearbeiten",
            "manage_tenants": "Tenants verwalten",
            "assign_tenant": "Tenant zuweisen",
            "manage_package_tenants": "Paket-Tenants verwalten",
            "assign_package": "Paket zuweisen",
            "assignment_dialog_title": "Tenant-Feature-Zuordnung",
            "package_assignment_dialog_title": "Tenant-Paket-Zuordnung",
            "custom_price_hint": "Leer lassen, um den Standardpreis des Features zu verwenden.",
            "not_configured": "Nicht konfiguriert",
            "no_assignments": "Keine Tenant-Zuordnung vorhanden.",
            "unassigned_module": "Ohne Modul",
            "unassigned_module_description": "Features, die unabhängig von einem bestimmten Modul monetarisiert werden.",
            "package_features_label": "Enthaltene Features",
            "package_feature_hint": "Wählen Sie die Features aus, die zu diesem Paket gehören.",
            "package_code_placeholder": "stabiles-paket-kürzel",
            "package_code_hint": "Wird automatisch aus dem Paketnamen generiert.",
            "catalog_inactive": "Katalog inaktiv",
            "billing_enabled": "Monetarisierung aktiv",
            "billing_disabled": "Monetarisierung inaktiv",
            "tabs": {
                "features": "Features",
                "packages": "Pakete",
                "tenants": "Tenants",
                "ai_automation": "KI-Automation"
            },
            "summary": {
                "modules": "Module",
                "features": "Features",
                "packages": "Pakete",
                "direct_assignments": "Direkte Zuordnungen",
                "package_assignments": "Paket-Zuordnungen",
                "active_assignments": "Aktive Zuordnungen",
                "trial_assignments": "Demo-Zuordnungen"
            },
            "sections": {
                "package_assignments": "Paket-Zuordnungen",
                "direct_feature_assignments": "Direkte Feature-Zuordnungen"
            },
            "columns": {
                "module": "Modul",
                "feature": "Feature",
                "package": "Paket",
                "code": "Code",
                "description": "Beschreibung",
                "catalog_status": "Katalogstatus",
                "billing_type": "Abrechnungsart",
                "default_price": "Standardpreis",
                "default_demo_days": "Demo-Tage",
                "pricing": "Preis & Laufzeit",
                "coverage": "Nutzung",
                "composition": "Umfang",
                "assignments": "Zuordnungen",
                "direct_assignments": "Direkt",
                "covered_tenants": "Tenants gesamt",
                "packages": "Pakete",
                "included_features": "Enthaltene Features",
                "references": "Systemreferenz",
                "tenant": "Tenant",
                "status": "Status",
                "effective_price": "Effektiver Preis",
                "custom_price": "Individueller Preis",
                "demo_until": "Demo bis",
                "active_features": "Aktiv",
                "active_packages": "Pakete",
                "trial_features": "Demo",
                "total_assignments": "Gesamt"
            },
            "ai_automation": {
                "title": "KI-Automatisierung nach Kunde und Lieferant",
                "description": "Bewertet KI-validierte Rechnungen danach, ob sie ohne relevante manuelle Korrektur bis zum Export verarbeitet wurden.",
                "details_title": "Monatliche Auswertung",
                "empty_title": "Noch keine KI-Automatisierungsdaten",
                "empty_text": "Nach angewendeter Migration und exportierten KI-validierten Rechnungen werden hier die Auswertungen gefüllt.",
                "unknown_tenant": "Unbekannter Tenant",
                "unknown_client": "Unbekannter Kunde",
                "unknown_supplier": "Unbekannter Lieferant",
                "no_client": "Kein Kunde",
                "no_supplier": "Kein Lieferant",
                "detail_title": "Rechnungsdetails",
                "actions": {
                    "details": "Details"
                },
                "summary": {
                    "total_invoices": "Rechnungen",
                    "ai_validated": "KI-validiert",
                    "one_click_export": "One-Click-Export",
                    "best_case": "Best Case",
                    "automation_value": "Automationswert",
                    "manual_corrections": "Manuelle Korrekturen"
                },
                "columns": {
                    "company": "Unternehmen",
                    "client_supplier": "Kunde / Lieferant",
                    "period": "Zeitraum",
                    "supplier": "Lieferant",
                    "billing_tier": "Abrechnungsstufe",
                    "ai_validated": "KI-validiert",
                    "email_imported": "E-Mail",
                    "auto_export": "Auto-Export",
                    "exported": "Exportiert",
                    "one_click": "One-Click",
                    "best_case": "Best Case",
                    "manual_corrections": "Manuelle Korrekturen"
                },
                "column_help": {
                    "tenant": "Tenant bzw. Mandant, zu dem diese Monatszeile gehört.",
                    "client_supplier": "Kombination aus Kunde und Lieferant für die in dieser Zeile berücksichtigten Rechnungen.",
                    "period": "Kalendermonat und Jahr, auf die sich diese Auswertung bezieht.",
                    "billing_tier": "Abgeleitete Abrechnungsstufe auf Basis des gemessenen Automationswerts dieser Zeile.",
                    "ai_validated": "Wie viele Rechnungen von allen Rechnungen in dieser Zeile KI-validiert wurden. Die Zusatzzeile zeigt, wie viele per E-Mail importiert wurden.",
                    "auto_export": "Rechnungen, die automatisch in Richtung Export weitergeleitet wurden. Die Zusatzzeile zeigt, wie viele davon erfolgreich exportiert wurden.",
                    "one_click": "Rechnungen, die nach der KI-Prüfung mit einer einmaligen Bestätigung exportiert werden konnten.",
                    "best_case": "Rechnungen mit dem höchsten Automationsgrad, typischerweise E-Mail-Import und One-Click-Export ohne relevante manuelle Korrektur.",
                    "manual_corrections": "Rechnungen, bei denen nach der KI-Verarbeitung noch relevante manuelle Änderungen nötig waren. Die Zusatzzeile zeigt die Korrekturarten.",
                    "actions": "Öffnet die Rechnungsdetails für die ausgewählte Monatszeile."
                },
                "detail_columns": {
                    "invoice": "Rechnung",
                    "automation": "Automation",
                    "ki": "KI",
                    "export": "Export",
                    "corrections": "Korrekturen",
                    "result": "Ergebnis"
                },
                "boolean": {
                    "yes": "Ja",
                    "no": "Nein"
                },
                "labels": {
                    "email": "E-Mail",
                    "validated": "Validiert",
                    "auto_forwarded": "Auto-Export",
                    "one_click": "One-Click",
                    "best_case": "Best Case",
                    "not_exported": "Nicht exportiert"
                },
                "automation_levels": {
                    "unknown": "Unbekannt",
                    "no_ai": "Keine KI",
                    "ai_not_validated": "Nicht validiert",
                    "manual_correction": "Manuelle Korrektur",
                    "ki_validated_waiting": "KI validiert",
                    "ki_autonomous_to_export_ready": "Bis Export vorbereitet",
                    "one_click_export": "One-Click-Export",
                    "email_import_one_click_export": "E-Mail One-Click-Export"
                },
                "billing_tiers": {
                    "premium": "Premium",
                    "advanced": "Advanced",
                    "automation": "Automation",
                    "assist": "Assistenz",
                    "base": "Basis"
                },
                "billing_tier_legend": {
                    "title": "Abrechnungsstufe",
                    "items": {
                        "base": "Kaum messbarer Automationswert in dieser Zeile.",
                        "assist": "Die KI unterstützt, aber manuelle Arbeit dominiert noch.",
                        "automation": "Spürbarer Automationsgewinn; mehrere Rechnungen sind mit wenig manuellem Aufwand exportbereit.",
                        "advanced": "Hoher Automationsgrad mit nur gelegentlichen manuellen Eingriffen.",
                        "premium": "Sehr hoher Automationsgrad; die meisten Rechnungen laufen nahezu touchless."
                    }
                },
                "correction_types": {
                    "values": "Werte",
                    "bank": "Bank",
                    "organization": "Organisation",
                    "other": "Sonstige",
                    "note_only": "Nur Notiz geändert",
                    "none": "Keine relevante Korrektur"
                }
            },
            "billing_types": {
                "monthly": "Monatlich",
                "yearly": "Jährlich",
                "one_time": "Einmalig",
                "usage": "Nutzungsbasiert",
                "included": "Inklusive"
            },
            "assignment_statuses": {
                "active": "Aktiv",
                "trial": "Demo",
                "inactive": "Inaktiv"
            },
            "validation": {
                "package_name_required": "Bitte geben Sie einen Paketnamen ein.",
                "package_code_required": "Bitte geben Sie einen gültigen Paket-Code ein.",
                "package_features_required": "Bitte wählen Sie mindestens ein Feature für das Paket aus."
            },
            "catalog_labels": {
                "procurement": {
                    "name": "Beschaffung",
                    "description": "Workflows für Bestellanforderungen, Freigaben und Bestellautomatisierung."
                },
                "procurement-core": {
                    "name": "Bestellanforderungen",
                    "description": "Kernprozess für die Beschaffung mit Erstellung, Inbox und Freigaben von Anforderungen."
                },
                "procurement-approval-flows": {
                    "name": "Genehmigungsketten",
                    "description": "Mehrstufige Freigabeketten und Eskalationen für Bestellanforderungen."
                },
                "procurement-budget-control": {
                    "name": "Budgetkontrolle",
                    "description": "Budgetzuordnung, Freigabelimits und finanzielle Prüfungen in der Beschaffung."
                },
                "procurement-punchout": {
                    "name": "Punchout & Marktplätze",
                    "description": "Punchout-Lieferanten und Marktplatz-Integrationen für den Bestellprozess."
                },
                "procurement-ai-suggestions": {
                    "name": "KI-Bestellvorschläge",
                    "description": "KI-gestützte Vorschläge und Vorbelegungen für Bestellanforderungen auf Basis früherer Bestellungen, Lieferunternehmen und Verträge."
                },
                "supplier-communication": {
                    "name": "Lieferantenkommunikation",
                    "description": "Verknüpfte Kommunikation mit Lieferanten zu Dokumenten und Aufgaben."
                },
                "invoice": {
                    "name": "Rechnung",
                    "description": "Erfassung, Erkennung, Validierung und Export von Rechnungen."
                },
                "invoice-core": {
                    "name": "Rechnungsworkflow",
                    "description": "Rechnungseingang, Bearbeitungsworkflow und manuelle Prüfung."
                },
                "invoice-recognition": {
                    "name": "Rechnungserkennung",
                    "description": "Automatisierte OCR- und Extraktionspipeline für Rechnungen."
                },
                "invoice-lines-recognition": {
                    "name": "Rechnungspositionserkennung",
                    "description": "Erkennung und Import einzelner Rechnungspositionen."
                },
                "invoice-ai": {
                    "name": "KI-Validierung & Vorschläge",
                    "description": "KI-gestützte Rechnungsprüfung, Vorschläge und KI-Dashboard."
                },
                "invoice-export-datev": {
                    "name": "DATEV-Export",
                    "description": "Nativer DATEV-Export für verarbeitete Rechnungen."
                },
                "invoice-export-datev-csv": {
                    "name": "DATEV-CSV-Export",
                    "description": "CSV-basierte DATEV-Alternative für Rechnungsdaten."
                },
                "invoice-export-ms365": {
                    "name": "MS365-Export",
                    "description": "Microsoft-365- bzw. D365-Export von Rechnungen und Stammdaten-Sync."
                },
                "einvoice-dashboard": {
                    "name": "E-Rechnungs-Dashboard",
                    "description": "Operatives Dashboard mit Einblicken in die Verarbeitung von E-Rechnungen."
                },
                "contract": {
                    "name": "Vertrag",
                    "description": "Workflows für den Vertragslebenszyklus und zugehörige Dokumentautomatisierung."
                },
                "contract-core": {
                    "name": "Vertragsmanagement",
                    "description": "Vertragserstellung, Laufzeitverfolgung und Aufgabensteuerung."
                },
                "contract-reminders": {
                    "name": "Vertragserinnerungen",
                    "description": "Erinnerungsworkflows für Verlängerungen, Fristen und Termine."
                },
                "contract-linked-procurement": {
                    "name": "Beschaffung aus Vertrag",
                    "description": "Bestellanforderungen auf Basis bestehender Verträge erstellen."
                },
                "master-data": {
                    "name": "Stammdaten",
                    "description": "Stammdaten-Governance, Berechtigungen und Erweiterbarkeit."
                },
                "permission-groups": {
                    "name": "Berechtigungsgruppen",
                    "description": "Berechtigungsgruppen und berechtigungsabhängige Stammdaten."
                },
                "custom-fields": {
                    "name": "Benutzerdefinierte Felder",
                    "description": "Individuelle Felder für Beschaffung, Rechnungen und verbundene Datensätze."
                },
                "multilingual-master-data": {
                    "name": "Mehrsprachige Stammdaten",
                    "description": "Mehrsprachige Übersetzungen für Produkte, Gruppen und Finanzstammdaten."
                },
                "advanced-master-data": {
                    "name": "Erweiterte Stammdatenpflege",
                    "description": "Erweiterte Pflege von Unternehmen, Lieferanten, Produkten und Finanzdimensionen."
                },
                "platform": {
                    "name": "Plattform",
                    "description": "Übergreifende Plattformfunktionen, Analysen und Enterprise-Add-ons."
                },
                "dashboards": {
                    "name": "Operative Dashboards",
                    "description": "Analyse-Dashboards für operative Prozesse und Dokumentenverarbeitung."
                },
                "ai-prompts": {
                    "name": "KI-Prompt-Studio",
                    "description": "Prompt-Vorlagen, Versionen und Ausführungswerkzeuge im Admin-Bereich."
                },
                "sso-saml": {
                    "name": "SSO / SAML",
                    "description": "Single Sign-on mit mandantenspezifischer SAML-Konfiguration."
                },
                "email-notifications": {
                    "name": "E-Mail-Benachrichtigungen",
                    "description": "Mandantenweite E-Mail-Benachrichtigungen für Dokumente und Workflows."
                }
            }
        }
    },
    "timeline": {
        "title": "Timeline",
        "preferences": {
            "order_asc": "Älteste zuerst",
            "order_desc": "Neuste zuerst",
            "comment_notifications": "E-Mail-Benachrichtigung bei Kommentaren",
            "comment_notifications_enabled": "Kommentarbenachrichtigungen aktiviert.",
            "comment_notifications_disabled": "Kommentarbenachrichtigungen deaktiviert."
        },
        "text": {
            "description_assignment": "Die Aufgabe wurde angenommen.",
            "cancellation": {
                "name": "{name}",
                "description_past_successful_invoice": "Die Rechnung wurde ausgesteuert und archiviert.",
                "description_past_successful_outgoing-invoice": "Die Ausgangsrechnung wurde storniert und archiviert.",
                "description_past_successful_procurement": "Die Bestellung wurde storniert und archiviert.",
                "description_past_successful_contract": "Der Vertrag wurde storniert und archiviert.",
                "name_procurement": "Stornierung",
                "name_contract": "Stornierung",
                "name_outgoing-invoice": "Stornierung",
                "name_invoice": "Aussteuerung"
            },
            "start": {
                "name": "Neue Bestellanforderung",
                "description_past_successful": "Neue Bestellanforderung wurde erstellt."
            },
            "select-product": {
                "is_searchable": true,
                "simple_name": "Produktauswahl",
                "name": "Produktauswahl (Stufe {index})",
                "description_past_unsuccessful": "Produktauswahl wurde abgebrochen.",
                "description_past_successful": "Produkte für diese Bestellung wurden ausgewählt.",
                "description_present": "Bitte Produkte für diese Bestellung auswählen.",
                "description_future": "Produkte für diese Bestellung müssen ausgewählt werden."
            },
            "approval": {
                "is_searchable": true,
                "simple_name": "Freigabe Bestellanforderung",
                "name": "Freigabe Bestellanforderung (Stufe {index})",
                "description_past_unsuccessful": "Freigabe der Bestellung wurde abgebrochen.",
                "description_past_successful": "Bestellanforderung wurde geprüft und freigegeben.",
                "description_present": "Bitte Bestellanforderung prüfen und freigeben.",
                "description_future": "Bestellanforderung muss geprüft und freigegeben werden."
            },
            "send-order": {
                "is_searchable": true,
                "name": "Beauftragung der Bestellung",
                "description_past_unsuccessful": "Bestellung bei Lieferunternehmen wurde abgebrochen.",
                "description_past_successful": "Bestellung wurde bei Lieferunternehmen beauftragt.",
                "description_present": "Bitte Bestellung bei Lieferunternehmen beauftragen.",
                "description_future": "Bestellung muss bei Lieferunternehmen beauftragt werden."
            },
            "delivery": {
                "is_searchable": true,
                "name": "Bestätigung der Lieferung",
                "description_past_unsuccessful": "Bestätigung des Wareneingangs wurde abgebrochen.",
                "description_past_successful": "Ware wurde geliefert und Wareneingang bestätigt.",
                "description_present": "Bitte den Wareneingang bestätigen.",
                "description_future": "Wareneingang muss bestätigt werden."
            },
            "reassignment": {
                "name": "Zuweisung",
                "description_past_unsuccessful": "",
                "description_past_successful": "hat die Aufgabe {name} zugewiesen.",
                "description_past_successful_from_group": "hat die Aufgabe angenommen."
            },
            "clearing": {
                "is_searchable": true,
                "name": "Klärung",
                "description_past_unsuccessful": "Klärung wurde abgebrochen.",
                "description_past_successful": "Unklarheiten der Bestellung wurden geklärt.",
                "description_present": "Bitte die Bestellung klären.",
                "description_finished_unsuccessful": "Bestellung wurde storniert und archiviert."
            },
            "order-sent-internal": {
                "name": "Systemmeldung",
                "description_past_successful": "Die Bestellung <b>({first_product_name})</b> beim Lieferunternehmen <b>{supplier}</b> wurde bestätigt."
            },
            "order-sent-punchout": {
                "name": "Systemmeldung",
                "description_past_successful": "Die Bestellung <b>({first_product_name})</b> wurde elektronisch an das Lieferunternehmen <b>{supplier}</b> gesendet."
            },
            "product-received": {
                "name": "Systemmeldung",
                "description_past_successful": "<b>{quantity} {unit}</b> eingegangen:<p>{product}</p><span style=\"color:#9a9898\">{supplier}</span>"
            },
            "invoice-upload": {
                "name": "Neue Rechnung",
                "description_past_successful": "Die Rechnung wurde hochgeladen."
            },
            "invoice-recognition": {
                "is_searchable": true,
                "name": "Rechnungserkennung",
                "description_past_unsuccessful": "Die Erkennung der Rechnungsdaten wurde abgebrochen.",
                "description_past_successful": "Die Erkennung der Rechnungsdaten wurde abgeschlossen.",
                "description_present": "Die Rechnungsdaten werden ausgelesen, dies kann bis zu einer Minute dauern. Laden Sie die Seite neu, um das Ergebnis zu sehen."
            },
            "invoice-manual-check": {
                "is_searchable": true,
                "name": "Manuelle Prüfung",
                "description_past_unsuccessful": "Die manuelle Prüfung wurde nicht abgeschlossen.",
                "description_past_successful": "Die Rechnung wurde manuell geprüft.",
                "description_present": "Bitte die Rechnungsdaten prüfen.",
                "description_future": "Die Rechnung muss manuell geprüft werden."
            },
            "invoice-financial-approval": {
                "is_searchable": true,
                "simple_name": "Freigabe Rechnung",
                "name": "Freigabe Rechnung (Stufe {index})",
                "description_past_unsuccessful": "Freigabe der Rechnung wurde abgebrochen.",
                "description_past_successful": "Rechnung wurde geprüft und freigegeben.",
                "description_present": "Bitte Rechnung prüfen und freigeben.",
                "description_future": "Rechnung muss geprüft und freigegeben werden."
            },
            "invoice-clearing": {
                "is_searchable": true,
                "name": "Klärung Buchhaltung",
                "description_past_unsuccessful": "Klärung wurde abgebrochen.",
                "description_past_successful": "Unklarheiten der Rechnung wurden geklärt.",
                "description_present": "Bitte die Rechnung klären.",
                "description_finished_unsuccessful": "Die Rechnung wurde ausgesteuert und archiviert."
            },
            "invoice-export": {
                "is_searchable": true,
                "name": "Export",
                "description_past_unsuccessful": "Die Rechnung wurde nicht exportiert.",
                "description_past_successful": "Die Rechnung wurde an {export_name} übermittelt.",
                "description_present": "Die Rechnung steht zum Export bereit.",
                "description_future": "Die Rechnung steht zum Export bereit."
            },
            "invoice-accounting": {
                "is_searchable": true,
                "name": "Buchhaltung",
                "description_past_unsuccessful": "Die Buchhaltung wurde abgebrochen.",
                "description_past_successful": "Die Buchhaltung wurde geprüft.",
                "description_present": "Bitte die Buchhaltung prüfen.",
                "description_future": "Die Buchhaltung muss geprüft werden."
            },
            "invoice-verified": {
                "is_searchable": true,
                "name": "Verifiziert",
                "description_past_unsuccessful": "Die Verifizierung wurde abgebrochen.",
                "description_past_successful": "Die Rechnung wurde verifiziert.",
                "description_present": "Die Rechnung wird verifiziert.",
                "description_future": "Die Rechnung wird verifiziert."
            },
            "skip": {
                "name": "Abbruch",
                "description_past_successful": "hat den Schritt abgebrochen."
            },
            "contract-start": {
                "name": "Neuer Vertrag",
                "description_past_successful": "Der Vertrag wurde erstellt.",
            },
            "contract-recognition": {
                "is_searchable": true,
                "name": "Vertragserkennung",
                "description_past_successful": "Die Vertragsdaten wurden erkannt.",
                "description_present": "Die Vertragsdaten werden erkannt."
            },
            "contract-check": {
                "is_searchable": true,
                "name": "Vertrag Prüfung",
                "description_past_unsuccessful": "Die Prüfung wurde nicht abgeschlossen.",
                "description_past_successful": "Der Vertrag wurde geprüft.",
                "description_present": "Bitte die Vertragsdaten prüfen.",
            },
            "contract-signing": {
                "is_searchable": true,
                "name": "Vertragsunterzeichnung",
                "description_past_unsuccessful": "Der Vertrag wurde nicht unterzeichnet.",
                "description_past_successful": "Der Vertrag wurde unterzeichnet.",
                "description_present": "Bitte den Vertrag unterzeichnen.",
                "description_future": "Der Vertrag muss unterzeichnet werden."
            },
            "contract-clearing": {
                "is_searchable": true,
                "name": "Klärung Vertrag",
                "description_past_unsuccessful": "Klärung wurde abgebrochen.",
                "description_past_successful": "Unklarheiten des Vertrags wurden geklärt.",
                "description_present": "Bitte den Vertrag klären.",
                "description_finished_unsuccessful": "Der Vertrag wurde storniert und archiviert."
            },

        }
    },
    "jexcel": {
        "noRecordsFound": "Keine Einträge gefunden.",
        "showingPage": "Seite {0} von {1}",
        "show": "Zeigen ",
        "entries": " Einträge",
        "insertANewColumnBefore": "Spalte davor einfügen",
        "insertANewColumnAfter": "Spalte danach einfügen",
        "deleteSelectedColumns": "Ausgewählte Spalten löschen",
        "renameThisColumn": "Spalte umbenennen",
        "orderAscending": "Aufsteigend sortieren",
        "orderDescending": "Absteigend sortieren",
        "insertANewRowBefore": "Zeile davor einfügen",
        "insertANewRowAfter": "Zeile danach einfügen",
        "deleteSelectedRows": "Ausgewählte Zeilen löschen",
        "copy": "Kopieren",
        "paste": "Einfügen",
        "saveAs": "Speichern unter",
        "about": "Über",
        "areYouSureToDeleteTheSelectedRows": "Sind Sie sicher, dass Sie die ausgewählten Zeilen löschen wollen?",
        "areYouSureToDeleteTheSelectedColumns": "Sind Sie sicher, dass Sie die ausgewählten Spalten löschen wollen?",
        "thisActionWillDestroyAnyExistingMergedCellsAreYouSure": "Esta ação irá destruir todas as células mescladas existentes. Você tem certeza?",
        "thisActionWillClearYourSearchResultsAreYouSure": "Esta ação limpará seus resultados de pesquisa. Você tem certeza?",
        "thereIsAConflictWithAnotherMergedCell": "Há um conflito com outra célula mesclada",
        "invalidMergeProperties": "Propriedades mescladas inválidas",
        "cellAlreadyMerged": "Cell já mesclado",
        "noCellsSelected": "Nenhuma célula selecionada",
        "save_warning": "Das Kopieren und Einfügen von Daten zwischen externen Tabellen wie Excel und liftbase kann zu fehlerhaften Reihenfolgen und verlorenen ID-Beziehungen führen. <br>Bitte bearbeiten Sie die Daten ausschließlich direkt in liftbase oder fügen Sie Excel-Daten lediglich ergänzend ein."
    },
    "system_comment": {
        "name": {
            "allocation": "Zuordnung",
            "datev_export": "DATEV Exportierung",
            "export_error": "Fehler beim Export",
            "export_detail": "Exportprotokoll",
            "repeat_recognition": "Rechnungserkennung",
            "bank_data_export_summary": "Zahlungsmodalität",
            "payment": "Zahlung per Kontoauszug",
            "bank_statement_payment": "Zahlung per Kontoauszug",
            "contract-termination-email": "Vertragskündigung",
            "ai_validation": "KI-Validierung"
        },
        "contract_termination_email_sent": "E-Mail zur Kündigungserinnerung wurde an {recipient} gesendet.",
        "contract_termination_email_failed": "E-Mail zur Kündigungserinnerung konnte nicht an {recipient} gesendet werden. Fehler: {error}.",
        "ai_validation_trusted": "Die Rechnung wurde von der KI geprüft und als vertrauenswürdig eingestuft.",
        "ai_validation_not_trusted": "Die Rechnung wurde von der KI geprüft und zur manuellen Prüfung weitergeleitet.",
        "invoice_approval_restart": "Der Freigabeprozess der Rechnung wurde neu gestartet. Grund: {reason}",
        "recognition_was_repeated": "{user_name} hat die Belegerkennung wiederholt.",
        "attach_new_invoice_to_procurement": "Die Rechnung <b>{link_to_invoice}</b> von <b>{supplier_name}</b> wurde dieser Bestellanforderung von <b>{user_name}</b> zugeordnet.",
        "attach_new_invoice_to_bcase": "Die Rechnung <b>{link_to_invoice}</b> von <b>{supplier_name}</b> wurde diesem Beleg von <b>{user_name}</b> zugeordnet.",
        "change_bcase_of_invoice": "Die Zuordnung der Rechnung <b>{link_to_invoice}</b> von <b>{supplier_name}</b> wurde wieder entfernt. <br>Die Rechnung wurde dem Beleg {link_to_bcase} zugeordnet.",
        "detach_bcase_of_invoice": "Die Zuordnung der Rechnung <b>{link_to_invoice}</b> von <b>{supplier_name}</b> wurde wieder entfernt.",
        "attach_new_invoice_to_procurement_without_supplier": "Die Rechnung <b>{link_to_invoice}</b> wurde dieser Bestellanforderung von <b>{user_name}</b> zugeordnet.",
        "change_procurement_of_invoice": "Die Zuordnung der Rechnung <b>{link_to_invoice}</b> von <b>{supplier_name}</b> wurde wieder entfernt. <br>Die Rechnung wurde der Bestellanforderung {link_to_procurement} zugeordnet.",
        "change_procurement_of_invoice_without_supplier": "Die Zuordnung der Rechnung <b>{link_to_invoice}</b> wurde wieder entfernt. <br>Die Rechnung wurde der Bestellanforderung {link_to_procurement} zugeordnet.",
        "detach_procurement_of_invoice": "Die Zuordnung der Rechnung <b>{link_to_invoice}</b> von <b>{supplier_name}</b> wurde wieder entfernt.",
        "detach_procurement_of_invoice_without_supplier": "Die Zuordnung der Rechnung <b>{link_to_invoice}</b> wurde wieder entfernt.",
        "attach_external_invoice_to_procurement": "Die Rechnung {invoice_number} von <b>{supplier_name}</b> wurde dieser Bestellanforderung von <b>{invoice_by}</b> zugeordnet.",
        "insert_datev_note": "Die Rechnung <b>{link_to_invoice}</b> von <b>{supplier_name}</b> wurde an DATEV Unternehmen online übermittelt.",
        "insert_datev_note_without_supplier": "Die Rechnung <b>{link_to_invoice}</b> wurde an DATEV Unternehmen online übermittelt.",
        "on_ms365_export_error_generic": "Fehler beim Export der Rechnung an D365. Bitte wenden Sie sich an den Support.",
        "on_ms365_export_validation_error": "Fehler beim Export der Rechnung an D365. Bitte wenden Sie sich an den Support. Fehler: {error}",
        "on_export_error": "Die Rechnung konnte nicht an DATEV Unternehmen online übermittelt werden. {error}",
        "on_export_error_generic": "Fehler beim Export der Rechnung an DATEV. Bitte wenden Sie sich an den Support.",
        "on_export_error_validation": "{supplier_external_id_export_validation}{supplier_name_export_validation} Bitte wenden Sie sich an eine Person mit Administrationsrechten um die Konfiguration zu überprüfen.",
        "on_export_error_datev_access_is_not_active": "Die Verbindung mit DATEV muss hergestellt werden. Bitte wenden Sie sich an eine Person mit Administratorenrechten.",
        "on_export_error_client_has_no_datev_access": "Das Unternehmen {client_name} hat keine DATEV-Zugangsdaten hinterlegt. Bitte wenden Sie sich an eine Person mit Administratorenrechten.",
        "on_export_error_client_has_no_datev_permission": "Beim der Übermittlung an DATEV ist ein Fehler aufgetreten. Der eingerichtete DATEV-Zugang hat keine Berechtigung für das Unternehmen {client_name}. Bitte wenden Sie sich an eine Person mit Administrationsrechten, um den Zugang oder die konfigurierten Unternehmen oder die Berechtigungen innerhalb DATEV zu überprüfen.",
        "on_export_error_datev_has_protocol_entries": "Fehler beim Export der Rechnung an DATEV. Bitte prüfen Sie das Exportprotokoll oder wenden Sie sich an den Support.",
        "on_export_error_no_fiscal_year": "Beim der Übermittlung an DATEV ist ein Fehler aufgetreten. Das Rechnungsdatum liegt nicht im DATEV Geschäftsjahr. Bitte wenden Sich sich an eine Person mit Administrationsrechten, um das Geschäftsjahr in DATEV zu überprüfen.",
        "on_export_error_invoice_not_active_for_fiscal_year": "Beim der Übermittlung an DATEV ist ein Fehler aufgetreten. Das DATEV Geschäftsjahr ist nicht für die Übermittlung von Eingangsrechnungen freigegeben. Bitte wenden Sich sich an eine Person mit Administrationsrechten, um das Geschäftsjahr in DATEV zu überprüfen.",
        "on_export_error_no_account_combination": "Konto-Kombination konnte nicht gefunden werden: {combination}.",
        "on_export_error_running": "Export gesperrt: Eine andere Instanz führt diesen Vorgang bereits aus.",
        "on_export_error_outgoing_invoice_not_supported": "Ausgangsrechnungen können nicht exportiert werden. Der Workflow endet mit der Verifizierung.",
        "on_export_error_document_discount_tax_required": "Der Dokumentrabatt kann nicht exportiert werden, weil die MwSt.-Zuordnung fehlt oder zu keiner Rechnungsposition passt. Bitte wählen Sie den MwSt.-Satz des Rabatts.",
        "on_export_error_document_discount_exceeds_base": "Der Dokumentrabatt ist höher als die Nettobasis der zugehörigen Rechnungspositionen und kann nicht exportiert werden.",
        "on_export_error_document_discount_invalid": "Der Dokumentrabatt kann nicht exportiert werden. Bitte prüfen Sie Betrag, Basis und MwSt.-Satz des Rabatts.",
        "insert_datev_protocol_note": "<b>Status</b>: {status} <br><br> <b>Protokolleinträge</b>: <br> {protocol}",
        "labels": {
            "ai_validation_trusted_label": "Die Rechnung wurde von der KI geprüft und als vertrauenswürdig eingestuft.",
            "ai_validation_not_trusted_label": "Die Rechnung wurde von der KI geprüft und zur manuellen Prüfung weitergeleitet.",
            "ai_validation_trusted_score_only_label": "Die Rechnung wurde von der KI als vertrauenswürdig eingestuft. {score_block}",
            "ai_validation_not_trusted_score_only_label": "Die Rechnung wurde zur manuellen Prüfung weitergeleitet. {score_block}",
            "ai_validation_trusted_reasons_label": "Die Rechnung wurde von der KI als vertrauenswürdig eingestuft. {score_block} Entscheidend waren außerdem: {ai_validation_reason_value}.",
            "ai_validation_not_trusted_reasons_label": "Die Rechnung wurde zur manuellen Prüfung weitergeleitet. {score_block} Entscheidend waren: {ai_validation_reason_value}.",
            "ai_validation_not_trusted_insufficient_positive_label": "Die Rechnung wurde zur manuellen Prüfung weitergeleitet. {score_block} Die positiven Signale reichten nicht aus: {ai_validation_reason_value}.",
            "ai_validation_score_block_risk_passed": "Aus positiven und negativen Signalen hat die KI ein Gesamtrisiko von {score} berechnet — das entspricht einem {score_level} Risikoniveau. Für die automatische Freigabe muss dieses Risiko unter {threshold} liegen; diese Grenze ist erfüllt.",
            "ai_validation_score_block_risk_failed": "Aus positiven und negativen Signalen hat die KI ein Gesamtrisiko von {score} berechnet — das entspricht einem {score_level} Risikoniveau. Für die automatische Freigabe muss dieses Risiko unter {threshold} liegen; dieser Wert liegt darüber.",
            "ai_validation_score_block_confidence_passed": "Aus den geprüften Signalen hat die KI einen Konfidenzwert von {score} berechnet — das entspricht einem {score_level} Niveau. Für die automatische Freigabe muss dieser Wert mindestens {threshold} betragen; diese Anforderung ist erfüllt.",
            "ai_validation_score_block_confidence_failed": "Aus den geprüften Signalen hat die KI einen Konfidenzwert von {score} berechnet — das entspricht einem {score_level} Niveau. Für die automatische Freigabe muss dieser Wert mindestens {threshold} betragen; der erreichte Wert reicht nicht aus.",
            "ai_validation_score_block_green_sum_passed": "Aus den positiven Signalen hat die KI eine Summe von {score} berechnet — das entspricht einem {score_level} Niveau. Für die automatische Freigabe muss dieser Wert mindestens {threshold} betragen; diese Anforderung ist erfüllt.",
            "ai_validation_score_block_green_sum_failed": "Aus den positiven Signalen hat die KI eine Summe von {score} berechnet — das entspricht einem {score_level} Niveau. Für die automatische Freigabe muss dieser Wert mindestens {threshold} betragen; der erreichte Wert reicht nicht aus.",
            "ai_validation_score_level_risk_very_low": "sehr niedrigen",
            "ai_validation_score_level_risk_low": "niedrigen",
            "ai_validation_score_level_risk_acceptable": "unkritischen",
            "ai_validation_score_level_risk_elevated": "erhöhten",
            "ai_validation_score_level_risk_high": "hohen",
            "ai_validation_score_level_confidence_very_low": "sehr geringen",
            "ai_validation_score_level_confidence_low": "geringen",
            "ai_validation_score_level_confidence_moderate": "moderaten",
            "ai_validation_score_level_confidence_high": "hohen",
            "ai_validation_score_level_confidence_very_high": "sehr hohen",
            "ai_validation_score_level_green_sum_very_low": "sehr geringen",
            "ai_validation_score_level_green_sum_low": "geringen",
            "ai_validation_score_level_green_sum_moderate": "moderaten",
            "ai_validation_score_level_green_sum_high": "hohen",
            "ai_validation_score_level_green_sum_very_high": "sehr hohen",
            "ai_validation_risk_compensated_label": "Erkannte Risiken ({ai_validation_secondary_reason_value}) wurden durch die positiven Signale ausgeglichen.",
            "ai_validation_positive_signals_label": "Positive Signale ({ai_validation_secondary_reason_value}) reichten nicht aus, um die Risiken auszugleichen.",
            "ai_validation_reason_and": "und",
            "ai_validation_reason_GREEN_01": "die Pflichtfelder vollständig sind",
            "ai_validation_reason_GREEN_02": "die Rechnung zum bisherigen Muster dieses Lieferunternehmens passt",
            "ai_validation_reason_GREEN_03": "die Absender-E-Mail bekannt ist und mit den Stammdaten übereinstimmt",
            "ai_validation_reason_GREEN_04": "die Beträge zur Leistung plausibel wirken",
            "ai_validation_reason_GREEN_05": "der Leistungszeitraum klar und ohne Überschneidung ist",
            "ai_validation_reason_GREEN_06": "die Bankverbindung mit den hinterlegten Stammdaten übereinstimmt",
            "ai_validation_reason_RED_01": "die Absender-E-Mail von den bekannten Adressen abweicht",
            "ai_validation_reason_RED_02": "der Leistungszeitraum sich mit bestehenden Rechnungen überschneidet",
            "ai_validation_reason_RED_03": "Betrag oder Risiko ungewöhnlich hoch ist",
            "ai_validation_reason_RED_04": "der Betrag im Vergleich zu früheren Rechnungen stark gestiegen ist",
            "ai_validation_reason_RED_05": "Bestellung/Vertrag fehlt oder deutlich abweicht",
            "ai_validation_reason_RED_06": "die Bankverbindung von den Stammdaten abweicht",
            "ai_validation_failed": "Die Rechnung wurde nicht validiert.",
            "ai_validation_duplicate_invoice_label": "Die KI-Validierung wurde nicht fortgesetzt, weil eine Dublette gefunden wurde. Die Rechnung wurde zur manuellen Prüfung weitergeleitet.",
            "ai_validation_mandatory_fields_missing_label": "KI-Validierung fehlgeschlagen: Folgende Pflichtfelder fehlen",
            "ai_validation_client_address_mismatch_label": "Die KI-Validierung wurde nicht fortgesetzt, weil die erkannte Rechnungsanschrift von den Stammdaten des Unternehmens abweicht. Die Rechnung wurde zur manuellen Prüfung weitergeleitet.",
            "ai_validation_client_address_unrecognized_label": "Die KI-Validierung wurde nicht fortgesetzt, weil auf der Rechnung keine ausreichend erkennbare Rechnungsanschrift gefunden wurde. Die Rechnung wurde zur manuellen Prüfung weitergeleitet.",
            "magic_suggestions_label": "Automatisch ausgefüllte Felder",
            "magic_suggestions_intro_label": "Hier sind die Felder, die automatisch anhand von vorherigen Belegen dieses Lieferanten ausgefüllt wurden:",
            "ledger_account_label": "Sachkonto",
            "cost_center_label": "Kostenstelle",
            "department_label": "Abteilung",
            "cost_type_label": "Kostenart",
            "incoming_revenue_type_label": "Einnahmetyp",
            "posting_key_label": "Buchungsschlüssel",
            "tax_group_label": "Steuergruppe",
            "tax_item_group_label": "Steuer-Artikelgruppe",
            "d365_branch_label": "Niederlassung",
            "d365_employee_label": "Mitarbeitende",
            "d365_department_label": "D365 Abteilung",
            "d365_area_label": "D365 Bereich",
            "d365_sales_channel_label": "D365 Vertriebskanal",
            "d365_vehicle_label": "Fahrzeug",
            "d365_project_label": "D365 Projekt",
            "supplier_iban_label": "IBAN",
            "supplier_bic_label": "BIC",
            "supplier_bank_country_label": "Bank Land",
            "supplier_bank_account_label": "Kontonummer",
            "supplier_bank_code_label": "Bankleitzahl",
            "supplier_payment_method_label": "Zahlungsweg",
            "invoice_number_label": "Rechnungsnummer",
            "duplicate_invoice_reference_label": "Dublette",
            "procurement_number_label": "Bestellnummer",
            "invoice_date_label": "Rechnungsdatum",
            "invoice_due_date_label": "Fälligkeit",
            "supplier_label": "Lieferunternehmen",
            "client_label": "Unternehmen",
            "business_partner_label": "Geschäftspartner",
            "total_netto_label": "Gesamt-Netto",
            "total_brutto_label": "Gesamt-Brutto",
            "tax_label": "Steuersatz",
            "positions_count_label": "Position(en)",
            "recognition_applied_data_label": "Von liftbase übernommen oder abgeleitet",
            "contract_recognition_result_label": "Erkannte Vertragsdaten",
            "contract_name_label": "Vertragsbezeichnung",
            "contract_number_label": "Vertragsnummer",
            "contract_external_number_label": "Externe Vertragsnummer",
            "contract_date_label": "Vertragsdatum",
            "contract_supplier_label": "Lieferunternehmen",
            "contract_client_label": "Unternehmen",
            "contract_category_label": "Kategorie",
            "contract_payment_method_label": "Zahlungsart",
            "contract_payment_direction_label": "Verhältnis",
            "contract_payment_timing_label": "Zahlungstyp",
            "contract_term_type_label": "Laufzeittyp",
            "contract_start_date_label": "Laufzeitbeginn",
            "contract_end_date_label": "Laufzeitende",
            "contract_duration_label": "Vertragsdauer",
            "contract_renewal_type_label": "Verlängerungsart",
            "contract_renewal_duration_label": "Verlängerungsdauer",
            "contract_notice_period_label": "Kündigungsfrist",
            "contract_termination_to_label": "Kündigung zum",
            "contract_total_net_label": "Gesamt-Netto",
            "contract_total_gross_label": "Gesamt-Brutto",
            "contract_currency_label": "Währung",
            "contract_positions_label": "Positionen",
            "origin_field_client_id": "Unternehmen",
            "origin_field_supplier_id": "Lieferunternehmen",
            "origin_field_business_partner_id": "Geschäftspartner",
            "origin_field_procurement_id": "Bestellanforderung",
            "origin_field_ledger_account_id": "Sachkonto",
            "origin_field_cost_center_id": "Kostenstelle",
            "origin_field_profit_center_id": "Profitcenter",
            "origin_field_department_id": "Abteilung",
            "origin_field_posting_key_id": "Buchungsschlüssel",
            "origin_field_branch_id": "Niederlassung",
            "origin_field_employee_id": "Mitarbeiter",
            "origin_field_d365_area_id": "Bereich",
            "origin_field_d365_department_id": "D365-Abteilung",
            "origin_field_d365_labor_wert_id": "Arbeitswert",
            "origin_field_d365_project_id": "Projekt",
            "origin_field_d365_sales_channel_id": "Vertriebskanal",
            "origin_field_d365_vehicle_id": "Fahrzeug",
            "origin_field_number": "Rechnungsnummer",
            "origin_field_total_netto": "Gesamt-Netto",
            "origin_field_total_brutto": "Gesamt-Brutto",
            "origin_field_invoice_date": "Rechnungsdatum",
            "origin_field_due_date": "Fälligkeitsdatum",
            "origin_field_delivery_date": "Lieferdatum",
            "origin_field_currency": "Währung",
            "origin_field_tax": "Steuersatz",
            "origin_field_contract_id": "Vertrag",
            "origin_field_cost_type_id": "Kostenart",
            "origin_field_incoming_revenue_type_id": "Erlösart",
            "origin_field_discount_percentage": "Skonto 1 %",
            "origin_field_discount_amount": "Skonto 1 Betrag",
            "origin_field_discount_days": "Skonto 1 Tage",
            "origin_field_discount_payment_date": "Skonto 1 Datum",
            "origin_field_discount_percentage2": "Skonto 2 %",
            "origin_field_discount_amount2": "Skonto 2 Betrag",
            "origin_field_discount_days2": "Skonto 2 Tage",
            "origin_field_discount_payment_date2": "Skonto 2 Datum",
            "origin_field_lines": "Positionen",
            "origin_field_recognized_client_id": "Erkanntes Unternehmen",
            "origin_field_recognized_supplier_id": "Erkanntes Lieferunternehmen",
            "origin_field_recognized_business_partner_id": "Erkannter Geschäftspartner",
            "origin_field_supplier_iban": "IBAN des Lieferunternehmens",
            "origin_field_supplier_bic": "BIC des Lieferunternehmens",
            "origin_field_payment_bank_form_source": "Quelle der Bankdaten",
            "origin_reason_document_extracted": "direkt aus dem Beleg ausgelesen",
            "origin_reason_from_procurement": "aus der zugeordneten Bestellanforderung übernommen",
            "origin_reason_from_supplier_master_data": "aus den Lieferantenstammdaten übernommen",
            "origin_reason_from_business_partner_master_data": "aus den Geschäftspartner-Stammdaten übernommen",
            "origin_reason_invoice_number_extracted_from_document": "direkt aus dem Beleg ausgelesen",
            "origin_reason_total_netto_extracted_from_document": "direkt aus dem Beleg ausgelesen",
            "origin_reason_total_brutto_extracted_from_document": "direkt aus dem Beleg ausgelesen",
            "origin_reason_invoice_date_extracted_from_document": "direkt aus dem Beleg ausgelesen",
            "origin_reason_due_date_extracted_from_document": "direkt aus dem Beleg ausgelesen",
            "origin_reason_delivery_date_extracted_from_document": "direkt aus dem Beleg ausgelesen",
            "origin_reason_document_discount_amount_extracted_from_document": "direkt aus dem Beleg ausgelesen",
            "origin_reason_document_discount_base_amount_extracted_from_document": "direkt aus dem Beleg ausgelesen",
            "origin_reason_document_discount_percentage_extracted_from_document": "direkt aus dem Beleg ausgelesen",
            "origin_reason_document_discount_tax_percentage_extracted_from_document": "direkt aus dem Beleg ausgelesen",
            "origin_reason_client_matched_by_receiver_name_or_vat": "aus erkanntem Empfängernamen oder Umsatzsteuer-ID zugeordnet",
            "origin_reason_client_matched_by_supplier_name_or_vat": "aus erkanntem Ausstellernamen oder Umsatzsteuer-ID zugeordnet",
            "origin_reason_client_from_creator_profile": "aus dem Profil des Uploaders übernommen",
            "origin_reason_client_from_procurement": "aus der zugeordneten Bestellanforderung übernommen",
            "origin_reason_supplier_matched_by_name_vat_or_iban": "aus erkanntem Lieferantennamen, Umsatzsteuer-ID oder IBAN zugeordnet",
            "origin_reason_business_partner_matched_by_name_vat_or_iban": "aus erkanntem Gegenparteinamen, Umsatzsteuer-ID oder IBAN zugeordnet",
            "origin_reason_business_partner_matched_by_receiver_name_or_vat": "aus erkanntem Empfängernamen oder Umsatzsteuer-ID zugeordnet",
            "origin_reason_supplier_from_single_procurement_supplier": "aus dem einzigen Lieferunternehmen der zugeordneten Bestellanforderung übernommen",
            "origin_reason_procurement_matched_by_recognized_reference": "aus erkannter Bestellreferenz zugeordnet",
            "origin_reason_procurement_matched_by_invoice_similarity": "über Ähnlichkeit von Betrag, Datum und Positionen zugeordnet",
            "origin_reason_procurement_matched_by_invoice_similarity_without_supplier": "über Ähnlichkeit von Betrag, Datum und Positionen vor Lieferantenauswahl zugeordnet",
            "origin_reason_ledger_account_from_procurement": "aus der zugeordneten Bestellanforderung übernommen",
            "origin_reason_cost_center_from_procurement": "aus der zugeordneten Bestellanforderung übernommen",
            "origin_reason_cost_type_from_procurement": "aus der zugeordneten Bestellanforderung übernommen",
            "origin_reason_profit_center_from_supplier_master_data": "aus den Lieferantenstammdaten übernommen",
            "origin_reason_profit_center_from_business_partner_master_data": "aus den Geschäftspartner-Stammdaten übernommen",
            "origin_reason_department_from_procurement": "aus der zugeordneten Bestellanforderung übernommen",
            "origin_reason_branch_from_procurement": "aus der zugeordneten Bestellanforderung übernommen",
            "origin_reason_employee_from_procurement": "aus der zugeordneten Bestellanforderung übernommen",
            "origin_reason_financial_dimension_from_procurement": "aus der zugeordneten Bestellanforderung übernommen",
            "origin_reason_ledger_account_from_supplier_master_data": "aus den Lieferantenstammdaten übernommen",
            "origin_reason_cost_center_from_supplier_master_data": "aus den Lieferantenstammdaten übernommen",
            "origin_reason_ledger_account_from_business_partner_master_data": "aus den Geschäftspartner-Stammdaten übernommen",
            "origin_reason_cost_center_from_business_partner_master_data": "aus den Geschäftspartner-Stammdaten übernommen",
            "origin_reason_posting_key_from_recognized_tax": "aus dem erkannten Steuersatz abgeleitet",
            "origin_reason_supplier_iban_extracted_from_document": "direkt aus dem Beleg ausgelesen",
            "origin_reason_supplier_bic_extracted_from_document": "direkt aus dem Beleg ausgelesen",
            "origin_reason_payment_bank_data_extracted_from_document": "aus den erkannten Bankdaten des Belegs gesetzt",
            "no_data_read_label": "Keine Daten erkannt.",
            "supplier_external_id_export_validation": "Die externe ID des Lieferunternehmens muss vorkonfiguriert werden. ",
            "supplier_name_export_validation": "Der Name des Lieferunternehmens muss vorkonfiguriert werden. ",
            "recognition_was_repeated": "{user_name} hat die Belegerkennung wiederholt.",
            "bankdata_recognized_label": "Bankverbindung aus Beleg erkannt",
            "bankdata_form_source_label": "Bankverbindung im Formular – Quelle",
            "bankdata_form_changed_label": "Bankverbindung im Formular – geändert",
            "bankdata_matches_masterdata_label": "Bankverbindung im Formular stimmt mit Stammdaten überein",
            "bankdata_written_back_label": "Neue Bankverbindung in Stammdaten übernommen",
            "bank_statement_auto_paid_label": "Die Rechnung wurde durch die Analyse eines Kontoauszugs automatisch als bezahlt markiert.",
            "payment_date_label": "Zahlungsdatum",
            "payment_amount_label": "Betrag",
            "bank_statement_document_label": "Kontoauszug",
            "bank_statement_reference_label": "Verwendungszweck",
            "bank_statement_match_reason_label": "Abgleichsgrund",
            "bank_statement_match_reason_payment_reference": "Zahlungsreferenz",
            "bank_statement_match_reason_invoice_number": "Rechnungsnummer",
            "bank_statement_match_reason_invoice_number_formatted": "Interne RE-Nummer",
            "bank_statement_match_reason_procurement_number": "Bestellnummer",
            "bank_statement_match_reason_supplier_iban": "Lieferanten-IBAN",
            "bank_statement_match_reason_supplier_name": "Lieferunternehmen",
            "contract_id": "Vertrag",
            "termination_deadline": "Kündigungsstichtag",
            "recipient": "Empfänger",
            "error": "Fehler"
        }
    },
    "login": {
        "email": {
            "title": "Einloggen",
            "instructions": "Bitte geben Sie Ihre E-Mail-Adresse ein, um sich anzumelden.",
            "punchin_instructions": "Um den Vorgang abzuschließen, müssen Sie sich einloggen und den Genehmigungsprozess der Bestellung starten.",
            "tenant": "Tenant",
            "place_holder": "E-Mail-Adresse",
            "last_used_emails": "Zuletzt verwendete E-Mail-Adressen",
            "delete_last_used_emails": "\"Zuletzt verwendet\" löschen",
            "has_no_account": "Noch keinen Zugang?",
            "login_link_via_email": "Login-Link per E-Mail erhalten",
            "finish_login_title": "Login abschließen",
            "finish_login_instructions": "Sie erhalten jetzt eine E-Mail mit einem Login-Link und einem Login-Code. Klicken Sie auf den Link oder geben Sie den sechsstelligen Code ein, um den Login abzuschließen. <br><br>Die Login-E-Mail wurde an <br><b>{email}</b><br> geschickt und sollte innerhalb kurzer Zeit eintreffen. Bitte prüfen Sie ggf. Ihren Spam-Ordner.",
            "code_instructions": "Alternativ können Sie den sechsstelligen Code aus der E-Mail eingeben:",
            "code_label": "Login-Code",
            "code_digit_label": "Zeichen {index} des Codes",
            "code_invalid": "Der Code ist falsch, abgelaufen oder wurde bereits verwendet. Bitte fordern Sie eine neue Login-E-Mail an.",
            "resend_code": "Neue Login-E-Mail senden",
            "forgot_passwort": {
                "title": "Passwort vergessen",
                "login_via_email": "Login ohne Passwort",
                "instructions": "In liftbase gibt es keine Passwörter. Nutzen Sie SSO oder einen Login-Link per E-Mail, oder verwenden Sie den separaten Passkey-Button."
            },
            "no_email": "Keine E-Mail",
            "no_email_validation": "Bitte geben Sie Ihre E-Mail-Adresse ein, um sich anzumelden.",
            "check_email_title": "E-Mail prüfen",
            "check_email_message": "Bitte prüfen Sie jetzt Ihr E-Mail-Postfach und klicken Sie auf den Login-Link oder geben Sie den Login-Code ein."
        },
        "integration": {
            "title": "Integration wird verbunden",
            "instructions": "liftbase schließt die Autorisierung ab. Sie werden gleich weitergeleitet.",
            "retry": "Die Verbindung konnte nicht fortgesetzt werden. Bitte erneut versuchen.",
            "retry_button": "Erneut verbinden"
        },
        "auto": {
            "login": "Einloggen",
            "passkey_retry": "Passkey-Login fehlgeschlagen. Sie können den Passkey-Button erneut verwenden oder mit SSO oder E-Mail fortfahren.",
            "status": {
                "discover": "Verfugbare Login-Methoden werden gepruft...",
                "passkey": "Passkey-Login wird versucht...",
                "saml": "Login mit {provider} wird versucht...",
                "email": "Login-Link und Code werden per E-Mail gesendet...",
                "code": "Login-Code wird geprüft..."
            }
        },
        "or": "oder",
        "saml": {
            "login": "Mit {provider} anmelden",
            "error": "SSO-Login fehlgeschlagen. Bitte versuchen Sie es erneut.",
            "error_expired": "Die SSO-Sitzung ist abgelaufen. Bitte starten Sie den Login erneut.",
            "error_mismatch": "Das SSO-Konto passt nicht zur eingegebenen E-Mail-Adresse."
        },
        "passkey": {
            "title": "Login mit Passkey",
            "login": "Mit Passkey anmelden",
            "what_is": {
                "title": "Was sind Passkeys?",
                "first": "Login ohne auf E-Mail zu warten",
                "second": "Mit Ihrem Fingerabdruck, Ihrem Gesicht oder PIN",
                "third": "Jetzt in wenigen Schritten in Ihrem Profil einrichten"
            },
            "error": "Passkey-Login fehlgeschlagen. Versuchen Sie es erneut über den Passkey-Button oder fahren Sie mit SSO oder E-Mail fort."
        }
    },
    "languages": {
        "de": "Deutsch",
        "en": "Englisch",
        "it": "Italienisch",
        "cz": "Tschechisch",
        "sk": "Slowakisch"
    },
    "translation-component": {
        "repeated": "Sie können dieselbe Sprache nicht mehrmals auswählen.",
        "language_empty": "Sie müssen die Sprache auswählen.",
        "translation_empty": "Sie müssen den Text für diese ausgewählte Sprache eingeben.",
        "both_empty": "Sie müssen die Sprache sowie den Text eingeben.",
        "language": "Sprache",
        "no_translation": "Es gibt keinen Text für diese Sprache registriert.",
        "at_least_one_required": "Sie müssen mindestens eine Bezeichnung angeben.",
        "text_without_translation": "Ohne Übersetzung"
    },
    "mailbox": {
        "invoice_lines_group_by_tax": "Positionen nach Steuersatz gruppieren",
        "invoice_lines_group_by_tax_hint": "Wenn aktiviert, werden erkannte Positionen nach Steuersatz zusammengefasst (z. B.: Summe 19% Steuer).",
        "ai_validation_mode": "KI-Validierung",
        "ai_validation_mode_none": "Keine KI-Validierung",
        "ai_skip_to_ready_for_export": "Aktivieren und zu \"Bereit zum Export\" schieben",
        "ai_skip_to_ready_for_export_hint": "Wenn aktiviert, wird die Rechnung nach der KI-Erkennung direkt in den Status \"Bereit zum Export\" verschoben, sofern keine Genehmigungsschritte erforderlich sind.",
        "ai_validation_advisory": "Aktivieren, Status unverändert lassen",
        "ai_validation_advisory_hint": "Wenn aktiviert, prüft die KI importierte Rechnungen, schreibt das Ergebnis in die Timeline und zeigt die Score-Details an, ohne den normalen Workflow zu überspringen.",
        "description": "Postfach",
        "description_plural": "Postfächer",
        "name": "Postfach-Name",
        "username": "E-Mail-Adresse",
        "password": "Passwort",
        "host": "Host",
        "port": "Port",
        "smtp_host": "SMTP-Host",
        "smtp_port": "SMTP-Port",
        "smtp_username": "SMTP-E-Mail-Adresse / Benutzername",
        "smtp_password": "SMTP-Passwort",
        "tab_general": "Allgemein",
        "tab_import": "Rechnungsimport",
        "tab_supplier_communication": "Lieferantenkommunikation",
        "section_identity": "Postfach & Protokoll",
        "section_assignment": "Zuordnung",
        "section_incoming": "Postfachzugang",
        "section_processing": "Verarbeitung",
        "section_outgoing": "Versand",
        "protocol": "Protokoll",
        "ms365": "Microsoft 365",
        "ms365_type": "Microsoft 365 Typ",
        "ms365_enterprise_app": "MS365 Enterprise App",
        "app_tenant_id": "Tenant ID",
        "app_client_id": "Client ID",
        "client_secret": "Client Secret",
        "folder": "Ordner",
        "mailbox": "MailBox",
        "period_in_days": "Zeitraum in Tagen",
        "period_in_days_column": "Zeitraum (Tage)",
        "period_in_days_tooltip": "Alter der E-Mails in Tagen",
        "remove_mailbox_msg": "Sind Sie sicher, dass Sie das Postfach entfernen wollen?",
        "remove_mailbox_btn": "Entfernen",
        "import_invoices_automatically": "Rechnungsimport aktiv",
        "use_for_supplier_communication": "Lieferantenkommunikation aktiv",
        "use_for_supplier_communication_hint": "Wenn aktiviert, wird dieses Postfach für Antworten in der Lieferantenkommunikation verwendet.",
        "supplier_communication_bcase_types": "Dokumenttypen für Lieferantenkommunikation",
        "supplier_communication_bcase_types_hint": "Wählen Sie die Dokumenttypen aus, für die dieses Postfach in der Lieferantenkommunikation verwendet werden darf.",
        "supplier_communication_bcase_types_placeholder": "Ein oder mehrere Dokumenttypen auswählen",
        "import_mode": "Importmodus",
        "import_mode_per_attachment": "Eine Rechnung pro E-Mail Attachment erzeugen",
        "import_mode_ai_classified_per_attachment": "Nur von KI erkannte Rechnungsanhänge importieren",
        "import_mode_per_email": "Eine Rechnung pro E-Mail erzeugen",
        "last_import_errors": "Letzte Importfehler",
        "show_import_errors": "{count} Fehler anzeigen",
        "no_import_errors": "Keine Importfehler",
        "check_connection_btn": "Verbindung testen",
        "connectivity_success_msg": "Die Verbindung wurde erfolgreich hergestellt.",
        "connectivity_error_msg": "Die Verbindung konnte nicht hergestellt werden. Bitte prüfen Sie die Einstellungen.",
        "connectivity_graph_client_secret_read_access_denied_msg": "Microsoft Graph hat den Zugriff auf dieses Postfach verweigert.<br><br>Bitte prüfen Sie in Azure, ob:<ul style='margin:8px 0;padding-left:20px;text-align:left'><li>die Enterprise App die benötigten Application Permissions hat:<br><b>Mail.Read</b>, <b>Mail.ReadBasic.All</b>, <b>Mail.ReadWrite</b></li><li>Admin Consent erteilt wurde</li><li>die App auf das Postfach zugreifen darf</li></ul>",
        "connectivity_graph_client_secret_access_denied_msg": "Microsoft Graph hat den Zugriff auf dieses Postfach verweigert.<br><br>Bitte prüfen Sie in Azure, ob:<ul style='margin:8px 0;padding-left:20px;text-align:left'><li>die Enterprise App die benötigten Application Permissions hat:<br><b>Mail.Read</b>, <b>Mail.ReadBasic.All</b>, <b>Mail.ReadWrite</b>, <b>Mail.Send</b></li><li>Admin Consent erteilt wurde</li><li>die App auf das Postfach zugreifen darf</li></ul>",
        "connectivity_graph_access_denied_msg": "Microsoft Graph hat den Zugriff auf dieses Postfach verweigert. Bitte verbinden Sie das Postfach erneut und prüfen Sie, ob der Benutzer Zugriff auf dieses Postfach hat.",
        "save_and_connect_btn": "Speichern und verbinden",
        "disconnect_btn": "Verbindung trennen",
        "disconnect_success_msg": "Die Verbindung wurde erfolgreich getrennt."
    },
    "marketplace": {
        "description": "Marktplatz",
        "description_plural": "Marktplätze",
        "name": "Name / Alias",
        "provider": "Anbieter",
        "country_code": "Land",
        "url": "URL",
        "email": "E-Mail",
        "order_url": "Bestell-URL",
        "order_auth_type": "Bestell-Authentifizierung",
        "order_auth_type_none": "Keine",
        "order_auth_type_basic": "HTTP Basic Auth",
        "order_auth_username": "Username",
        "order_auth_password": "Passwort",
        "identity": "Identity",
        "secret": "Secret",
        "section_configuration": "Marktplatz-Konfiguration",
        "section_sender_identity": "Absender / Identity",
        "section_order_authentication": "Bestell-Authentifizierung",
        "new": "Neuer Marktplatz",
        "amazon_more_clients_info": "In Liftbase sind mehrere Unternehmen hinterlegt. <br>Damit Rechnungen von Amazon Business der richtigen Firma zugeordnet werden, <br>folgen Sie bitte der Anleitung unter <br><a href='https://liftbase.de/handbuch/einrichtung/amazon-business-mehrere-unternehmen.' target='_blank'>https://liftbase.de/handbuch/einrichtung/amazon-business-mehrere-unternehmen</a>."
    },
    "payment_options": {
        "label": "Zahlungsart des Lieferunternehmen",
        "AUTOMATIC_DEBIT": "SEPA-Lastschrift",
        "CREDIT_CARD": "Kreditkarte",
        "BANK_TRANSFER": "Überweisung (IBAN/BIC)",
        "BANK_TRANSFER_FOREIGN": "Überweisung Ausland (Kontonummer/BLZ)",
        "ONLINE_PAYMENT": "Online-Zahlungsdienste"
    },
    "errors": {
        "field_required": "Ein erforderliches Feld im Formular wurde nicht ausgefüllt.",
        "specific_field_required": "Das Feld {field} ist erforderlich.",
        "invalid_type": "Der angegebene Wert ist ungültig.",
        "specific_invalid_type": "Der Wert \"{value}\" ist für den Typ {type} ungültig.",
        "unique_violation": "Dieser Wert wird bereits verwendet.",
        "specific_unique_violation": "Es existiert bereits ein Eintrag mit diesem Wert im Feld {field}.",
        "foreign_key_violation": "Ungültiger Verweis auf einen anderen Eintrag.",
        "specific_foreign_key_violation": "Der Wert im Feld {field} konnte keinem bestehenden Eintrag zugeordnet werden.",
        "permission_denied": "Du hast keine Berechtigung für diese Aktion.",
        "check_violation": "Die angegebenen Daten erfüllen nicht die Systemkriterien.",
        "specific_check_violation": "Der Wert im Feld {field} erfüllt nicht die definierten Regeln.",
        "value_too_long": "Der Wert überschreitet die zulässige Länge.",
        "specific_value_too_long": "Der Wert im Feld {field} überschreitet die zulässige Länge.",
        "not_found": "Die angeforderte Ressource wurde nicht gefunden.",
        "already_exists": "Dieses Element ist bereits registriert.",
        "validation_failed": "Die Validierung der Daten ist fehlgeschlagen.",
        "unexpected": "Etwas ist schiefgelaufen. Bitte versuche es erneut oder kontaktiere den Support.",
        "specific_field_not_found": "Das Feld {field} wurde im Typ {type} nicht gefunden.",
        "expected_type_but_found": "Es wurde erwartet, dass {field} vom Typ {type} ist, aber es wurde {type_found} gefunden.",
        "duplicate_key_violation": "Der angegebene Wert existiert bereits und verstößt gegen die Einschränkung des eindeutigen Schlüssels {field}.",
        "unexpected_null_value_for_type": "Unerwarteter Nullwert für den Typ {type}.",
        "timeline_changed": "Der Beleg wurde von einer anderen Person geändert. Bitte überprüfen Sie den Beleg erneut.",
        "timeline_locked": "Der Beleg wurde soeben von {name} geändert. Bitte prüfen Sie den Beleg erneut.",
        "save_bcase_error": "Beim Speichern ist ein Fehler aufgetreten.<br>" +
            "Das Formular konnte nicht gespeichert werden.<br>" +
            "Bitte prüfen Sie die Eingaben und versuchen Sie es erneut.<br>" +
            "Falls das Problem weiterhin besteht, kontaktieren Sie bitte den Support.",
    },
    "onboarding": {
        "flow_option": "Konfiguration",
        "custom_option": "Demo-Daten individuell auswählen",
        "custom_option_description": "Wählen Sie gezielt aus, welche Beispieldaten Sie verwenden möchten – ideal, um sich mit dem System vertraut zu machen, ohne selbst Daten einzugeben.",
        "full_option": "Demo-Daten vollständig verwenden (empfohlen)",
        "full_option_description": "Nutzen Sie eine vollständige Beispieldatenkonfiguration, um das System sofort zu verwenden – ohne manuelle Einrichtung.",
        "none_option": "Ohne Demo-Daten starten",
        "none_option_description": "Beginnen Sie mit einer leeren Umgebung und konfigurieren Sie das System vollständig mit Ihren eigenen Daten.",
        "btn_start": "Los geht’s!",
        "btn_finish": "Loslegen!",
        "select_client": "Bitte wählen Sie die Unternehmen aus, mit denen Sie arbeiten möchten.",
        "select_cost_center": "Bitte wählen Sie die Kostenstellen aus, mit denen Sie arbeiten möchten.",
        "select_department": "Bitte wählen Sie die Abteilungen aus, mit denen Sie arbeiten möchten.",
        "select_ledger_account": "Bitte wählen Sie die Sachkonten aus, mit denen Sie arbeiten möchten.",
        "select_posting_key": "Bitte wählen Sie die Steuerschlüssel aus, mit denen Sie arbeiten möchten.",
        "select_supplier": "Bitte wählen Sie die Lieferunternehmen aus, mit denen Sie arbeiten möchten.",
        "select_product": "Bitte wählen Sie die Artikel aus, mit denen Sie arbeiten möchten.",
        "general_config": "Bitte geben Sie die wichtigsten Grundeinstellungen ein.",
        "profile_config": "Wichtige Profildaten eingeben – für einen schnelleren Ablauf und einfachere Bestellungen.",
    },
    "contract": {
        "description": "Vertrag",
        "name": "Bezeichnung",
        "contract_date": "Vertragsdatum",
        "contract_number_formatted": "VT-nummer",
        "contract_number": "Vertragsnummer",
        "category": "Kategorie",
        "status": "Status",
        "type": "Typ",
        "notes": "Notiz",
        "payment_method": "Zahlungsart",
        "payment_direction": "Verhältnis",
        "external_contract_number": "Externe Vertragsnummer",
        "responsible_id": "Verantwortlich",
        "recurring_invoice": "Dauerrechnung",
        "start_date": "Laufzeitbeginn",
        "end_date": "Laufzeitende",
        "duration": "Vertragsdauer",
        "min_duration": "Mindestvertragslaufzeit",
        "duration_unit_type": "Vertragsdauer",
        "renewal_type": "Verlängerungsart",
        "renewal_duration": "Verlängerungsdauer",
        "renewal_duration_unit_type": "Verlängerungsdauer",
        "notice_period": "Kündigungsfrist",
        "notice_period_unit_type": "Kündigungsfrist",
        "termination_special_right": "Sonderkündigungsrecht",
        "termination_deadline": "Kündigungsstichtag",
        "next_possible_contract_end": "Nächstmögliches Vertragsende",
        "terminated_on": "Gekündigt am",
        "termination_to": "Kündigung zum",
        "reminder_": "Erinnerungsdatum",
        "reminder_date": "Erinnerungsdatum",
        "reminder_duration": "Erinnerung vor Kündigungsstichtag",
        "reminder_unit_type": "Kündigungserinnerung Zeiteinheit",
        "term_type": "Laufzeittyp",
        "termination_to_options": {
            "none": "Kein",
            "day": "Tag",
            "year_end": "Jahresende",
            "half_year_end": "Halbjahresende",
            "quarter_end": "Quartalsende",
            "month_end": "Monatsende",
            "week_end": "Wochenende"
        },
        "duration_unit_type_options": {
            "month": "Monat(e)",
            "quarter": "Quartal",
            "semester": "Halbjahr",
            "year": "Jahr(e)",
            "week": "Woche(n)",
        },
        "renewal_type_options": {
            "auto": "Automatisch verlängert",
            "none": "Keine Verlängerung",
            "once": "Einmalige Verlängerung",
            "manual": "Manuell verlängert"
        },
        "payment_timing": "Zahlungstyp",
        "payment_timing_options": {
            "advance": "Vorschüssig",
            "postpaid": "Nachschüssig",
            "midterm": "Mittig"
        },
        "usage_type": "Rhythmus",
        "usage_type_options": {
            "usage_based": "Nach Verbrauch",
            "weekly": "Wöchentlich",
            "biweekly": "Zweiwöchentlich",
            "monthly": "Monatlich",
            "quarterly": "Vierteljährlich",
            "semiannually": "Halbjährlich",
            "yearly": "Jährlich"
        },
        "category_options": {
            "service": "Dienstleistung",
            "subscription": "Abonnement",
            "license": "Lizenz",
            "maintenance": "Wartung",
            "consulting": "Beratung",
            "leasing": "Leasing",
            "rental": "Miete",
            "support": "Support",
            "other": "Andere"
        },
        "term_type_options": {
            "fixed": "Befristet",
            "indefinite": "Unbefristet",
            "none": "ohne Laufzeit"
        },
        "payment_direction_options": {
            "incoming": "Eingehend",
            "outgoing": "Ausgehend",
            "both": "Beide Richtungen"
        },
        "ai": {
            "back": "Zurück",
            "add_title": "Neuer Vertrag",
            "add_subtitle": "Wählen Sie aus, wie Sie den Vertrag anlegen möchten.",
            "manual_title": "Vertragsdaten eingeben",
            "manual_description": "Vertrag manuell über das vorhandene Formular anlegen.",
            "ai_title": "Vertrag mit KI erkennen",
            "ai_description": "PDF hochladen und erkannte Vertragsdaten prüfen.",
            "disabled": "KI ist für diesen Mandanten deaktiviert.",
            "upload_title": "Vertrag mit KI erkennen",
            "upload_subtitle": "Laden Sie ein oder mehrere PDFs hoch. Die erkannten Daten werden neben dem Dokument zur Prüfung angezeigt.",
            "upload_info": "Vertrags-PDFs hier ablegen oder zur Auswahl anklicken.",
            "upload_hint": "Nur PDF, maximal 30 MB und 50 Seiten.",
            "file_invalid": "Nur PDF-Dateien werden unterstützt.",
            "file_too_large": "Das PDF darf nicht größer als 30 MB sein.",
            "file_size": "{size} MB",
            "select_file_preview": "Wählen Sie eine Datei aus, um die Vorschau zu sehen.",
            "start_recognition": "Verträge zur Erkennung senden",
            "recognition_failed": "Der Vertrag konnte nicht erkannt werden. Bitte versuchen Sie es erneut.",
            "document_review_hint": "Prüfen Sie die erkannten Felder vor dem Speichern.",
            "document_loading": "Dokument wird geladen…",
            "new_upload": "Neuer Upload",
            "document_preview_failed": "Die Dokumentvorschau konnte nicht geladen werden. Sie können die erkannten Daten trotzdem prüfen und speichern.",
            "client_review": "Im Dokument wird „{client}“ als Unternehmen genannt. Bitte prüfen Sie das ausgewählte Unternehmen.",
            "persistence_failed": "Der Vertrag wurde angelegt, aber PDF und KI-Analyse konnten noch nicht gespeichert werden.",
            "retry_save": "Speichern wiederholen"
        },
        "statuses": {
            "active": "Aktiv",
            "inactive": "Inaktiv",
            "declined": "Gekündigt",
            "expired": "Abgelaufen",
            "pending": "Ausstehend",
            "recognition": "Erkennung",
            "completed": "Unterzeichnet",
            "check": "Prüfung",
            "clearing": "Klärung Vertrag",
        },
        "page": {
            "new": "Neuer Vertrag",
            "create_btn": "Vertrag anlegen",
            "no_edit_permission": "Ihnen fehlt die Berechtigung zu Bearbeitung der Daten. Bitte senden Sie den Vertrag über die Aktionen zur Klärung, um Änderungen an den Daten vorzunehmen.",
            "before_leave_msg": "Ihrer Vertrag wurde nicht gespeichert. Sind Sie sicher, dass Sie die Seite verlassen wollen?",
            "no_procurement": "Für diesen Vertrag wurden noch keine Bestellungen erfasst.",
            "no_invoice": "Für diesen Vertrag wurden noch keine Rechnungen erfasst.",
            "recognition_data_title": "Belegerkennung Rohdaten",
            "no_recognition_data": "Keine Daten erkannt.",
            "no_permission_create_contract": "Sie haben keine Berechtigung, einen neuen Vertrag anzulegen.",
            "period": "Zeitraum",
            "no_invoice_for_period": "Keine Rechnungen für diesen Zeitraum vorhanden.",
            "confirm_before_leave_msg": "Ihr Vertrag wurde nicht gespeichert. Sind Sie sicher, dass Sie die Seite verlassen wollen?",
            "reminder_tooltip": "An diesem Tag erinnern wie Sie per E-Mail an diesen Vertrag.",
            "tour": {
                "description": "",
                "save_btn": "",
            },
            "validation": {
                "client_id_required": "Bitte wählen Sie ein Unternehmen aus.",
                "department_id_required": "Bitte wählen Sie eine Abteilung aus.",
                "department_id_required_client_missing": "Erst Unternehmen auswählen.",
                "cost_center_id_required": "Bitte wählen Sie eine Kostenstelle aus.",
                "cost_center_id_required_filters_missing": "Erst Unternehmen und Abteilung auswählen.",
                "cost_center_id_required_department_missing": "Erst Abteilung auswählen.",
                "cost_center_id_required_client_missing": "Erst Unternehmen auswählen.",
            }
        },

        "reminder_type": {
            "contract_end": "Vertragsende",
            "cancellation_notice": "Kündigungsfrist",
            "invoice_missing": "Fehlende Rechnung",
            "custom": "Benutzerdefiniert",
        },
        "procurements": {
            "quantity_ordered": "Bestellt",
            "quantity_received": "Erhalten"
        },
        "documents": "Unterlagen"
    },
    "contract_line": {
        "title": "Vertragsposition",
        "new_title": "Neue Vertragsposition",
        "name": "Beschreibung",
        "type": "Typ",
        "type_options": {
            "service": "Dienstleistung",
            "product": "Produkt",
            "license": "Lizenz",
            "maintenance": "Wartung",
            "subscription": "Abonnement",
            "other": "Sonstiges"
        },
        "item_number": "Pos.-Nr.",
        "quantity": "Menge",
        "total": "Summe",
        "image_url": "Bild-URL",
        "webshop_url": "Shop-URL",
        "offer_number": "Angebotsnummer",
        "offer_date": "Angebotsdatum",
        "usage_type": "Rhythmus",
        "add_btn": "Neue Position hinzufügen",
        "delete_btn": "Vertragsposition entfernen",
        "edit_btn": "Vertragsposition bearbeiten",
        "confirm_before_delete_msg": "Sind Sie sicher, dass Sie diese Position endgültig löschen wollen?",
        "confirm_before_delete_title": "Position löschen",
        "confirm_before_delete_btn": "Löschen"
    },
    "contract_term": {
        "title": "Vertragslaufzeit",
        "add_btn": "Neue Vertragslaufzeit hinzufügen",
        "delete_btn": "Vertragslaufzeit entfernen",
        "edit_btn": "Vertragslaufzeit bearbeiten",
        "section_duration": "Laufzeit",
        "section_renewal": "Verlängerung",
        "section_termination": "Kündigung",
        "section_reminder": "Erinnerung",
        "term_type_indefinite": "Unbefristete Verträge haben keine Verlängerung",
        "show_termination_fields_msg": "Verlängerte Verträge können wie folgt zum Laufzeitende gekündigt werden.",
        "do_not_show_termination_fields_msg": "Befristete Verträge haben ein festes Vertragsende und können nur mittels einer Sonderkündigung früher beendet werden.",
        "no_termination_possible_msg": "Das Vertragsende ist erreicht, eine Kündigung ist nicht möglich.",
        "no_renewal_msg": "Unbefristete Verträge haben keine Verlängerung"
    },
    "copy_contract_dialog": {
        "title": "Daten übernehmen",
        "title_select_contract": "Vertragsdaten übernehmen",
        "select_contract": "Wählen Sie einen Vertrag aus.",
        "message": "Möchten Sie einige Daten des Vetrags in diese Bestellanforderung übernehmen?",
        "overwrite_checkbox": "Die bestehenden Daten im Formular überschreiben.",
        "confirm_btn": "Bestätigen"
    },
    "custom_field": {
        "description": "Benutzerdefiniertes Feld",
        "label": "Bezeichnung",
        "type": "Feldtyp",
        "multilingual": "Mehrsprachig",
        "export_enabled": "Für Export verwenden",
        "export_field_name": "Name im {export_name} Export",
        "bcase_type": "Belegtyp",
        "bcase_types": {
            "default_value": "Standardwert",
            "required": "Pflichtfeld",
            "readonly": "Readonly",
            "show_in_search": "Suchfeld",
            "show_in_export": "Exportfeld",
            "show_in_column_dialog": "Spalten Dialog",
            "show_in_api": "API",
            "order": "Reihenfolge",
            "visible_in_step_types": "In Schritten anzeigen",
            "all_steps": "Alle Schritte",
        },
        "tooltip": "Hinweis (Tooltip)",
        "default_value": "Standardwert",
        "field_key": "API-Name",
        "type_options": {
            "text": "Text",
            "textarea": "Mehrzeiliger Text",
            "number": "Zahl",
            "currency": "Währung",
            "checkbox": "Checkbox",
            // "checkbox_group": "Mehrfachauswahl (Checkboxen)",
            "radio": "Auswahl (Radio)",
            "enum": "Auswahlliste",
            // "combi_single": "Kombiliste (einzeln)",
            // "combi_multi": "Kombiliste (mehrfach)",
            "date": "Datum",
            "html": "Rich Text (HTML)",
        },
        "page": {
            "new_title": "Neues Feld",
            "tab_general": "Allgemein",
            "tab_options": "Optionen",
            "tab_validation": "Validierung",
            "tab_labels": "Bezeichnungen",
            "tab_tooltips": "Tooltips",
            "tab_permissions": "Berechtigungsgruppen",
            "tab_clients": "Unternehmen",
            "tab_bcase_types": "Verknüpfte Belegtypen",
            "tab_bcase_description": "Zusatzfelder",
            "validation": {
                "label_required": "Bitte geben Sie eine Bezeichnung ein.",
                "field_key_required": "Bitte geben Sie einen API-Namen ein.",
                "export_field_name_required": "Bitte geben Sie einen Namen für den Export ein."
            },
            "options": {
                "repeated": "Sie können dieselbe Option nicht mehrmals eintragen.",
                "required_fields": "Sie müssen das Label sowie die Option-ID eingeben.",
                "language_empty": "Sie müssen die Sprache auswählen.",
                "at_least_one_required": "Sie müssen mindestens eine Option angeben.",
            }
        }

    },
    "custom_field_label": {
        "description": "Bezeichnungen"
    },
    "custom_field_tooltip": {
        "description": "Tooltips"
    },
    "custom_field_option": {
        "description": "Optionen"
    },
    "custom_field_bcase_type": {
        "description": "Verknüpfte Belegtypen",
        "visible_in_step_types": "In Schritten anzeigen"
    },
    "bcase_custom_field": {
        "description": "Zusatzfelder"
    }
}
